(function () {
    'use strict';

    angular
        .module('app.vehicle.details.options.items.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.options.items.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.options.items.item': {
                        templateUrl: 'app/main/vehicle/details/options/items/item/item.html',
                        controller: 'VehicleOptionItemsItemController as vm'
                    }
                },
                resolve: {
                    optionItem: function (vehicleService, $stateParams) {
                        return vehicleService.getVehicleOptionItemsItemPromise($stateParams.vin, $stateParams.category, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.options.items.item')
        .controller('VehicleOptionItemsItemController', VehicleOptionItemsItemController);

    /** @ngInject */
    function VehicleOptionItemsItemController($scope, $controller, $state, $timeout, $rootScope, $window, optionItem, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.options.items';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.optionItem = optionItem;

        console.log(vm.optionItem);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.past.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.gas.past.item', {
                url: '/:gasItem',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.gas.past.item': {
                        templateUrl: 'app/main/vehicle/gas/past/item/past-item.html',
                        controller: 'VehicleGasPastItemController as vm'
                    }
                },
                resolve: {
                    gasItem: function (vehicleService, $stateParams) {
                        return vehicleService.getGasItemPromise($stateParams.vin, $stateParams.gasItem);
                    }
                },
                params: {
                    gasItem: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.past.item')
        .controller('VehicleGasPastItemController', controller);

    /** @ngInject */
    function controller($scope, $mdToast, $controller, $timeout, gasItem, $rootScope, $window, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.gas.past';
        
        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.mEstimatedCOOperGallon = mEstimatedCOOperGallon;

        vm.gasItem = gasItem;

        console.log(vm.gasItem);

        

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.standard.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.standard.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.standard.item': {
                        templateUrl: 'app/main/vehicle/details/standard/standard-item/standard-item.html',
                        controller: 'VehicleStandardItemController as vm'
                    }
                },
                resolve: {
                    standard: function (vehicleService, $stateParams) {
                        return vehicleService.getVehicleStandardItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    itemId: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.standard.item')
        .controller('VehicleStandardItemController', VehicleStandardItemController);

    /** @ngInject */
    function VehicleStandardItemController($scope, $controller, $state, $timeout, $rootScope, $window, standard, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.standard';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.standard = standard;

        console.log(vm.standard);

        vm.attributes = standard.attributes;

    
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.attributes = $scope.searchTerm ? standard.attributes.filter(createFilterFor($scope.searchTerm)) : standard.attributes;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.safety_features.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.safety_features.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.safety_features.item': {
                        templateUrl: 'app/main/vehicle/details/safety_features/item/item.html',
                        controller: 'VehicleSafetyFeaturesItemController as vm'
                    }
                },
                resolve: {
                    item: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSASafetyFeaturesItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.safety_features.item')
        .controller('VehicleSafetyFeaturesItemController', VehicleCrashItemController);

    /** @ngInject */
    function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, item, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.safety_features';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.item = item;


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.rec_features.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.rec_features.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.rec_features.item': {
                        templateUrl: 'app/main/vehicle/details/rec_features/item/item.html',
                        controller: 'VehicleRecFeaturesItemController as vm'
                    }
                },
                resolve: {
                    item: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSARecFeaturesItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.rec_features.item')
        .controller('VehicleRecFeaturesItemController', VehicleCrashItemController);

    /** @ngInject */
    function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, item, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.rec_features';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.item = item;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.options.items', [
            'app.vehicle.details.options.items.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.options.items', {
                url: '/:category',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.options.items': {
                        templateUrl: 'app/main/vehicle/details/options/items/items.html',
                        controller: 'VehicleOptionItemsController as vm'
                    }
                },
                resolve: {
                    optionItems: function (vehicleService, $stateParams) {
                        return vehicleService.getVehicleOptionItemsPromise($stateParams.vin, $stateParams.category);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.options.items')
        .controller('VehicleOptionItemsController', VehicleOptionItemsController);

    /** @ngInject */
    function VehicleOptionItemsController($scope, $controller, $state, $timeout, $rootScope, $window, optionItems, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.options';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.option = optionItems;

        vm.optionItems = optionItems.options;


        console.log(vm.optionItems);

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.optionItems = $scope.searchTerm ? optionItems.options.filter(createFilterFor($scope.searchTerm)) : optionItems.options;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToOptionItem = function (optionItem) {
            $timeout(function () {
                $state.go('app.vehicle.details.options.items.item', { itemId: optionItem.id });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.mancomms.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.mancomms.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.mancomms.item': {
                        templateUrl: 'app/main/vehicle/details/man_comms/item/item.html',
                        controller: 'VehicleManCommItemController as vm'
                    }
                },
                resolve: {
                    commItem: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSAManComItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.mancomms.item')
        .controller('VehicleManCommItemController', VehicleOptionItemsItemController);

    /** @ngInject */
    function VehicleOptionItemsItemController($scope, $controller, $state, $timeout, $rootScope, $window, commItem, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.mancomms';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.commItem = commItem;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.investigations.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.investigations.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.investigations.item': {
                        templateUrl: 'app/main/vehicle/details/investigations/item/item.html',
                        controller: 'VehicleInvestigationsItemController as vm'
                    }
                },
                resolve: {
                    investigationsItem: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSAInvestigationsItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.investigations.item')
        .controller('VehicleInvestigationsItemController', VehicleCrashItemController);

    /** @ngInject */
    function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, investigationsItem, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.investigations';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.investigationsItem = investigationsItem;

        vm.ratingArray = function(item){
            var arrayOf = [];
            for (var i = 1; i <= 5; i++){
                arrayOf.push(i <= item.rating);
            }
            return arrayOf;
        }

        vm.goToRecall = function(item){
            $state.go('app.vehicle.recalls.recall', {recallId : item.nhtsaCampaignNumber})
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.crash.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.crash.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.crash.item': {
                        templateUrl: 'app/main/vehicle/details/crash/item/item.html',
                        controller: 'VehicleCrashItemController as vm'
                    }
                },
                resolve: {
                    crashRating: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSACrashItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.crash.item')
        .controller('VehicleCrashItemController', VehicleCrashItemController);

    /** @ngInject */
    function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, crashRating, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.crash';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.crashRating = crashRating;

        vm.ratingArray = function(item){
            var arrayOf = [];
            for (var i = 1; i <= 5; i++){
                arrayOf.push(i <= item.rating);
            }
            return arrayOf;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.complaints.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.complaints.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.complaints.item': {
                        templateUrl: 'app/main/vehicle/details/complaints/item/item.html',
                        controller: 'VehicleComplaintItemController as vm'
                    }
                },
                resolve: {
                    complaintItem: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSAComplaintItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.complaints.item')
        .controller('VehicleComplaintItemController', VehicleOptionItemsItemController);

    /** @ngInject */
    function VehicleOptionItemsItemController($scope, $controller, $state, $timeout, $rootScope, $window, complaintItem, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.complaints';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.complaintItem = complaintItem;

        console.log(vm.complaintItem);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.bulletins.item', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.bulletins.item', {
                url: '/:itemId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.bulletins.item': {
                        templateUrl: 'app/main/vehicle/details/bulletins/item/item.html',
                        controller: 'VehicleBulletinsItemController as vm'
                    }
                },
                resolve: {
                    item: function (vehicleService, $stateParams) {
                        return vehicleService.getBulletinsItemPromise($stateParams.vin, $stateParams.itemId);
                    }
                },
                params: {
                    vin: null,
                    animate: null,
                    category : null,
                    itemId : null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.bulletins.item')
        .controller('VehicleBulletinsItemController', VehicleCrashItemController);

    /** @ngInject */
    function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, item, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details.bulletins';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.item = item;

        console.log(item);

        vm.compDescriptions = vm.item.componentDescription.split(':');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.recalls.recall', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.recalls.recall', {
                url: '/:recallId',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.recalls.recall': {
                        templateUrl: 'app/main/vehicle/recalls/recall/recall.html',
                        controller: 'VehicleRecallsRecallController as vm'
                    }
                },
                resolve: {
                    recallItem: function (vehicleService, $stateParams) {
                        return vehicleService.getRecallItemPromise($stateParams.vin, $stateParams.recallId);
                    }
                },
                params: {
                    vin: null,
                    recallId: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.recalls.recall')
        .controller('VehicleRecallsRecallController', controller);

    /** @ngInject */
    function controller($scope, $controller, $timeout, $rootScope, $window, recallItem, vehicleService, $http) {

        $scope.noHeroTransitionBack = true;
        $scope.forceOverrideState = 'app.vehicle.recalls';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.recallItem = recallItem;

        var tempItems = [];

        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.recallStatus, index: 0 });
        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.subject, index: 1 });
        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.summary, index: 2 });
        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.reportReceivedDate, index: 3 });
        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.consequence, index: 4 });
        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.correctiveAction, index: 5 });
        tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.nhtsaCampaignNumber, index: 6 });
        //  for (var i = 0; i < vm.recallItem.associatedProducts.length; i++) {
        //       tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.associatedProducts[i], index: 12 + i });
        //   }
        //   for (var i = 0; i < vm.recallItem.associatedDocuments.length; i++) {
        //       tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.associatedDocuments[i], index: 300 + i });
        //   }

        vm.items = tempItems;

       //**// console.log(vm.recallItem);

         vm.getImage = function (isTrue) {
            return isTrue ? "assets/images/cartraxx/caution.svg" : "assets/images/cartraxx/checked.svg";
        }

        vm.recallsTitle = function (recall) {
            return recall.openRecallsCount > 0 ? recall.openRecallsCount + ' Open Recalls' : 'No Open Recalls';
        }

           function textColor(isTrue) {
            if (!isTrue) return { color: 'green' };
            return { color: '#FF5722' };
        }

        vm.textColor = textColor;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.maintenance.item', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, ChartJsProvider) {
        // State
        $stateProvider
            .state('app.vehicle.maintenance.item', {
                url: '/:maintenanceItem',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.maintenance.item': {
                        templateUrl: 'app/main/vehicle/maintenance/item/item.html',
                        controller: 'VehicleMaintenanceItemController as vm'
                    }
                },
                resolve: {
                    maintenanceItem: function (vehicleService, $stateParams) {
                        return vehicleService.getMaintenanceItemPromise($stateParams.vin, $stateParams.maintenanceItem);
                    },
                    user : function (firebaseService){
                        return firebaseService.getUserDataPromise();
                    }
                },
                params: {
                    maintenanceItem: null
                }
            });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.maintenance.item')
        .controller('VehicleMaintenanceItemController', controller);

    /** @ngInject */
    function controller($scope, $state, $q, $controller, $timeout, $rootScope, $window, maintenanceItem, user, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.maintenance';

        angular.extend(this, $controller('VehicleMaintenanceController', { $scope: $scope, vehicle: mVehicle }));

        var vm = this;

        vm.mi = maintenanceItem;

        $timeout(function () {
            vm.animate = true;
        }, 600);

      //**//  console.log(vm.mi);

        vm.getWidth = function () {
            return {
                width: ((vm.labor / (vm.labor + vm.parts)) * 100) + '%'
            }
        }

        vm.variable = user.global.laborCost.defaultVariable;

        vm.laborCost = typeof user.settings.laborCost === "number" ? user.settings.laborCost : user.global.laborCost.default;

        vm.labor = vm.mi.laborUnits > 0 ? Math.floor(vm.mi.laborUnits * vm.laborCost) : 0;
        vm.parts = vm.mi.partUnits > 0 && vm.mi.partCostPerUnit > 0 ? Math.floor(vm.mi.partUnits * vm.mi.partCostPerUnit) : 0;


        if (vm.mi.laborUnits > 0 && vm.mi.partUnits > 0 && vm.mi.partCostPerUnit > 0) {
            $scope.labels = ["Labor ($)", "Parts ($)"];
            $scope.data = [Math.floor(vm.mi.laborUnits * vm.laborCost), Math.floor(vm.mi.partUnits * vm.mi.partCostPerUnit)];
            $scope.colors = ['#03A9F4', '#D50000', '#673AB7', '#4CAF50'];

        }

        vm.getCost = function (variable) {
            return vm.getLabor(variable) + vm.parts;
        }

        vm.getLabor = function (variable) {
            return (vm.mi.laborUnits * (vm.laborCost + (vm.variable * variable)));
        }

        vm.inputMaintenance = function () {
            $rootScope.inputMaintenanceActionItem = vm.mi;
            $timeout(function () {
                $state.go('app.vehicle.maintenance.input');
            });
        }

        vm.hasCompletedMaintenance = function () {
            for (var key in vm.mi.completedMaintenance) {
                return true;
            }
            return false;
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.maintenance.input', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.maintenance.input', {
                url: '/Input',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.maintenance.input': {
                        templateUrl: 'app/main/vehicle/maintenance/input-maintenance/input-maintenance.html',
                        controller: 'VehicleInputMaintenanceController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.maintenance.input')
        .controller('VehicleInputMaintenanceController', controller);

    /** @ngInject */
    function controller($scope, $q, $mdToast, $controller, $timeout, $rootScope, $window, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.maintenance';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        $scope.m = {};

        $scope.vehicle = mVehicle;

        if ($rootScope.inputMaintenanceActionItem) {
            $scope.m.actionItem = $rootScope.inputMaintenanceActionItem;
            $rootScope.inputMaintenanceActionItem = null;
        }

        $scope.m.dateCompleted = new Date();
        $scope.m.odometerAtCompletion = vm.vehicle.odometer;

        $scope.mItems = $scope.vs.getMaintenanceArray();

        vm.selectedItemChange = function (item) {
            //   console.log($scope.m.maintenanceItem);
            //  console.log(item);
        }

        vm.querySearch = function (text) {
            var results = text ? $scope.mItems.filter(createFilterFor(text)) : $scope.mItems;
            var deferred = $q.defer();
            deferred.resolve(results);
            return deferred.promise;
        }

        /**
   * Create filter function for a query string
   */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                var searchThis = mItem.action.toLowerCase() + " " + mItem.item.toLowerCase();
                return (searchThis.indexOf(lowercaseQuery) > -1);
            };

        }

        vm.submit = function () {
            if ($scope.vUpdates.$invalid) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Check Errors')
                        .position('bottom')
                        .hideDelay(3000)
                );
                return;
            }


            vm.loading = true;

            var sendThis = {};

            angular.copy($scope.m, sendThis);

            sendThis.actionItem = sendThis.actionItem.action + " " + sendThis.actionItem.item;

            sendThis.dateCompleted = new Date(sendThis.dateCompleted).toISOString();

            if (sendThis.odometerAtCompletion > mVehicle.odometer) {
                sendThis.updateToThisOdometer = true;
            }

            vehicleService.addMaintanceRepair(sendThis, function (result) {
                vm.loading = false;
                vm.goBack();
            }, function (failed) {
                vm.loading = false;

                if (failed.status === 400 && failed.data.code === 34) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(failed.data.message)
                            .position('bottom')
                            .hideDelay(3000)
                    );
                }

            });

        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.image.editor', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.vehicle.image.editor', {
            url: '/Edit',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.vehicle.image.editor': {
                    templateUrl: 'app/main/vehicle/image/editor/image-editor.html',
                    controller: 'VehicleImageEditorController as vm'
                }
            },
            resolve: {
                vehicle: function (vehicleService, $stateParams) {
                    return vehicleService.getVehiclePromise($stateParams.vin);
                }
            },
            params: {
                vin: null
            }

        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.image.editor')
        .controller('VehicleImageEditorController', VehicleImageEditorController);

    /** @ngInject */
    function VehicleImageEditorController($scope, $rootScope, $controller, $mdBottomSheet, $state, vehicleService, $window, $http) {

        $scope.forceOverrideState = 'app.vehicle.image';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.vehicle = mVehicle;

        $scope.myImage = $rootScope.tempGalleryImage;
        $scope.myCroppedImage = '';

        scope.$on('$destroy', function () {
            $scope.myImage = null;
            $rootScope.tempGalleryImage = null;
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.view', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.gas.view', {
                url: '/View',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.gas.view': {
                        templateUrl: 'app/main/vehicle/gas/view/gas-overview.html',
                        controller: 'ViewGasController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.view')
        .controller('ViewGasController', controller);

    /** @ngInject */
    function controller($scope, $mdToast, $controller, $state, $timeout, $rootScope, $window, vehicleService, $http) {

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        var temp = [];

        vm.whatNowList = [
        ]

        for (var key in mVehicle.gasJson) {
            temp.push(mVehicle.gasJson[key]);
        }

        var gasOptions = [
            {
                title: "Control Speed",
                description: "Closely monitor your accelartion and speed - this can have a 15% effect"
            },
            {
                title: "Clean fuel injectors",
                description: "Clean injectors give a more even fuel-air mix which results in a more predictable burn in the cylinder"
            },
            {
                title: "Windows up / AC off",
                description: "By keeping your windows up and the AC off, you reduce the strain on your engine and maintain the aerodynamics of your car"
            },
            {
                title: "Legally draft when possible",
                description: "If you can find an opportunity to legally draft the vehicle in front of you, take it.  Dont be stupid and stay safe!"
            },
            {
                title: "Reduce weight",
                description: "Start with your trunk and remove things that you never need, less weight = better MPG"
            },
            {
                title: "Oxygen Sensor",
                description: "It monitors exhaust flow, which adjusts the fuel injection level. When it is faulty, the data isn't accurate"
            }
        ];

        function init() {
            var tempArray = vehicleService.getMaintenanceArray('percentage');

            function createJson(json, desc) {
                return {
                    title: json.action + " " + json.item,
                    description: desc
                }
            }

            for (var i = 0; i < tempArray.length; i++) {
                if (vm.whatNowList.length >= 3) return;
                if (tempArray[i].duePercentage < .75) continue;
                var action = tempArray[i].action.toLowerCase();
                var item = tempArray[i].item.toLowerCase();
                if (action.indexOf("change") > -1 && item.indexOf("oil") > -1) vm.whatNowList.push(createJson(tempArray[i], "It has a minimal effect, but a reliable engine is key to a lower MPG."));
                if (action.indexOf("inspect") > -1 && item.indexOf("tire") > -1) vm.whatNowList.push(createJson(tempArray[i], "Tire pressure and tread can effect fuel efficiency by 20%!"));
                if (action.indexOf("replace") > -1 && item.indexOf("spark") > -1) vm.whatNowList.push(createJson(tempArray[i], "Fresh plugs that aren't covered in carbon desposits will certainly help."));
                if (action.indexOf("replace") > -1 && item.indexOf("air filter") === 0) vm.whatNowList.push(createJson(tempArray[i], "For a $14 investment you can see a 13% improvement"));
            }

            gasOptions.shuffle();

            for (var i = 0; i < 3 - vm.whatNowList.length; i++) {
                vm.whatNowList.push(gasOptions[i]);
            }

        }

        init();

        vm.gasItems = [];

        vm.test = [
            1,
            2,
            3,
            4,
            11,
            21,
            31,
            41,
            12,
            22,
            32,
            42,
            13,
            23,
            33,
            43
        ]

        vm.maxMPG = 0;

        for (var key in mVehicle.gasJson) {
            if (!mVehicle.gasJson[key].estimatedMPG) continue;
            if (mVehicle.gasJson[key].estimatedMPG > vm.maxMPG) vm.maxMPG = mVehicle.gasJson[key].estimatedMPG;
            vm.gasItems.push(mVehicle.gasJson[key]);
        }

        vm.getHeightItem = function (item) {
            return { height: 100 - (((item.estimatedMPG / vm.maxMPG)) * 100) + "%" }
        }

        vm.goToGasItem = function (key) {
            $state.go('app.vehicle.gas.past.item', { gasItem: key, vin: $state.params.vin });
        }

        var jsQueryContainer = document.querySelector('#virtual-container');

        var vContainer = angular.element(jsQueryContainer);

        var scrollerJQuery = jsQueryContainer.getElementsByClassName("md-virtual-repeat-scroller");

        var scroller = angular.element(scrollerJQuery);

        var offseterJQuery = scrollerJQuery[0].getElementsByClassName("md-virtual-repeat-offsetter");

        var offsetter = angular.element(offseterJQuery[0]);

        $scope.$watch(function () {
            var items = jsQueryContainer.querySelectorAll('*[id^="virtual-container_"]');
            if (items.length === 0) return;
            scroller.scrollLeft = scroller.scrollWidth;
        });

        /**
         
                scroller.bind("scroll", function () {
                    checkForMiddle();
                });
        
                vm.size = {
                    width: 0,
                    height: 0
                };
        
                $scope.$watch(function () {
                    vm.size = {
                        width: vContainer.width(),
                        height: vContainer.height()
                    };
                    checkForMiddle();
                });
        
              
                function checkForMiddle() {
                    var items = jsQueryContainer.querySelectorAll('*[id^="virtual-container_"]');
                    if (items.length === 0) return;
                    var counter = 0;
                    var test = angular.element(items[3]);
                    var bodyRect = document.body.getBoundingClientRect();
                    var elemRect = offseterJQuery[0].getBoundingClientRect();    
                    var offset = elemRect.left - bodyRect.left;
                    while (((counter + 1) * 50) < ((vm.size.width / 2) - offset)) {
                        counter++;
                    }
                    console.log(counter);
                    $scope.middleItem = items[counter].id.replace("virtual-container_", "");
                    if(!$scope.$$phase) {
                        $scope.$digest();
                      }
                }
                 */

        vm.estimatedImage;

        switch (mVehicle.estimatedMPG.trending) {
            case "DOWN":
                vm.estimatedImage = "assets/images/cartraxx/down_arrow_orange.svg";
            case "UP":
                vm.estimatedImage = "assets/images/cartraxx/up_arrow_green.svg";
            default:
                vm.estimatedImage = "assets/images/cartraxx/steady_arrow_blue.svg";
        }


        vm.getClassCircle = function (index) {
            switch (index + 1) {
                case 1:
                    return "circle-blue";
                case 2:
                    return "circle-red";
                case 3:
                    return "circle-purple";
            }
        }

        vm.data = temp;

        vm.pastFillUps = function () {
            if (mVehicle.gasJson) for (var key in mVehicle.gasJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.gas.past');
                });
                return;
            }

            $mdToast.show(
                $mdToast.simple()
                    .textContent('No Past Fill-Ups')
                    .position('bottom')
                    .hideDelay(3000)
            );

        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.past', [
            'app.vehicle.gas.past.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.gas.past', {
                url: '/Past',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.gas.past': {
                        templateUrl: 'app/main/vehicle/gas/past/past.html',
                        controller: 'VehicleGasPastController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.past')
        .controller('VehicleGasPastController', controller)
        .controller('DateFilterController', dateFilterController);

    /** @ngInject */
    function dateFilterController($scope, $mdToast, $controller, $mdDialog, dateAfter, dateBefore, $state, $timeout, $rootScope, $window, vehicleService, $http) {
        var vm = this;
        vm.dateAfter = dateAfter;
        vm.dateBefore = dateBefore;

        vm.today = new Date();

        vm.today.setHours(23, 59, 59);

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.ok = function () {
            if (vm.vUpdates.$invalid) return;


            var fail = false;

            if (vm.dateBefore > vm.today) {
                console.log("too late");
                vm.vUpdates.$invalid = true;
                vm.vUpdates.dateBefore.$invalid = true;
                vm.vUpdates.dateBefore.$error.maxdate = true;
                fail = true;
            }
            if (vm.dateAfter > vm.today) {
                vm.vUpdates.$invalid = true;
                vm.vUpdates.dateAfter.$invalid = true;
                vm.vUpdates.dateAfter.$error.maxdate = true;
                fail = true;
            }
            if (fail) return;
            if (vm.dateBefore < vm.dateAfter) {
                vm.vUpdates.$invalid = true;
                vm.vUpdates.dateBefore.$invalid = true;
                vm.vUpdates.dateBefore.$error.mindate = true;
                return;
            }
            vm.dateBefore.setHours(23, 59, 59);
            $mdDialog.hide({ dateAfter: vm.dateAfter, dateBefore: vm.dateBefore });
        }
    }

    /** @ngInject */
    function controller($scope, $mdToast, $controller, $mdDialog, $state, $timeout, $rootScope, $window, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        var temp = [];
        for (var key in mVehicle.gasJson) {
            temp.push(mVehicle.gasJson[key]);
        }

        vm.dateItems = temp;

        vm.gasItems = temp;

        var tempDate = new Date(vm.gasItems[0].date);
        console.log(tempDate);
        console.log(tempDate.getDate());
        vm.dateAfter = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
        vm.dateBefore = new Date();

        vm.goToGasItem = function (key) {
            $state.go('app.vehicle.gas.past.item', { gasItem: key, vin: $state.params.vin });
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (item === null) continue;
                    if (typeof item === "undefined") continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        vm.filterDates = function (ev) {

            $mdDialog.show({
                controller: 'DateFilterController as vm',
                templateUrl: 'app/main/vehicle/gas/past/past-filter-dates.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    dateAfter: vm.dateAfter,
                    dateBefore: vm.dateBefore
                }
            })
                .then(function (ranges) {

                    console.log(ranges);

                    vm.dateAfter = ranges.dateAfter;
                    vm.dateBefore = ranges.dateBefore;

                    var tempRange = [];

                    for (var i = 0; i < temp.length; i++) {
                        var date = new Date(temp[i].date);
                        if (date > vm.dateBefore || date < vm.dateAfter) continue;
                        tempRange.push(temp[i]);
                    }

                    vm.dateItems = tempRange;

                    searchTermChanged();

                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        }

        function searchTermChanged() {
            vm.gasItems = $scope.searchTerm ? vm.dateItems.filter(createFilterFor($scope.searchTerm)) : vm.dateItems;
            console.log(vm.gasItems);
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        }

        $scope.$watch('searchTerm', searchTermChanged);

        vm.maxMPG = 0;

        for (var key in mVehicle.gasJson) {
            if (!mVehicle.gasJson[key].estimatedMPG) continue;
            if (mVehicle.gasJson[key].estimatedMPG > vm.maxMPG) vm.maxMPG = mVehicle.gasJson[key].estimatedMPG;
        }

        vm.getWidthMPG = function (item) {
            if (!item || !item.estimatedMPG) return { width: '0%' };
            return { width: "calc(" + (((item.estimatedMPG / vm.maxMPG)) * 100) + "% - 15px)" }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.input', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.gas.input', {
                url: '/Input',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.gas.input': {
                        templateUrl: 'app/main/vehicle/gas/input-gas/input-gas.html',
                        controller: 'VehicleInputGasController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas.input')
        .controller('VehicleInputGasController', controller);

    /** @ngInject */
    function controller($scope, $mdToast, $controller, $state, $timeout, $rootScope, $window, vehicleService, $http) {

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        $scope.fuel = {};

        $scope.vehicle = mVehicle;

        var emptyLastFillup = { odometer: 0 };

        $scope.fuel.odometer = mVehicle.odometer > 0 ? mVehicle.odometer : null;

        var gasJson = mVehicle.gasJson;
        if (!gasJson) gasJson = {};

        $scope.fuel.pricePerGallon = null;
        $scope.fuel.totalGallons = null;
        $scope.fuel.date = new Date();

        vm.calculatedMPG = 0;

        vm.getLatestGasOdometer = function (odometer) {
            if (!odometer) return 0;
            var topNumObj = emptyLastFillup;
            for (var key in gasJson) {
                var temp = gasJson[key];
                if (odometer < temp.odometer) continue;
                if (temp.odometer >= topNumObj.odometer) {
                    topNumObj = temp;
                    topNumObj.key = key;
                }
            }
            return topNumObj;
        }

        function updateLastFillup() {
            vm.lastGasOdometer = vm.getLatestGasOdometer($scope.fuel.odometer ? $scope.fuel.odometer : 0);
            vm.lastFillup = vm.lastGasOdometer;
            if ((!vm.lastFillup || !(vm.lastFillup.odometer > 0)) && $scope.selectedLastFillup === "LAST_FILLUP") {
                $scope.selectedLastFillup = undefined;
            }
            calcMPG();
        }

        vm.getLastOdometer = function () {
            switch ($scope.selectedLastFillup) {
                case "LAST_FILLUP":
                    return vm.lastFillup.odometer;
                case "LAST_ODOMETER":
                    return vm.lastOdometer;
                default:
                    return -1;
            }
        }

        vm.radioGroupChanged = function () {
            $scope.fuel.lastOdometer = vm.getLastOdometer();
        }

        vm.editing = null;

        $scope.$watch(function () { return vm.editing; }, function () {
            if (vm.editing) {
                $timeout(function () { vm.editing = false; });
            }
        }, true);

        var touchedOrder = {};

        $scope.$watch(function () { return $scope.fuel.pricePerGallon; }, function (item) {
            if (vm.editing && vm.editing !== "pricePerGallon") return;
            console.log(item);
            if (!($scope.fuel.pricePerGallon > 0)) {
                delete vm.focused.pricePerGallon;
                return;
            }
            else if (isActive('pricePerGallon')) vm.focused.pricePerGallon = true;
            watchCost();
        }, true);

        $scope.$watch(function () { return $scope.fuel.totalGallons; }, function (item) {
            if (vm.editing && vm.editing !== "totalGallons") return;
            if (!($scope.fuel.totalGallons > 0)) {
                delete vm.focused.totalGallons;
                calcMPG();
                return;
            }
            else if (isActive('totalGallons')) vm.focused.totalGallons = true;
            watchCost();
            calcMPG();
        }, true);

        $scope.$watch(function () { return $scope.fuel.totalCost; }, function (item) {
            if (vm.editing && vm.editing !== "totalCost") return;
            if (!($scope.fuel.totalCost > 0)) {
                delete vm.focused.totalCost;
                return;
            }
            else if (isActive('totalCost')) vm.focused.totalCost = true;
            watchCost();
        }, true);

        function isActive(name) {
            return (document.activeElement && document.activeElement.name && document.activeElement.name === name);
        }

        vm.focused = {};

        function watchCost(changing) {
            if (vm.focused.pricePerGallon && vm.focused.totalGallons && vm.focused.totalCost) return;
            if (vm.focused.pricePerGallon && vm.focused.totalGallons) {
                $scope.fuel.totalCost = Number(($scope.fuel.totalGallons * $scope.fuel.pricePerGallon).formatMoney());
            } else if (vm.focused.totalGallons && vm.focused.totalCost) {
                $scope.fuel.pricePerGallon = Number(($scope.fuel.totalCost / $scope.fuel.totalGallons).formatMoney());
            } else if (vm.focused.totalCost && vm.focused.pricePerGallon) {
                $scope.fuel.totalGallons = Number(($scope.fuel.totalCost / $scope.fuel.pricePerGallon).toFixed(2));
            }

        }

        function calcMPG() {
            if (!($scope.fuel.totalGallons > 0) || !($scope.fuel.odometer > 0) || !(vm.getLastOdometer() > 0) || ($scope.fuel.odometer <= vm.getLastOdometer())) {
                vm.calculatedMPG = 0;
            } else {
                vm.calculatedMPG = ($scope.fuel.odometer - vm.getLastOdometer()) / $scope.fuel.totalGallons;
            }
        }

        $scope.$watch(function () { return $scope.fuel.odometer; }, updateLastFillup, true);
        $scope.$watch(function () { return vm.lastOdometer; }, calcMPG, true);
        $scope.$watch(function () { return $scope.selectedLastFillup; }, calcMPG, true);
        $scope.$watch(function () { return vm.lastFillup.odometer; }, calcMPG, true);

        vm.save = function () {
            $scope.attemptedSave = true;
            if (vm.vUpdates.$invalid) return;

            if ($scope.fuel.odometer === vm.getLastOdometer()) return;

            vm.loading = true;

            vehicleService.updateGas($scope.fuel, function (success) {
                $state.go('app.vehicle');
            }, function (error) {
                vm.loading = false;

                if (error.status === 400) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(error.data.message)
                            .position('bottom')
                            .hideDelay(3000)
                    );
                }

            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.standard', [
            'app.vehicle.details.standard.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.standard', {
                url: '/Standard',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.standard': {
                        templateUrl: 'app/main/vehicle/details/standard/standard.html',
                        controller: 'VehicleStandardController as vm'
                    }
                },
                resolve: {
                    standard: function (vehicleService, $stateParams) {
                        return vehicleService.getVehicleStandardPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.standard')
        .controller('VehicleStandardController', VehicleStandardController);

    /** @ngInject */
    function VehicleStandardController($scope, $controller, $mdToast, $state, $timeout, $rootScope, $window, standard, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.standard = standard;


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        vm.goToStandardItem = function (item) {
            if (item.attributes) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.standard.item', {itemId : item.id});
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Attributes')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.standard = $scope.searchTerm ? standard.filter(createFilterFor($scope.searchTerm)) : standard;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.specs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.specs', {
                url: '/Specs',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.specs': {
                        templateUrl: 'app/main/vehicle/details/specs/specs.html',
                        controller: 'VehicleSpecsController as vm'
                    }
                },
                resolve: {
                    specs: function (vehicleService, $stateParams) {
                        return vehicleService.getVehicleSpecsPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.specs')
        .controller('VehicleSpecsController', VehicleSpecsController);

    /** @ngInject */
    function VehicleSpecsController($scope, $controller, $state, $timeout, $rootScope, $window, specs, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.specs = specs;

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function(item){
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.specs = $scope.searchTerm ? specs.filter(createFilterFor($scope.searchTerm)) : specs;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.safety_features', [
            'app.vehicle.details.safety_features.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.safety_features', {
                url: '/SafetyFeatures',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.safety_features': {
                        templateUrl: 'app/main/vehicle/details/safety_features/safety_features.html',
                        controller: 'VehicleSafetyFeaturesController as vm'
                    }
                },
                resolve: {
                    items: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSASafetyFeaturesPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.safety_features')
        .controller('VehicleSafetyFeaturesController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, items, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.items = items;


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.items = $scope.searchTerm ? items.filter(createFilterFor($scope.searchTerm)) : items;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToItem = function (item) {
            $timeout(function () {
                $state.go('app.vehicle.details.safety_features.item', { itemId: item });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.rec_features', [
            'app.vehicle.details.rec_features.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.rec_features', {
                url: '/RecommendedFeatures',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.rec_features': {
                        templateUrl: 'app/main/vehicle/details/rec_features/rec_features.html',
                        controller: 'VehicleRecFeaturesController as vm'
                    }
                },
                resolve: {
                    items: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSARecFeaturesPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });
 

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.rec_features')
        .controller('VehicleRecFeaturesController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, items, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.items = items;


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.items = $scope.searchTerm ? items.filter(createFilterFor($scope.searchTerm)) : items;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToItem = function (item) {
            $timeout(function () {
                $state.go('app.vehicle.details.rec_features.item', { itemId: item });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.options', [
            'app.vehicle.details.options.items'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.options', {
                url: '/Options',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.options': {
                        templateUrl: 'app/main/vehicle/details/options/options.html',
                        controller: 'VehicleOptionsController as vm'
                    }
                },
                resolve: {
                    options: function (vehicleService, $stateParams) {
                        return vehicleService.getVehicleOptionsPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.options')
        .controller('VehicleOptionsController', VehicleOptionsController);

    /** @ngInject */
    function VehicleOptionsController($scope, $controller, $state, $timeout, $rootScope, $window, options, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.options = options;

        console.log(vm.options);

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.options = $scope.searchTerm ? options.filter(createFilterFor($scope.searchTerm)) : options;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToOptions = function (option) {
            if (option.options.length > 0) {
                $timeout(function () {
                    $state.go('app.vehicle.details.options.items', {category : option.category});
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Options')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.mancomms', [
            'app.vehicle.details.mancomms.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.mancomms', {
                url: '/ManComms',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.mancomms': {
                        templateUrl: 'app/main/vehicle/details/man_comms/man_comms.html',
                        controller: 'VehicleManCommsController as vm'
                    }
                },
                resolve: {
                    manComms: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSAManComPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.mancomms')
        .controller('VehicleManCommsController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, manComms, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.manComms = manComms;

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.manComms = $scope.searchTerm ? manComms.filter(createFilterFor($scope.searchTerm)) : manComms;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToComplaintItem = function (optionItem) {
            $timeout(function () {
                $state.go('app.vehicle.details.mancomms.item', { itemId: optionItem.nhtsaIdNumber });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.investigations', [
            'app.vehicle.details.investigations.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.investigations', {
                url: '/Investigations',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.investigations': {
                        templateUrl: 'app/main/vehicle/details/investigations/investigations.html',
                        controller: 'VehicleInvestigationsController as vm'
                    }
                },
                resolve: {
                    investigations: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSAInvestigationsPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.investigations')
        .controller('VehicleInvestigationsController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, investigations, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.investigations = investigations;


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.investigations = $scope.searchTerm ? investigations.filter(createFilterFor($scope.searchTerm)) : investigations;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToComplaintItem = function (optionItem) {
            $timeout(function () {
                $state.go('app.vehicle.details.investigations.item', { itemId: optionItem.nhtsaActionNumber });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.crash', [
            'app.vehicle.details.crash.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.crash', {
                url: '/CrashTests',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.crash': {
                        templateUrl: 'app/main/vehicle/details/crash/crash.html',
                        controller: 'VehicleCrashController as vm'
                    }
                },
                resolve: {
                    crashTests: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSACrashPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.crash')
        .controller('VehicleCrashController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, crashTests, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.crashTests = crashTests;

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.crashTests = $scope.searchTerm ? crashTests.filter(createFilterFor($scope.searchTerm)) : crashTests;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToComplaintItem = function (optionItem) {
            $timeout(function () {
                $state.go('app.vehicle.details.crash.item', { itemId: optionItem.type });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.complaints', [
            'app.vehicle.details.complaints.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.complaints', {
                url: '/Complaints',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.complaints': {
                        templateUrl: 'app/main/vehicle/details/complaints/complaints.html',
                        controller: 'VehicleComplaintsController as vm'
                    }
                },
                resolve: {
                    complaints: function (vehicleService, $stateParams) {
                        return vehicleService.getNHTSAComplaintsPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.complaints')
        .controller('VehicleComplaintsController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, complaints, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.complaints = complaints;

        console.log(vm.complaints);


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.complaints = $scope.searchTerm ? complaints.filter(createFilterFor($scope.searchTerm)) : complaints;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToComplaintItem = function (optionItem) {
            $timeout(function () {
                $state.go('app.vehicle.details.complaints.item', { itemId: optionItem.nhtsaIdNumber });
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.bulletins', [
            'app.vehicle.details.bulletins.item'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.details.bulletins', {
                url: '/Bulletins',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.details.bulletins': {
                        templateUrl: 'app/main/vehicle/details/bulletins/bulletins.html',
                        controller: 'VehicleBulletinsController as vm'
                    }
                },
                resolve: {
                    items: function (vehicleService, $stateParams) {
                        return vehicleService.getBulletinsPromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });
 

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details.bulletins')
        .controller('VehicleBulletinsController', VehicleComplaintsController);

    /** @ngInject */
    function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, items, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle.details';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.items = items;


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (!item) continue;
                    if (item.constructor === [].constructor) {
                        for (var i = 0; i < item.length; i++) {
                            if (filterFn(item[i])) return true;
                        }
                    }
                    else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.isNumber = function (item) {
            return (typeof item === "number");
        }

        $scope.$watch('searchTerm', function () {
            vm.items = $scope.searchTerm ? items.filter(createFilterFor($scope.searchTerm)) : items;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.goToItem = function (item) {
            $timeout(function () {
                $state.go('app.vehicle.details.bulletins.item', { itemId: item.id });
            });
        }

        vm.compDesc = function(item){
            if (item && item.componentDescription){
                return item.componentDescription.replaceAll(':', ' > ');
            }
            return null;
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('settingsToolbar', directive);

    /** @ngInject */
    function directive() {
        return {
            restrict: 'E',
            scope: {
                show: '=?'
            },
            templateUrl: 'app/main/settings/generic/generic-toolbar/generic-toolbar.html',
            compile: function (tElement) {
                // Add class
               //// tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                 ////   scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                 ////   function cardTemplateLoaded() {
                  ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
                 ////  }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.settings', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.settings', {
                url: '/Settings?focus',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.settings': {
                        templateUrl: 'app/main/vehicle/settings/settings.html',
                        controller: 'VehicleSettingsController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    focus: null
                }
            });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.settings')
        .controller('VehicleSettingsController', VehicleSettingsController);

    /** @ngInject */
    function VehicleSettingsController($scope, $controller, $mdDialog, $state, vehicleService, $window, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.vehicle = mVehicle;

        vm.focus = $state.params.focus;

        vm.save = function (form) {
            if ($scope.vUpdates.$invalid) return;

            var success = function (vehicle) {

                vm.vehicle = vehicle;

                vm.goBack();

            };

            var continueThis = false;

            for (var key in vm.updatedSettings) {
                if (vm.updatedSettings[key] == vm.vehicle[key]) continue;
                continueThis = true;
                break;
            }

            if (!continueThis) {
                success(vm.vehicle);
                return;
            }

            vm.updatedSettings.id = vm.vehicle.id;
            vm.updatedSettings.vin = vm.vehicle.vin;

            vm.loading = true;


            vehicleService.updateVehicle(vm.updatedSettings, success, function (failed) {
                vm.loading = false;
                console.log(failed);
            });
        }

        vm.deleteVehicle = function (ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
            .title('Delete')
            .textContent("Are you sure you would like to delete this vehicle?  All settings and data will be lost.")
            .ariaLabel('Error')
            .ok('OK')
            .cancel('CANCEL')
            .targetEvent(ev)

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                vehicleService.deleteVehicle(mVehicle.vin, ev)
                .then(function (){
                    vm.loading = false;
                    $state.go('app.garage');
                }, function (){
                    vm.loading = false;
                });
            }, function () {

            });

            

        }

        vm.loading = false;

        vm.updatedSettings = {};
        vm.updatedSettings.nickname = vm.vehicle.nickname;
        vm.updatedSettings.odometer = vm.vehicle.odometer;
        vm.updatedSettings.licensePlate = vm.vehicle.licensePlate;
        vm.updatedSettings.postalCode = vm.vehicle.postalCode;
        vm.updatedSettings.autoUpdateMileage = vm.vehicle.autoUpdateMileage;
        vm.updatedSettings.updateMileagePerDay = vm.vehicle.updateMileagePerDay;
        vm.updatedSettings.trackMaintenance = vm.vehicle.trackMaintenance;
        vm.updatedSettings.trackRecalls = vm.vehicle.trackRecalls;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.recalls', [
            'app.vehicle.recalls.recall'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.recalls', {
                url: '/Recalls?openRecalls',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.recalls': {
                        templateUrl: 'app/main/vehicle/recalls/recalls.html',
                        controller: 'VehicleRecallsController as vm'
                    }
                },
                resolve: {
                    recalls: function (vehicleService, $stateParams) {
                        return vehicleService.getRecallsPromise($stateParams.vin, $stateParams.openRecalls);
                    }
                },
                params: {
                    vin: null,
                    focus: null,
                    openRecalls: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.recalls')
        .controller('VehicleRecallsController', VehicleRecallsController);

    /** @ngInject */
    function VehicleRecallsController($scope, $controller, $state, $timeout, $rootScope, $window, recalls, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.goTo = function (recall) {
            $state.go('app.vehicle.recalls.recall', { recallId: recall.recallNumber });
        };

        vm.recalls = recalls;

        console.log(vm.recalls);

        vm.openRecallsList = recalls;

        vm.getTitle = function () {
            return $state.params.openRecalls ? "Opened Recalls" : "Recalls";
        }

        vm.getTitleItem = function(item){
            return item.subject ? item.subject : item.summary;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                for (var key in mItem) {
                    var item = mItem[key];
                    if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
                    if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
                }
                return false;
            };

        }

        $scope.$watch('searchTerm', function () {
            vm.recalls = $scope.searchTerm ? recalls.filter(createFilterFor($scope.searchTerm)) : recalls;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.maintenance', [
            'app.vehicle.maintenance.input',
            'app.vehicle.maintenance.item'
            
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.maintenance', {
                url: '/Maintenance',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.maintenance': {
                        templateUrl: 'app/main/vehicle/maintenance/maintenance.html',
                        controller: 'VehicleMaintenanceController as vm'
                    }
                },
                resolve: {
                    vehicleMaintenance: function (vehicleService, $stateParams) {
                        return vehicleService.getMaintenancePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.maintenance')
        .controller('VehicleMaintenanceController', controller);

    /** @ngInject */
    function controller($scope, $state, $q, $controller, $timeout, $rootScope, $window, vehicleService, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        $scope.currentOdometer = mVehicle.odometer;

        $scope.m = {};

        $scope.m.date = new Date();
        $scope.m.odometer = vm.vehicle.odometer;

        vm.editTracking = false;

        function loadMaintenance() {

            var tempStuff = $scope.vs.getMaintenanceArray('percentage', true);

            var temptemp = [];

            var foundNoTrack = false;
            for (var i = 0; i < tempStuff.length; i++) {
                var item = tempStuff[i];

                if (!item.tracking && !foundNoTrack) {
                    foundNoTrack = true;
                    temptemp.push({
                        type: "header",
                        style: {
                            height: "40px"
                        },
                        item: {
                            text: "Not Tracking",
                            keyId: "NotTracking"
                        }
                    });

                }

                temptemp.push({
                    type: "item",
                    item: item
                });
            }

            vm.ar = temptemp;
        }

        loadMaintenance();





        $scope.mItems = {};

        vm.selectedItemChange = function (item) {
            //   console.log($scope.m.maintenanceItem);
            //  console.log(item);
        }

        vm.querySearch = function (text) {
            var results = text ? $scope.mItems.filter(createFilterFor(text)) : $scope.mItems;
            var deferred = $q.defer();
            deferred.resolve(results);
            return deferred.promise;
        }

        vm.editTrackingFunc = function () {
            if (vm.editTracking) {
                vm.loading = true;
                var temp = {};
                for (var key in vm.ar) {
                    temp[vm.ar[key].keyId] = vm.ar[key].tracking;
                }
                vehicleService.udpateMaintenanceTracking(temp, function (success) {
                    vm.loading = false;
                    $state.reload();
                }, function (done) {
                    vm.loading = false;

                });
            }
            vm.editTracking = !vm.editTracking;
        }

        /**
   * Create filter function for a query string
   */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(mItem) {
                if (!mItem.item || !mItem.item.action) return false;
                var searchThis = mItem.item.action.toLowerCase() + " " + mItem.item.item.toLowerCase();
                return (searchThis.indexOf(lowercaseQuery) > -1);
            };

        }

        vm.goTo = function (item) {
            $state.go('app.vehicle.maintenance.item', { maintenanceItem: item.id });
        }

        $scope.$watch('searchTerm', function () {
            $scope.mItems = $scope.searchTerm ? vm.ar.filter(createFilterFor($scope.searchTerm)) : vm.ar;
            var scroller = document.getElementById("scroll-vs-repeat");
            if (scroller) scroller.scrollTop = 0;
        });

        vm.textColor = function (item) {
            if (!item.status || !item.status.indexOf("DUE") === -1) return { color: 'green' };
            return { color: '#FF5722' };
        }

        vm.dueMileage = function (item) {
            var due = item.nextDueOdomoter - $scope.currentOdometer;
            var dueAbs = Math.abs(due);
            var startOf = due > 0 ? "Due in " : "Overdue by ";
            return startOf + dueAbs.toLocaleString() + " miles";
        }

        vm.dueInTime = function (item) {
            var absDays = Math.abs(item.daysDiff);
            var startOf = item.daysDiff > 0 ? "Due in " : "Overdue by ";
            return startOf + (absDays > 30 ? Math.abs(item.monthsDiff) + " months" : Math.abs(item.daysDiff) + " days");
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.image', [
            'app.vehicle.image.editor'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.vehicle.image', {
            url: '/Image',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.vehicle.image': {
                    templateUrl: 'app/main/vehicle/image/image.html',
                    controller: 'VehicleImageController as vm'
                }
            },
            resolve: {
                vehicle: function (vehicleService, $stateParams) {
                    return vehicleService.getVehiclePromise($stateParams.vin);
                }
            },
            params: {
                vin: null
            }

        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.image')
        .controller('VehicleImageController', VehicleImageController)
        .controller('ListBottomSheetCtrl', ListBottomSheetCtrl);

    /** @ngInject */
    function VehicleImageController($scope, $controller, $rootScope, appProxy, $mdBottomSheet, $state, vehicleService, $window, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.vehicle = mVehicle;

        $scope.alert = '';

        $scope.showListBottomSheet = function () {
            $scope.alert = '';
            $mdBottomSheet.show({
                templateUrl: 'app/main/vehicle/image/image-bottom-sheet.html',
                controller: 'ListBottomSheetCtrl',
                scope: $scope
            }).then(function (clickedItem) {
            });
        };




    }

    /** @ngInject */
    function ListBottomSheetCtrl($scope, $controller, appProxy, $mdDialog, $timeout, $rootScope, $mdBottomSheet, $state, vehicleService, $window, $http) {

        /*
        $scope.items = [
            { name: 'Camera', icon: 'assets/images/cartraxx/ic_photo_camera_black_24px.svg' },
            { name: 'Upload', icon: 'assets/images/cartraxx/ic_file_upload_black_24px.svg', state: "app.vehicle.image.editor" },
            { name: 'Default', icon: 'assets/images/cartraxx/ic_file_upload_black_24px.svg' }
        ];
        */

        $scope.isApp = appProxy.isApp();

        $scope.default = function () {
            alert('default');
        }

        function errorFun(error) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Image Failed')
                    .textContent('unable to load image.')
                    .ariaLabel('Alert Dialog Demo')
                    .ok('OK')
                    .targetEvent(ev)
            );
            $mdBottomSheet.hide();
        }

        function successFun(data) {
            if (!data.imageBase64) return;
            $rootScope.tempGalleryImage = "data:image/jpeg;base64," + data.imageBase64;
            $mdBottomSheet.hide();
            $timeout(function () {
                $state.go('app.vehicle.image.editor');
            });
        }

        $scope.camera = function () {
            appProxy.getImage({ imageFrom: "camera" })
                .then(successFun, errorFun);
        }

        $scope.upload = function (ev) {
            if (appProxy.isNotApp()) {
                $('#fileInput').trigger('click');
            }
            else
                appProxy.getImage({ imageFrom: "gallery" })
                    .then(successFun, errorFun);

        }

        var handleFileSelect = function (evt) {
            if (evt.currentTarget.files.length === 0) {
                $mdBottomSheet.hide();
                return;
            }
            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $rootScope.tempGalleryImage = evt.target.result;
                    $mdBottomSheet.hide();
                    $timeout(function () {
                        $state.go('app.vehicle.image.editor');
                    });
                });
            };
            reader.readAsDataURL(file);
        };

        $timeout(function () {
            $('#fileInput').on('change', handleFileSelect);
        }, 100)


        $scope.listItemClick = function ($index) {
            var clickedItem = $scope.items[$index];
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.history_report', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.history_report', {
                url: '/HistoryReport',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.history_report': {
                        templateUrl: 'app/main/vehicle/history/history.html',
                        controller: 'VehicleHistoryReportController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.history_report')
        .controller('VehicleHistoryReportController', VehicleHistoryReportController);

    /** @ngInject */
    function VehicleHistoryReportController($scope, $controller, $state, vehicleService, $window, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.vehicle = mVehicle;

        $scope.carfax = function () {
            $window.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getCarfaxDiscount");
        }

         $scope.vinaudit = function () {
            $window.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getVINAudit");
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details', [
            'app.vehicle.details.specs',
            'app.vehicle.details.standard',
            'app.vehicle.details.options',
            'app.vehicle.details.complaints',
            'app.vehicle.details.mancomms',
            'app.vehicle.details.crash',
            'app.vehicle.details.investigations',
            'app.vehicle.details.rec_features',
            'app.vehicle.details.safety_features',
            'app.vehicle.details.bulletins'

        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
     
        $stateProvider
        .state('app.vehicle.details', {
            url: '/Details',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.vehicle.details': {
                    templateUrl: 'app/main/vehicle/details/details.html',
                    controller: 'VehicleDetailsController as vm'
                }
            },
            resolve: {
                options: function (vehicleService, $stateParams) {
                    return vehicleService.getVehiclePromise($stateParams.vin);
                }
            },
            params: {
                vin: null,
                animate: null
            }
        });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.details')
        .controller('VehicleDetailsController', VehicleDetailsController);

    /** @ngInject */
    function VehicleDetailsController($scope, $controller, $rootScope, $mdToast, $state, $timeout, vehicleService, $http, vehicle) {
        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        $scope.vs = vehicleService;

        vm.estimatedImage;

        vm.estimatedImage;

        var counterSpecs = 0;

        if (mVehicle.formattedJson) for (var key in mVehicle.formattedJson) {
            counterSpecs++;
        }

        vm.specsCount = counterSpecs;

        if (mVehicle.estimatedMPG && mVehicle.estimatedMPG.trending) switch (mVehicle.estimatedMPG.trending) {
            case "DOWN":
                vm.estimatedImage = "assets/images/cartraxx/down_arrow_orange.svg";
            case "UP":
                vm.estimatedImage = "assets/images/cartraxx/up_arrow_green.svg";
            default:
                vm.estimatedImage = "assets/images/cartraxx/steady_arrow_blue.svg";
        }

        vm.shouldAnimate = $state.params.animate === "Y";

        vm.firstMaintenance = vehicleService.getFirstMaintenance();

        vm.animate = [
            vm.shouldAnimate,
            vm.shouldAnimate,
            vm.shouldAnimate,
            vm.shouldAnimate,
            vm.shouldAnimate
        ];

        $scope.valueId = '34';

        vm.showLogonNow = true;

        $timeout(function () {
            vm.showLogonNow = true;
        }, 800);

        $scope.$watch('valueId', function () {
            $scope.value =
                $scope.valueId && mVehicle.formattedJson[$scope.valueId] ?
                    mVehicle.formattedJson[$scope.valueId] : null;
        }, true);


        vm.getHeadline = vehicleService.getHeadline;

        vm.getSubHeader = vehicleService.getSubHeader;

        vm.goToSettings = function (focus) {
            $rootScope.isHeroTransition = true;
            vm.focus = focus;
            $timeout(function () {
                $state.go('app.vehicle.settings', { focus: focus });
            });
        }

        vm.goToImage = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.image');
            });
        }

        vm.recalls = function () {
            if (vehicleService.hasRecalls()) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.recalls');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Recalls')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToSpecs = function () {
            if (vm.vehicle.formattedJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.specs');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Specs')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToDetails = function () {
            if (vm.vehicle.standardJson.equipment) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.standard');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Details')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToOptions = function () {
            if (vm.vehicle.styleDetailsJson.options) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.options');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Options')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToComplaints = function () {
            if (vm.vehicle.nhtsaInfoJson.complaintsJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.complaints');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Complaints')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }

        }


        vm.goToManComms = function () {
            if (vm.vehicle.nhtsaInfoJson.manufacturerCommJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.mancomms');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Manufacturer Communications')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToCrash = function () {
            if (vm.vehicle.nhtsaInfoJson.crashTestJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.crash');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Crash Test Data')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToInvestigations = function () {
            if (vm.vehicle.nhtsaInfoJson.investigationsJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.investigations');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Investigations')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToRecFeatures = function () {
            if (vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.rec_features');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Recommended Features')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToSafetyFeatures = function () {
            if (vm.vehicle.nhtsaInfoJson.safetyFeaturesJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.safety_features');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Safety Features')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToBulletins = function () {
            if (vm.vehicle.bulletinsJson.serviceBulletinHolder) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.details.bulletins');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Bulletins')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }
        

        vm.maintenance = function () {

            if (vehicleService.hasMaintenance()) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.maintenance');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Maintenance')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }

        }

        vm.inputGas = function () {
            vm.loading = true;
            vehicleService.getVehiclePromise(mVehicle.vin)
                .then(function () {
                    vm.loading = false;
                    $rootScope.isHeroTransition = true;
                    $timeout(function () {
                        $state.go('app.vehicle.gas.input');
                    });
                }, function (failed) {
                    vm.loading = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(failed.data.message)
                            .position('bottom')
                            .hideDelay(3000)
                    );
                });

            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.gas.input');
            });
        }


        vm.inputMaintenance = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.maintenance.input');
            });
        }

        vm.historyReport = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.history_report');
            });
        }

        vm.checkGas = function () {
            vm.loading = true;

            vehicleService.getVehiclePromise(mVehicle.vin)
                .then(function () {
                    vm.loading = false;
                    $rootScope.isHeroTransition = true;
                    $timeout(function () {
                        if (vm.vehicle.estimatedMPG) $state.go('app.vehicle.gas.view');
                        else $state.go('app.vehicle.gas.input');
                    });
                }, function (failed) {
                    vm.loading = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(failed.data.message)
                            .position('bottom')
                            .hideDelay(3000)
                    );
                });


        }

        vm.getMPG = vehicleService.getMPG;


        if (vm.shouldAnimate) {

            var counter = 0;

            var timeout_length = 400;

            var animateFunction = function () {
                vm.animate[counter] = false;
                $scope.$apply();
                counter++;
                if (counter < vm.animate.length) setTimeout(animateFunction, timeout_length);
                else {
                    vm.shouldAnimate = false;
                    $state.go('.', { animate: null }, { notify: false });
                }
            }

            setTimeout(animateFunction, 600);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.settings_register', {
                url: '/Settings/Register',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.settings_register': {
                        templateUrl: 'app/main/settings/register/register.html',
                        controller: 'SettingsRegisterController as vm'
                    }
                },
                bodyClass: 'register',
                resolve: {
                    user: function (firebaseService, $q, Auth) {
                        return $q(function (resolve, rejectThis) {
                            Auth.$waitForSignIn().then(function (user) {
                                if (user && !user.isAnonymous) throw "GO_TO_GARAGE";
                                else resolve();
                            }, function (error) {
                                resolve();
                            }).catch(function (e) {
                                rejectThis(e);
                            });
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings/register');

        /*
                msNavigationServiceProvider.saveItem('settings.register', {
                    title: 'Register',
                    icon: 'icon-account',
                    state: 'app.settings_register',
                    weight: 1
                });
                */
    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.register')
        .controller('SettingsRegisterController', SettingsRegisterController);

    /** @ngInject */
    function SettingsRegisterController($scope, $state, $rootScope, $controller, $mdDialog, firebaseService) {

      
        $scope.noHeroTransitionBack = true;

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.createUserWithEmailAndPassword = function (email, password, username, ev) {

            vm.loading = true;

            firebaseService.createUserWithEmailAndPassword(email, password, username, function (result, errorOrUser) {

                vm.loading = false;

            }, ev);
        }

        vm.signInWithGoogle = function (ev) {
            vm.loading = true;

            firebaseService.signInWithGoogle(function () {
                vm.loading = false;

            }, ev);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.achievements', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.achievements', {
                url: '/Achievements',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.achievements': {
                        templateUrl: 'app/main/vehicle/achievements/achievements.html',
                        controller: 'VehicleAchievementsController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.achievements')
        .controller('VehicleAchievementsController', VehicleAchievementsController);

    /** @ngInject */
    function VehicleAchievementsController($scope, $controller, $state, vehicleService, $window, $http) {

        $scope.forceOverrideState = 'app.vehicle';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.vehicle = mVehicle;

        $scope.carfax = function () {
            $window.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getCarfaxDiscount");
        }

         $scope.vinaudit = function () {
            $window.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getVINAudit");
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.privacy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.settings.privacy', {
                url: '/PrivacyPolicy',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.settings.privacy': {
                        templateUrl: 'app/main/settings/privacy/privacy.html',
                        controller: 'PrivacyController as vm'
                    }
                },
                bodyClass: 'settings_privacy',
                resolve: { 
                      
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.privacy')
        .controller('PrivacyController', PrivacyController);

    /** @ngInject */
    function PrivacyController($scope, $firebaseAuth, firebaseService, $mdToast, user, $state) {

        var vm = this;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.settings_login', {
            url: '/Settings/Login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.settings_login': {
                    templateUrl: 'app/main/settings/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            resolve: {
                user: function (firebaseService, $q, Auth) {
                    return $q(function (resolve, rejectThis) {
                        firebaseService.getUserDataPromise(false).then(function (user) {
                            if (user.account && !user.account.isAnonymous) throw "GO_TO_GARAGE";
                            else resolve();
                        }, function (error) {
                            if (error === "EMAIL_VERIFICATION_REQUIRED")
                                throw error;
                            else
                                resolve();
                        }).catch(function (e) {
                            rejectThis(e);
                        });
                    });
                }
            }

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings/login');


        /*
                 msNavigationServiceProvider.saveItem('settings.login', {
                    title    : 'Login',
                    icon     : 'icon-login',
                    state    : 'app.settings_login',
                    weight   : 1
                });
                */
    }

})();
(function () {
    'use strict';

    angular
        .module('app.settings.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $controller, firebaseService, $state) {

        $scope.noHeroTransitionBack = true;

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        vm.loading = false;

        vm.signInEmail = function (email, password, ev) {
            vm.loading = true;
            firebaseService.signInEmail(email, password, function () {
                vm.loading = false;
            }, ev);
        };

        vm.signInWithGoogle = function (ev) {
            vm.loading = true;
            firebaseService.signInWithGoogle(function () {
                vm.loading = false;
            }, ev);
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.generic', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.settings', {
                url: '/Settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/generic/generic.html',
                        controller: 'SettingsController as vm'
                    }
                },
                resolve: {
                    user: function (firebaseService) {
                        return firebaseService.getUserDataPromise();
                    }
                }
            });


        msNavigationServiceProvider.saveItem('settings.home', {
            title: 'Settings',
            icon: 'icon-home',
            state: 'app.settings',
            /*stateParams: {
                'param1': 'page'
             },*/
            weight: 1
        });

                    NavItems.addItem('app.settings', "assets/images/cartraxx/settings.svg", 'Settings');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.generic')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($scope, $rootScope, $timeout, firebaseService, user, appProxy, $state) {

        var vm = this;

        var tempCosts = [];

        if (!user.settings.settings) user.settings.settings = {};
        $scope.tempSettings = user.settings.settings;
        if (!$scope.tempSettings) $scope.tempSettings = {};

        $scope.tempSettings.laborCost = !user.settings.settings.laborCost ? user.global.laborCost.default : user.settings.settings.laborCost;

        for (var i = user.global.laborCost.min; i < user.global.laborCost.max; i += user.global.laborCost.increment) {
            tempCosts.push(i.toString());
        }

        vm.laborCosts = tempCosts;


        $scope.fs = firebaseService;

        appProxy.getDebugMode()
            .then(function (data) {
                $scope.debugMode = data.debugMode;
            });

        vm.saveDebug = function () {

            appProxy.setDebugMode({ debugMode: $scope.debugMode });
        }

        vm.isApp = function () {
            return appProxy.handlerContains('getDebugMode');
        }

        vm.saveSettings = function () {
            user.settings.$save().then(function (ref) {
                $state.go('app.garage');
            }, function (error) {
            });
        }

        vm.contactUs = function () {
            $timeout(function () {
                $state.go('app.settings_contactus');
            });
        }

        $rootScope.saveSettings = vm.saveSettings;

        $scope.$on('$destroy', function () {
            $rootScope.saveSettings = null;
        });



    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.email_verify', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.settings_emailverify', {
                url: '/Email/Verification',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.settings_emailverify': {
                        templateUrl: 'app/main/settings/email_verify/email.html',
                        controller: 'EmailVerifyController as vm'
                    }
                },
                bodyClass: 'emailverify',
                resolve: { 
                       user: function (Auth, $q, firebaseService) {
                         return $q(function (resolve, reject) {
                            firebaseService.getUserDataPromise(false)
                             .then(function (user){
                                 console.log(user.account);
                                 if (user.account.isAnonymous === true){
                                     throw "AUTH_REQUIRED";
                                 }
                                 else if (!user.account.emailVerified) resolve(user.account);
                                 else throw "EMAIL_ALREADY_VERIFIED";
                             }, function(failed){
                                 console.log(failed);
                                 reject(failed);
                             })
                             .catch(function (error){
                                 console.log(error);
                                 reject(error);
                             });
                         });
                    }
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.email_verify')
        .controller('EmailVerifyController', EmailVerifyController);

    /** @ngInject */
    function EmailVerifyController($scope, $firebaseAuth, firebaseService, $mdToast, user, $state) {

        var vm = this;

        function emailSent(result, string) {

        }

        vm.sendEmailVerification = function () {
            firebaseService.sendEmailVerification(user);
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Sent - Check Email')
                    .position('bottom')
                    .hideDelay(3000)
            );
        }

        vm.checkAgain = function () {
            function failed(error) {
                console.log(error);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Authentication Failed')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }

            firebaseService.reloadUser().then(function (user) {
                if (mFirebaseUser.account.emailVerified) {
                    $state.go('app.garage');
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Email not verified')
                            .position('bottom')
                            .hideDelay(3000)
                    );
                }
            }, failed).catch(failed);
        }

        vm.signOut = function (ev) {
            firebaseService.signOut(ev);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings.download',
        [
        ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {


        // State
        $stateProvider
            .state('app.settings_download', {
                url: '/Download',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.settings_download': {
                        templateUrl: 'app/main/settings/download/download.html',
                        controller: 'DownloadController as vm'
                    }
                },
                bodyClass: 'download',
            });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.settings.download')
        .controller('DownloadController', DownloadController);

    /** @ngInject */
    function DownloadController($mdToast, $controller, $http, $scope, $mdDialog, Auth, $state, $mdSidenav, dialogsService, $timeout) {

        var vm = this;

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

    
    }

})();
(function () {
    'use strict';

    angular
        .module('app.settings.contactus',
        [
        ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {


        // State
        $stateProvider
            .state('app.settings_contactus', {
                url: '/ContactUs',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.settings_contactus': {
                        templateUrl: 'app/main/settings/contact-us/contact-us.html',
                        controller: 'ContactUsController as vm'
                    }
                },
                bodyClass: 'ContactUs',
            });

            NavItems.addItem('app.settings_contactus', "assets/images/cartraxx/mail_outline.svg", 'Contact Us');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.settings.contactus')
        .controller('ContactUsController', ContactUsController);

    /** @ngInject */
    function ContactUsController($mdToast, $controller, $http, $scope, $mdDialog, Auth, $state, $mdSidenav, dialogsService, $timeout) {

        var vm = this;

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        vm.contacts = [
            { name: 'Tech Support', value: 'tech-support@cartraxx.com' },
            { name: 'Sales', value: 'sales@cartraxx.com' }
        ]

        vm.obj = {};

        vm.send = function (form) {

            if (form.$invalid || form.$pristine) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("*Please supply the necessary fields")
                        .position('bottom right')
                );
                return;
            }

            vm.loading = true;

            vm.obj.id = Utils.generateUID();

            vm.obj.uid = Auth.$getAuth().uid;

            if (mDeviceInfo){
                for (var key in mDeviceInfo){
                    vm.obj["device_" + key] = mDeviceInfo[key];
                }
            }

            Utils.httpPost($http, "https://cartraxx.azurewebsites.net/api/settings?type=contactus&userId=" + mFirebaseUser.account.uid, vm.obj, function (data) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .title('Thanks')
                        .textContent("Thank you for reaching out.  We will respond to your email shortly.")
                        .ariaLabel('Thanks')
                        .ok('OK')
                ).then(function (data) {
                    vm.goBack();
                }, function (done) {
                    vm.goBack();

                });
            }, function (error) {
                console.log(error);
                vm.loading = false;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Error sending communication")
                        .position('bottom right')
                );
            });

        }

        vm.formatDate = function (date) {
            return new Date(date).toDateString();
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('DialogListController', DialogListController);

    /** @ngInject */
    function DialogListController($scope, $controller, $mdDialog, $rootScope, $mdToast, $state, $timeout, vehicleService, $http, title, items, data) {

        //  angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        if (!data) data = {};

        $scope.items = items;
        $scope.title = title;
        $scope.text = data.text ? data.text : 'text';
        $scope.id = data.id ? data.id : 'id';


        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

var vm = this;

vm.select = function(item){
    $mdDialog.hide(item);
}

    }
})();
(function () {
    DialogsUtil = {
        listDialogJson: function (title, items, optionalExtras) {

            var json = {
                controller: 'DialogListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/common/dialogs/dialog_list.html',
                locals : {
                    title : title,
                    items : items,
                    data : optionalExtras
                }
            };

            for (var key in optionalExtras) {
                if (!json.hasOwnProperty(key)) json[key] = optionalExtras[key];
            }

            return json;

        }
    }
}
)();
(function () {
    'use strict';

    angular
        .module('app.garage.add', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.garage.add', {
                url: '/Add',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.garage.add': {
                        templateUrl: 'app/main/garage/add/vehicle-add.html',
                        controller: 'VehicleAddController as vm'
                    }
                }
            });

    
    }
})();
(function () {
    'use strict';

    angular
        .module('app.garage.add')
        .controller('VehicleAddController', VehicleController);

    /** @ngInject */
    function VehicleController($scope, appProxy, $controller, $mdDialog, $rootScope, $mdToast, $state, $timeout, vehicleService, $http) {

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        $scope.app = appProxy;

        vm.scanVIN = function(){
            appProxy.decodeByBarcode()
            .then(function(data){
                $scope.vin = data.vin;
                $scope.$apply();
            }, function(error){
                 $mdToast.show(
                        $mdToast.simple()
                            .textContent(error.errorMessage)
                            .position('bottom')
                            .hideDelay(3000)
                    );
            });
        }

        vm.decode = function (ev) {
          if ($scope.vUpdates.style)  console.log($scope.vUpdates.style.$invalid);
            if ($scope.vUpdates.$invalid) return;

            vm.loading = true;

            var styleId;
            var yearId;

            if (vm.style) styleId = vm.style.id;
            if (vm.year) yearId = vm.year.id;

            vehicleService.decodeVehicle($scope.vin, styleId, yearId, function (vehicle) {
                switch (vehicle.resultType) {
                    case 'decoded':
                        $state.go('app.vehicle.settings', {vin : mVehicle.vin});
                        return;
                    case 'styleSelection':
                        for (var i = 0; i < vehicle.options.length; i++) {
                            vehicle.options[i].text = vehicle.options[i].name;
                        }
                        vm.styleGuide = vehicle.options;
                        break;
                    case 'yearSelection':
                     for (var i = 0; i < vehicle.options.length; i++) {
                            vehicle.options[i].text = vehicle.options[i].year;
                        }
                        vm.yearGuide = vehicle.options;
                        break;
                }
                vm.loading = false;
            }, function (failed) {
                vm.loading = false;

                $mdDialog.show(
                    $mdDialog.alert()
                        .title('Error')
                        .textContent(failed.message ? failed.message : failed)
                        .ariaLabel('Error')
                        .ok('OK')
                        .targetEvent(ev)
                );

            });
        };

        vm.getList = function (title, list, event) {
            $mdDialog.show(
                DialogsUtil.listDialogJson(title, list,
                    {
                        event: event,
                    })
            )
                .then(function (result) {
                    if (title === 'Style') vm.style = result;
                    if (title === 'Year') vm.year = result;
                });
        }

        $scope.$watch('vin', function(){
            vm.styleGuide = null;
            vm.yearGuide = null;
            vm.style = null;
            vm.year = null;
        });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('watch', directive);

    function directive() {
        return {
            restrict: 'E',
            scope: {
                resize: '&'
            },
            replace: true,
            link: function (scope, elm, attrs) {
                var container = element[0];

                /** 
                scope.$watch(function () {
                    scope.resize({
                        width: element.width(),
                        height: element.height()
                    });
                });
                */

                $scope.$watchGroup([
                    function () { return container.offsetWidth; },
                    function () { return container.offsetHeight; }
                ], function (values) {
                    scope.resize(values);
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('touchedNow', touchedDirective);

    /** @ngInject */
    function touchedDirective() {
        return {
            replace: true,
            scope: {},
            template: function (tElement, tAttrs) {
                
                var touch = "ng-touchstart='touching = true' ng-touchend='touching = false'"

                if (!tAttrs.hasOwnProperty('mdInkRipple')) touch += " md-ink-ripple"

                return '<div ' + touch + ' ng-transclude></div>';
            },
            transclude: true,
            link: function (scope, element, attrs) {
                if (element[0].style.position !== "relative")
                element[0].style.position = "relative";
                scope.$watch('touching', function () {
                    if (scope.touching) angular.element(element[0]).trigger('mousedown');
                    else angular.element(element[0]).trigger('mouseup');
                });
            }
        };
    }
})();
(function () {
    "use strict";


    var lastUpdate = {};

    angular
        .module('app.core')
        .directive('ngVirtualRepeat', NgVirtualRepeatDirective)
        .directive('testDirective', testDirective);

    /** @ngInject */
    function testDirective() {
        return {
            restrict: 'A',
            transclude: 'element',
            scope: {
            }
        };
    }

    /** @ngInject */
    function NgVirtualRepeatDirective(vkThread) {
        return {
            restrict: 'A',
            link: link,
            scope: {
                width: '=',
                height: '=',
                data: '=',
                onCellClick: '&',
                updateColor: '=',
                getLastUpdate: '='
            }
        };

        function link(scope, element, attrs) {
            var viewport = findParent(element, 'ng-virtual-repeat-container');
            var container = viewport.find('div').eq(0);
            var scrollTop = 0;
            var scrollLeft = 0;
            var visibleRows = 0;
            var visibleCols = 0;
            var cellWidth = 0;
            var cellHeight = 0;
            var watchSize = attrs.watchSize === undefined ? false : true;
            viewport.css({
                overflow: 'scroll',
                width: '100%',
                height: '100%'
            });

            calculateCellSize();

            render();

            var vm = this;
            /*
                        scope.$watch('data', function onMatrixChange(newValue, oldValue) {
                            if (newValue === undefined)
                                element.empty();
                            else
                                //           if (lastUpdate.startRow) updateRender();
                                //      else
                                render();
                        }, true);
                        */

            vm.renderAgain = false;
            vm.setTimeoutWaiting = false;

            viewport.bind('scroll', function onViewportScroll(event) {
                scrollTop = event.target.scrollTop;
                scrollLeft = event.target.scrollLeft;

                render();
                /*
                vm.renderAgain = true;
                if (!vm.setTimeoutWaiting) {
                    vm.setTimeoutWaiting = true;
                    setTimeout(function () {
                        if (!vm.renderAgain) return;
                        render();
                        vm.renderAgain = false;
                        vm.setTimeoutWaiting = false;
                    }, 300);
                }
                */
            });

            if (watchSize)
                scope.$watch(function getViewPortSize() {
                    return viewport[0].clientHeight + viewport[0].clientWidth;
                }, function onSizeChange() {
                    //        if (lastUpdate.startRow) updateRender();
                    //    else
                    render();
                });

            /**
             * Calculate cell size by faking a dummy td.
             */
            function calculateCellSize() {
                var dummyCell = element.append('<tr><td></td></tr>').find('td')[0];
                cellWidth = dummyCell.offsetWidth;
                cellHeight = dummyCell.offsetHeight;
            }

            scope.updateColor = function (X, Y, color) {
                var element = document.getElementById(X + "_" + Y);
                if (element && element.style.backgroundColor !== color) element.style.backgroundColor = color;
            }

            scope.getLastUpdate = function () {
                return lastUpdate;
            }

            /**
             * Calculate parameters and render the template to the view.
             */
            function render() {
                //  var matrix = scope.matrix;

                //   if (!matrix) return;

                element.empty();
                visibleRows = Math.ceil(viewport[0].clientHeight / cellHeight);
                visibleCols = Math.ceil(viewport[0].clientWidth / cellWidth);

                var startRow = Math.floor(scrollTop / cellHeight);
                var StartCol = Math.floor(scrollLeft / cellWidth);
                var endRow = startRow + visibleRows + 1;
                var endCol = StartCol + visibleCols + 1;
                var totalRows = scope.height;
                var totalCols = scope.width;
                if (endRow > totalRows) endRow = totalRows;
                if (endCol > totalCols) endCol = totalCols;

                lastUpdate.startRow = startRow;
                lastUpdate.StartCol = StartCol;
                lastUpdate.endRow = endRow;
                lastUpdate.endCol = endCol;

                element.append(generateTemplate(scope.data, lastUpdate));

                container.css({ 'padding-top': startRow * cellHeight + 'px' });
                container.css({ 'height': totalRows * cellHeight + 'px' });
                container.css({ 'padding-left': StartCol * cellWidth + 'px' });
                container.css({ 'width': totalCols * cellWidth + 'px' });



            }

            var loadingTemplate = false;


            function formatData() {
                var newData = {};
                for (var key in scope.data) {
                    if (isNaN(key)) continue;
                    newData[key] = scope.data[key];
                }
                return newData;
            }
        }


        /**
         * Generate table html template from matrix in the diplay port
         * @param {Array} start - the top left koordinate of matrix where begin display
         * @param {Array} end - the bottom right koordinate of the matrix where ends display
         * @returns {String} - the html generated tempalte.
         */
        function generateTemplate(data, lastUpdate) {
            var template = '';
            for (var y = lastUpdate.startRow; y < lastUpdate.endRow; y++) {
                var trElement = '<tr>';
                for (var x = lastUpdate.StartCol; x < lastUpdate.endCol; x++) {
                    var color = "white";
                    if (data && data[x] && data[x][y]) {
                        color = data[x][y].color;
                    }
                    trElement += ['<td id="' + x + '_' + y + '" style="background: ' + color + ';" onclick="onPixelClicked(' + x + ',' + y + ', this)">', "", '</td>'].join('');
                }
                template += trElement + '</tr>';
            }
            return template;
        }

        /**
         * Find parent element by selector.
         * @param {jqElement} element - current element.
         * @param {String} selector - class selector.
         * @returns {jqElement} - the parent element found or undefined if none.
         */
        function findParent(element, selector) {
            if (!element) return;
            if (!selector)
                //todo refactor error
                throw new Error('findParent, selector not specified');

            var parent = element.parent();
            while (parent) {

                if (parent.hasClass(selector))
                    return parent;

                parent = parent.parent();
            }
            return;
        }

    }
})();
(function () {
  "use strict";

  /**
   * @ngdoc module
   * @name material.components.virtualRepeat
   */
  angular.module('app.core')
    .directive('mdVRPContainer', VirtualRepeatContainerDirective)
    .directive('mdVRP', VirtualRepeatDirective)
    .directive('mdFH', ForceHeightDirective);


  /**
   * @ngdoc directive
   * @name mdVRPContainer
   * @module material.components.virtualRepeat
   * @restrict E
   * @description
   * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
   *
   * VirtualRepeat is a limited substitute for ng-repeat that renders only
   * enough DOM nodes to fill the container and recycling them as the user scrolls.
   *
   * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
   * another visible item by replacing the previous dataset with the new one.
   *
   * ### Common Issues
   *
   * - When having one-time bindings inside of the view template, the VirtualRepeat will not properly
   *   update the bindings for new items, since the view will be recycled.
   *
   * - Directives inside of a VirtualRepeat will be only compiled (linked) once, because those
   *   are will be recycled items and used for other items.
   *   The VirtualRepeat just updates the scope bindings.
   *
   *
   * ### Notes
   *
   * > The VirtualRepeat is a similar implementation to the Android
   * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
   *
   * <!-- This comment forces a break between blockquotes //-->
   *
   * > Please also review the <a ng-href="api/directive/mdVRP">VirtualRepeat</a>
   * documentation for more information.
   *
   *
   * @usage
   * <hljs lang="html">
   *
   * <md-virtual-repeat-container md-top-index="topIndex">
   *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
   * </md-virtual-repeat-container>
   * </hljs>
   *
   * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
   *     container to $scope. It can both read and set the scroll position.
   * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
   *     (defaults to orientation and scrolling vertically).
   * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
   *     the number of items when that number is less than its original size.
   * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
   *     will shrink to (default: 0).
   */
  function VirtualRepeatContainerDirective() {
    return {
      controller: VirtualRepeatContainerController,
      template: virtualRepeatContainerTemplate,
      compile: function virtualRepeatContainerCompile($element, $attrs) {
        $element
          .addClass('md-v-r-p-container-2');
        if ($attrs.hasOwnProperty('mdOrientHorizontal')) {
          $element.addClass('md-orient-horizontal');
        } else if ($attrs.hasOwnProperty('mdOrientGrid')) {
          $element.addClass('md-orient-grid');
        } else {
          $element.addClass('md-orient-vertical');
        }
      }
    };
  }


  function virtualRepeatContainerTemplate($element) {
    return '<div class="md-virtual-repeat-scroller">' +
      '<div class="md-virtual-repeat-sizer"></div>' +
      '<div class="md-virtual-repeat-offsetter">' +
      $element[0].innerHTML +
      '</div></div>';
  }

  /**
   * Number of additional elements to render above and below the visible area inside
   * of the virtual repeat container. A higher number results in less flicker when scrolling
   * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
   * @const {number}
   */
  var NUM_EXTRA = 3;

  /** @ngInject */
  function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window, $scope,
    $element, $attrs) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$element = $element;
    this.$attrs = $attrs;

    /** @type {number} The width or height of the container */
    this.size = 0;
    /** @type {number} The scroll width or height of the scroller */
    this.scrollSize = 0;
    /** @type {number} The scrollLeft or scrollTop of the scroller */
    this.scrollOffset = 0;
    /** @type {boolean} Whether the scroller is oriented horizontally */
    this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
    /** @type {!VirtualRepeatController} The repeater inside of this container */
    this.repeater = null;
    /** @type {boolean} Whether auto-shrink is enabled */
    this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
    /** @type {number} Minimum number of items to auto-shrink to */
    this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
    /** @type {?number} Original container size when shrank */
    this.originalSize = null;
    /** @type {number} Amount to offset the total scroll size by. */
    this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
    /** @type {?string} height or width element style on the container prior to auto-shrinking. */
    this.oldElementSize = null;
    /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
    this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;

    if (this.$attrs.mdTopIndex) {
      /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
      this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
      /** @type {number} The index of the item that is at the top of the scroll container */
      this.topIndex = this.bindTopIndex(this.$scope);

      if (!angular.isDefined(this.topIndex)) {
        this.topIndex = 0;
        this.bindTopIndex.assign(this.$scope, 0);
      }

      this.$scope.$watch(this.bindTopIndex, angular.bind(this, function (newIndex) {
        if (newIndex !== this.topIndex) {
          this.scrollToIndex(newIndex);
        }
      }));
    } else {
      this.topIndex = 0;
    }

    this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
    this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
    this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');

    // After the dom stablizes, measure the initial size of the container and
    // make a best effort at re-measuring as it changes.
    var boundUpdateSize = angular.bind(this, this.updateSize);

    $$rAF(angular.bind(this, function () {
      boundUpdateSize();

      var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
      var jWindow = angular.element($window);

      // Make one more attempt to get the size if it is 0.
      // This is not by any means a perfect approach, but there's really no
      // silver bullet here.
      if (!this.size) {
        debouncedUpdateSize();
      }

      jWindow.on('resize', debouncedUpdateSize);
      $scope.$on('$destroy', function () {
        jWindow.off('resize', debouncedUpdateSize);
      });

      $scope.$emit('$md-resize-enable');
      $scope.$on('$md-resize', boundUpdateSize);
    }));
  }


  /** Called by the md-virtual-repeat inside of the container at startup. */
  VirtualRepeatContainerController.prototype.register = function (repeaterCtrl) {
    this.repeater = repeaterCtrl;

    angular.element(this.scroller)
      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
  };


  /** @return {boolean} Whether the container is configured for horizontal scrolling. */
  VirtualRepeatContainerController.prototype.isHorizontal = function () {
    return this.horizontal;
  };


  /** @return {number} The size (width or height) of the container. */
  VirtualRepeatContainerController.prototype.getSize = function () {
    return this.size;
  };


  /**
   * Resizes the container.
   * @private
   * @param {number} size The new size to set.
   */
  VirtualRepeatContainerController.prototype.setSize_ = function (size) {
    var dimension = this.getDimensionName_();

    this.size = size;
    this.$element[0].style[dimension] = size + 'px';
  };


  VirtualRepeatContainerController.prototype.unsetSize_ = function () {
    this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
    this.oldElementSize = null;
  };


  /** Instructs the container to re-measure its size. */
  VirtualRepeatContainerController.prototype.updateSize = function () {
    // If the original size is already determined, we can skip the update.
    if (this.originalSize) return;

    this.size = this.isHorizontal()
      ? this.$element[0].clientWidth
      : this.$element[0].clientHeight;

    // Recheck the scroll position after updating the size. This resolves
    // problems that can result if the scroll position was measured while the
    // element was display: none or detached from the document.
    this.handleScroll_();

    this.repeater && this.repeater.containerUpdated();
  };


  /** @return {number} The container's scrollHeight or scrollWidth. */
  VirtualRepeatContainerController.prototype.getScrollSize = function () {
    return this.scrollSize;
  };


  VirtualRepeatContainerController.prototype.getDimensionName_ = function () {
    return this.isHorizontal() ? 'width' : 'height';
  };


  /**
   * Sets the scroller element to the specified size.
   * @private
   * @param {number} size The new size.
   */
  VirtualRepeatContainerController.prototype.sizeScroller_ = function (size) {
    var dimension = this.getDimensionName_();
    var crossDimension = this.isHorizontal() ? 'height' : 'width';

    // Clear any existing dimensions.
    this.sizer.innerHTML = '';

    // If the size falls within the browser's maximum explicit size for a single element, we can
    // set the size and be done. Otherwise, we have to create children that add up the the desired
    // size.
    if (size < this.maxElementPixels) {
      this.sizer.style[dimension] = size + 'px';
    } else {
      this.sizer.style[dimension] = 'auto';
      this.sizer.style[crossDimension] = 'auto';

      // Divide the total size we have to render into N max-size pieces.
      var numChildren = Math.floor(size / this.maxElementPixels);

      // Element template to clone for each max-size piece.
      var sizerChild = document.createElement('div');
      sizerChild.style[dimension] = this.maxElementPixels + 'px';
      sizerChild.style[crossDimension] = '1px';

      for (var i = 0; i < numChildren; i++) {
        this.sizer.appendChild(sizerChild.cloneNode(false));
      }

      // Re-use the element template for the remainder.
      sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
      this.sizer.appendChild(sizerChild);
    }
  };


  /**
   * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
   * @private
   * @param {number} size The new size.
   */
  VirtualRepeatContainerController.prototype.autoShrink_ = function (size) {
    var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());

    if (this.autoShrink && shrinkSize !== this.size) {
      if (this.oldElementSize === null) {
        this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
      }

      var currentSize = this.originalSize || this.size;

      if (!currentSize || shrinkSize < currentSize) {
        if (!this.originalSize) {
          this.originalSize = this.size;
        }

        // Now we update the containers size, because shrinking is enabled.
        this.setSize_(shrinkSize);
      } else if (this.originalSize !== null) {
        // Set the size back to our initial size.
        this.unsetSize_();

        var _originalSize = this.originalSize;
        this.originalSize = null;

        // We determine the repeaters size again, if the original size was zero.
        // The originalSize needs to be null, to be able to determine the size.
        if (!_originalSize) this.updateSize();

        // Apply the original size or the determined size back to the container, because
        // it has been overwritten before, in the shrink block.
        this.setSize_(_originalSize || this.size);
      }

      this.repeater.containerUpdated();
    }
  };


  /**
   * Sets the scrollHeight or scrollWidth. Called by the repeater based on
   * its item count and item size.
   * @param {number} itemsSize The total size of the items.
   */
  VirtualRepeatContainerController.prototype.setScrollSize = function (itemsSize) {
    var size = itemsSize + this.offsetSize;
    if (this.scrollSize === size) return;

    this.sizeScroller_(size);
    this.autoShrink_(size);
    this.scrollSize = size;
  };


  /** @return {number} The container's current scroll offset. */
  VirtualRepeatContainerController.prototype.getScrollOffset = function () {
    return this.scrollOffset;
  };

  /**
   * Scrolls to a given scrollTop position.
   * @param {number} position
   */
  VirtualRepeatContainerController.prototype.scrollTo = function (position) {
    this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
    this.handleScroll_();
  };

  /**
   * Scrolls the item with the given index to the top of the scroll container.
   * @param {number} index
   */
  VirtualRepeatContainerController.prototype.scrollToIndex = function (index) {
    var itemSize = this.repeater.getItemSize();
    var itemsLength = this.repeater.itemsLength;
    if (index > itemsLength) {
      index = itemsLength - 1;
    }
    this.scrollTo(itemSize * index);
  };

  VirtualRepeatContainerController.prototype.resetScroll = function () {
    this.scrollTo(0);
  };


  VirtualRepeatContainerController.prototype.handleScroll_ = function () {
    var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
    if (!ltr && !this.maxSize) {
      this.scroller.scrollLeft = this.scrollSize;
      this.maxSize = this.scroller.scrollLeft;
    }
    var offset = this.isHorizontal() ?
      (ltr ? this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
      : this.scroller.scrollTop;
    if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;

    var itemSize = this.repeater.getItemSize();
    if (!itemSize) return;

    var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);

    var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
      (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize)) + 'px)';

    this.scrollOffset = offset;
    this.offsetter.style.webkitTransform = transform;
    this.offsetter.style.transform = transform;

    if (this.bindTopIndex) {
      var topIndex = Math.floor(offset / itemSize);
      if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
        this.topIndex = topIndex;
        this.bindTopIndex.assign(this.$scope, topIndex);
        if (!this.$rootScope.$$phase) this.$scope.$digest();
      }
    }

    this.repeater.containerUpdated();
  };


  /**
   * @ngdoc directive
   * @name mdVRP
   * @module material.components.virtualRepeat
   * @restrict A
   * @priority 1000
   * @description
   * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
   *
   * Virtual repeat is a limited substitute for ng-repeat that renders only
   * enough DOM nodes to fill the container and recycling them as the user scrolls.
   *
   * Arrays, but not objects are supported for iteration.
   * Track by, as alias, and (key, value) syntax are not supported.
   *
   * ### On-Demand Async Item Loading
   *
   * When using the `md-on-demand` attribute and loading some asynchronous data, the `getItemAtIndex` function will
   * mostly return nothing.
   *
   * <hljs lang="js">
   *   DynamicItems.prototype.getItemAtIndex = function(index) {
   *     if (this.pages[index]) {
   *       return this.pages[index];
   *     } else {
   *       // This is an asynchronous action and does not return any value.
   *       this.loadPage(index);
   *     }
   *   };
   * </hljs>
   *
   * This means that the VirtualRepeat will not have any value for the given index.<br/>
   * After the data loading completed, the user expects the VirtualRepeat to recognize the change.
   *
   * To make sure that the VirtualRepeat properly detects any change, you need to run the operation
   * in another digest.
   *
   * <hljs lang="js">
   *   DynamicItems.prototype.loadPage = function(index) {
   *     var self = this;
   *
   *     // Trigger a new digest by using $timeout
   *     $timeout(function() {
   *       self.pages[index] = Data;
   *     });
   *   };
   * </hljs>
   *
   * > <b>Note:</b> Please also review the
   *   <a ng-href="api/directive/mdVRPContainer">VirtualRepeatContainer</a> documentation
   *   for more information.
   *
   * @usage
   * <hljs lang="html">
   * <md-virtual-repeat-container>
   *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
   * </md-virtual-repeat-container>
   *
   * <md-virtual-repeat-container md-orient-horizontal>
   *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
   * </md-virtual-repeat-container>
   * </hljs>
   *
   * @param {number=} md-item-size The height or width of the repeated elements (which must be
   *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
   *   but still assumes that all repeated nodes have same height or width.
   * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
   *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
   * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
   *   that can fetch rows rather than an array.
   *
   *   **NOTE:** This object must implement the following interface with two (2) methods:
   *
   *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
   *     loaded (it should start downloading the item in that case).
   *   - `getLength: function() [number]` The data length to which the repeater container
   *     should be sized. Ideally, when the count is known, this method should return it.
   *     Otherwise, return a higher number than the currently loaded items to produce an
   *     infinite-scroll behavior.
   */
  function VirtualRepeatDirective($parse) {
    return {
      controller: VirtualRepeatController,
      priority: 1000,
      require: ['mdVRP', '^^mdVRPContainer'],
      restrict: 'A',
      terminal: true,
      transclude: 'element',
      compile: function VirtualRepeatCompile($element, $attrs) {
        var expression = $attrs.mdVRP;
        var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
        var repeatName = match[1];
        var repeatListExpression = $parse(match[2]);
        var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);

        return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
          ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
        };
      }
    };
  }


  /** @ngInject */
  function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
    $$rAF, $mdUtil) {
    this.$scope = $scope;
    this.$element = $element;
    this.$attrs = $attrs;
    this.$browser = $browser;
    this.$document = $document;
    this.$mdUtil = $mdUtil;
    this.$rootScope = $rootScope;
    this.$$rAF = $$rAF;

    /** @type {boolean} Whether we are in on-demand mode. */
    this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
    /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
    this.browserCheckUrlChange = $browser.$$checkUrlChange;
    /** @type {number} Most recent starting repeat index (based on scroll offset) */
    this.newStartIndex = 0;
    /** @type {number} Most recent ending repeat index (based on scroll offset) */
    this.newEndIndex = 0;
    /** @type {number} Most recent end visible index (based on scroll offset) */
    this.newVisibleEnd = 0;
    /** @type {number} Previous starting repeat index (based on scroll offset) */
    this.startIndex = 0;
    /** @type {number} Previous ending repeat index (based on scroll offset) */
    this.endIndex = 0;
    // TODO: measure width/height of first element from dom if not provided.
    // getComputedStyle?
    /** @type {?number} Height/width of repeated elements. */
    this.itemSize = $scope.$eval($attrs.mdItemSize) || null;

    /** @type {boolean} Whether this is the first time that items are rendered. */
    this.isFirstRender = true;

    /**
     * @private {boolean} Whether the items in the list are already being updated. Used to prevent
     *     nested calls to virtualRepeatUpdate_.
     */
    this.isVirtualRepeatUpdating_ = false;

    /** @type {number} Most recently seen length of items. */
    this.itemsLength = 0;

    /**
     * @type {!Function} Unwatch callback for item size (when md-items-size is
     *     not specified), or angular.noop otherwise.
     */
    this.unwatchItemSize_ = angular.noop;

    /**
     * Presently rendered blocks by repeat index.
     * @type {Object<number, !VirtualRepeatController.Block}
     */
    this.blocks = {};
    /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
    this.pooledBlocks = [];

    $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
  }


  /**
   * An object representing a repeated item.
   * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
   */
  VirtualRepeatController.Block;


  /**
   * Called at startup by the md-virtual-repeat postLink function.
   * @param {!VirtualRepeatContainerController} container The container's controller.
   * @param {!Function} transclude The repeated element's bound transclude function.
   * @param {string} repeatName The left hand side of the repeat expression, indicating
   *     the name for each item in the array.
   * @param {!Function} repeatListExpression A compiled expression based on the right hand side
   *     of the repeat expression. Points to the array to repeat over.
   * @param {string|undefined} extraName The optional extra repeatName.
   */
  VirtualRepeatController.prototype.link_ =
    function (container, transclude, repeatName, repeatListExpression, extraName) {
      this.container = container;
      this.transclude = transclude;
      this.repeatName = repeatName;
      this.rawRepeatListExpression = repeatListExpression;
      this.extraName = extraName;
      this.sized = false;

      this.repeatListExpression = angular.bind(this, this.repeatListExpression_);

      this.container.register(this);
    };


  /** @private Cleans up unused blocks. */
  VirtualRepeatController.prototype.cleanupBlocks_ = function () {
    angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
      block.element.remove();
    });
  };


  /** @private Attempts to set itemSize by measuring a repeated element in the dom */
  VirtualRepeatController.prototype.readItemSize_ = function () {
    if (this.itemSize) {
      // itemSize was successfully read in a different asynchronous call.
      return;
    }

    this.items = this.repeatListExpression(this.$scope);
    this.parentNode = this.$element[0].parentNode;
    var block = this.getBlock_(0);
    if (!block.element[0].parentNode) {
      this.parentNode.appendChild(block.element[0]);
    }

    this.itemSize = block.element[0][
      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;

    this.blocks[0] = block;
    this.poolBlock_(0);

    if (this.itemSize) {
      this.containerUpdated();
    }
  };


  /**
   * Returns the user-specified repeat list, transforming it into an array-like
   * object in the case of infinite scroll/dynamic load mode.
   * @param {!angular.Scope} The scope.
   * @return {!Array|!Object} An array or array-like object for iteration.
   */
  VirtualRepeatController.prototype.repeatListExpression_ = function (scope) {
    var repeatList = this.rawRepeatListExpression(scope);

    if (this.onDemand && repeatList) {
      var virtualList = new VirtualRepeatModelArrayLike(repeatList);
      virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
      return virtualList;
    } else {
      return repeatList;
    }
  };


  /**
   * Called by the container. Informs us that the containers scroll or size has
   * changed.
   */
  VirtualRepeatController.prototype.containerUpdated = function () {
    // If itemSize is unknown, attempt to measure it.
    if (!this.itemSize) {
      // Make sure to clean up watchers if we can (see #8178)
      if (this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop) {
        this.unwatchItemSize_();
      }
      this.unwatchItemSize_ = this.$scope.$watchCollection(
        this.repeatListExpression,
        angular.bind(this, function (items) {
          if (items && items.length) {
            this.readItemSize_();
          }
        }));
      if (!this.$rootScope.$$phase) this.$scope.$digest();

      return;
    } else if (!this.sized) {
      this.items = this.repeatListExpression(this.$scope);
    }

    if (!this.sized) {
      this.unwatchItemSize_();
      this.sized = true;
      this.$scope.$watchCollection(this.repeatListExpression,
        angular.bind(this, function (items, oldItems) {
          if (!this.isVirtualRepeatUpdating_) {
            this.virtualRepeatUpdate_(items, oldItems);
          }
        }));
    }

    this.updateIndexes_();

    if (this.newStartIndex !== this.startIndex ||
      this.newEndIndex !== this.endIndex ||
      this.container.getScrollOffset() > this.container.getScrollSize()) {
      if (this.items instanceof VirtualRepeatModelArrayLike) {
        this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
      }
      this.virtualRepeatUpdate_(this.items, this.items);
    }
  };


  /**
   * Called by the container. Returns the size of a single repeated item.
   * @return {?number} Size of a repeated item.
   */
  VirtualRepeatController.prototype.getItemSize = function () {
    return this.itemSize;
  };


  /**
   * Called by the container. Returns the size of a single repeated item.
   * @return {?number} Size of a repeated item.
   */
  VirtualRepeatController.prototype.getItemCount = function () {
    return this.itemsLength;
  };


  /**
   * Updates the order and visible offset of repeated blocks in response to scrolling
   * or items updates.
   * @private
   */
  VirtualRepeatController.prototype.virtualRepeatUpdate_ = function (items, oldItems) {
    this.isVirtualRepeatUpdating_ = true;

    var itemsLength = items && items.length || 0;
    var lengthChanged = false;

    // If the number of items shrank, keep the scroll position.
    if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
      this.items = items;
      var previousScrollOffset = this.container.getScrollOffset();
      this.container.resetScroll();
      this.container.scrollTo(previousScrollOffset);
    }

    if (itemsLength !== this.itemsLength) {
      lengthChanged = true;
      this.itemsLength = itemsLength;
    }

    this.items = items;
    if (items !== oldItems || lengthChanged) {
      this.updateIndexes_();
    }

    this.parentNode = this.$element[0].parentNode;

    if (lengthChanged) {
      this.container.setScrollSize(itemsLength * this.itemSize);
    }

    // Detach and pool any blocks that are no longer in the viewport.
    Object.keys(this.blocks).forEach(function (blockIndex) {
      var index = parseInt(blockIndex, 10);
      if (index < this.newStartIndex || index >= this.newEndIndex) {
        this.poolBlock_(index);
      }
    }, this);

    // Add needed blocks.
    // For performance reasons, temporarily block browser url checks as we digest
    // the restored block scopes ($$checkUrlChange reads window.location to
    // check for changes and trigger route change, etc, which we don't need when
    // trying to scroll at 60fps).
    this.$browser.$$checkUrlChange = angular.noop;

    var i, block,
      newStartBlocks = [],
      newEndBlocks = [];

    // Collect blocks at the top.
    for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
      block = this.getBlock_(i);
      this.updateBlock_(block, i);
      newStartBlocks.push(block);
    }

    // Update blocks that are already rendered.
    for (; this.blocks[i] != null; i++) {
      this.updateBlock_(this.blocks[i], i);
    }
    var maxIndex = i - 1;

    // Collect blocks at the end.
    for (; i < this.newEndIndex; i++) {
      block = this.getBlock_(i);
      this.updateBlock_(block, i);
      newEndBlocks.push(block);
    }

    // Attach collected blocks to the document.
    if (newStartBlocks.length) {
      this.parentNode.insertBefore(
        this.domFragmentFromBlocks_(newStartBlocks),
        this.$element[0].nextSibling);
    }
    if (newEndBlocks.length) {
      this.parentNode.insertBefore(
        this.domFragmentFromBlocks_(newEndBlocks),
        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
    }

    // Restore $$checkUrlChange.
    this.$browser.$$checkUrlChange = this.browserCheckUrlChange;

    this.startIndex = this.newStartIndex;
    this.endIndex = this.newEndIndex;

    if (this.isFirstRender) {
      this.isFirstRender = false;
      var firstRenderStartIndex = this.$attrs.mdStartIndex ?
        this.$scope.$eval(this.$attrs.mdStartIndex) :
        this.container.topIndex;

      // The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
      // Introduce a slight delay so that the update happens when it is actually ready.
      this.$mdUtil.nextTick(function () {
        this.container.scrollToIndex(firstRenderStartIndex);
      }.bind(this));
    }

    this.isVirtualRepeatUpdating_ = false;
  };


  /**
   * @param {number} index Where the block is to be in the repeated list.
   * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
   * @private
   */
  VirtualRepeatController.prototype.getBlock_ = function (index) {
    if (this.pooledBlocks.length) {
      return this.pooledBlocks.pop();
    }

    var block;
    this.transclude(angular.bind(this, function (clone, scope) {
      block = {
        element: clone,
        new: true,
        scope: scope
      };

      this.updateScope_(scope, index);
      this.parentNode.appendChild(clone[0]);
    }));
    return block;
  };


  /**
   * Updates and if not in a digest cycle, digests the specified block's scope to the data
   * at the specified index.
   * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
   * @param {number} index The index to set.
   * @private
   */
  VirtualRepeatController.prototype.updateBlock_ = function (block, index) {
    this.blocks[index] = block;

    if (!block.new &&
      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
      return;
    }
    block.new = false;

    // Update and digest the block's scope.
    this.updateScope_(block.scope, index);

    // Perform digest before reattaching the block.
    // Any resulting synchronous dom mutations should be much faster as a result.
    // This might break some directives, but I'm going to try it for now.
    if (!this.$rootScope.$$phase) {
      block.scope.$digest();
    }
  };


  /**
   * Updates scope to the data at the specified index.
   * @param {!angular.Scope} scope The scope which should be updated.
   * @param {number} index The index to set.
   * @private
   */
  VirtualRepeatController.prototype.updateScope_ = function (scope, index) {
    scope.$index = index;
    scope[this.repeatName] = this.items && this.items[index];
    if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
  };


  /**
   * Pools the block at the specified index (Pulls its element out of the dom and stores it).
   * @param {number} index The index at which the block to pool is stored.
   * @private
   */
  VirtualRepeatController.prototype.poolBlock_ = function (index) {
    this.pooledBlocks.push(this.blocks[index]);
    this.parentNode.removeChild(this.blocks[index].element[0]);
    delete this.blocks[index];
  };


  /**
   * Produces a dom fragment containing the elements from the list of blocks.
   * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
   *     should be added to the document fragment.
   * @return {DocumentFragment}
   * @private
   */
  VirtualRepeatController.prototype.domFragmentFromBlocks_ = function (blocks) {
    var fragment = this.$document[0].createDocumentFragment();
    blocks.forEach(function (block) {
      fragment.appendChild(block.element[0]);
    });
    return fragment;
  };


  /**
   * Updates start and end indexes based on length of repeated items and container size.
   * @private
   */
  VirtualRepeatController.prototype.updateIndexes_ = function () {
    var itemsLength = this.items ? this.items.length : 0;
    var containerLength = Math.ceil(this.container.getSize() / this.itemSize);

    this.newStartIndex = Math.max(0, Math.min(
      itemsLength - containerLength,
      Math.floor(this.container.getScrollOffset() / this.itemSize)));
    this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
    this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
    this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
  };

  /**
   * This VirtualRepeatModelArrayLike class enforces the interface requirements
   * for infinite scrolling within a mdVRPContainer. An object with this
   * interface must implement the following interface with two (2) methods:
   *
   * getItemAtIndex: function(index) -> item at that index or null if it is not yet
   *     loaded (It should start downloading the item in that case).
   *
   * getLength: function() -> number The data legnth to which the repeater container
   *     should be sized. Ideally, when the count is known, this method should return it.
   *     Otherwise, return a higher number than the currently loaded items to produce an
   *     infinite-scroll behavior.
   *
   * @usage
   * <hljs lang="html">
   *  <md-virtual-repeat-container md-orient-horizontal>
   *    <div md-virtual-repeat="i in items" md-on-demand>
   *      Hello {{i}}!
   *    </div>
   *  </md-virtual-repeat-container>
   * </hljs>
   *
   */
  function VirtualRepeatModelArrayLike(model) {
    if (!angular.isFunction(model.getItemAtIndex) ||
      !angular.isFunction(model.getLength)) {
      throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
        'functions getItemAtIndex() and getLength() ');
    }

    this.model = model;
  }


  VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function (start, end) {
    for (var i = start; i < end; i++) {
      if (!this.hasOwnProperty(i)) {
        this[i] = this.model.getItemAtIndex(i);
      }
    }
    this.length = this.model.getLength();
  };

  /**
   * @ngdoc directive
   * @name mdFH
   * @module material.components.virtualRepeat
   * @restrict A
   * @description
   *
   * Force an element to have a certain px height. This is used in place of a style tag in order to
   * conform to the Content Security Policy regarding unsafe-inline style tags.
   *
   * @usage
   * <hljs lang="html">
   *   <div md-force-height="'100px'"></div>
   * </hljs>
   */
  function ForceHeightDirective($mdUtil) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var height = scope.$eval(attrs.mdFH) || null;

        if (height && element) {
          element[0].style.height = height;
        }
      }
    }
  }
  ForceHeightDirective.$inject = ['$mdUtil'];


})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('scrollIf', directive);

    /** @ngInject */
    function directive() {
        return function (scope, element, attributes) {
            setTimeout(function () {
                if (scope.$eval(attributes.scrollIf)) {
                    window.scrollTo(0, element[0].offsetTop - 100)
                }
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('rippler', directive);

    /** @ngInject */
    function directive() {
        return {
            replace: true,
            template: function (tElement, tAttrs) {
                var touch = "ng-touchstart='touching = true' ng-touchend='touching = false' md-ink-ripple"

                return '<div ' + touch + ' ng-transclude></div>';
            },
            scope: {},
            transclude: true,
            link: function (scope, element, attrs) {
                angular.element(element[0]).addClass('position-relative');
                scope.$watch('touching', function () {
                    var classNow = attrs.rippler;
                    if (typeof classNow !== "string" || classNow === "") classNow = "md-grey-300-bg";
                    if (scope.touching) angular.element(element[0]).addClass(classNow)
                    else angular.element(element[0]).removeClass(classNow);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('progressView', progressViewDirective);

    /** @ngInject */
    function progressViewDirective() {
        return {
            restrict: 'E',
            scope: {
                show: '=?'
            },
            templateUrl: 'app/core/directives/progress-view/progress-view.html',
            compile: function (tElement) {
                // Add class
                tElement.addClass('progress-view');
                tElement.addClass('animate-if');

                return function postLink(scope, iElement) {
                    // Methods
                 ////   scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                 ////   function cardTemplateLoaded() {
                  ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
                 ////  }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('goBack', directive);

    /** @ngInject */
    function directive() {
        return {
            restrict: 'E',
            templateUrl: 'app/core/directives/go-back/go-back.html',
            compile: function (tElement) {
                // Add class
               //// tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                 ////   scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                 ////   function cardTemplateLoaded() {
                  ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
                 ////  }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('focusOn', focusOnDirective);

    /** @ngInject */
    function focusOnDirective($timeout) {
        return function (scope, elem, attrs) {
            attrs.$observe('focusOn', function () {
                scope.focusOn = scope.$eval(attrs.focusOn);
                if (scope.focusOn) $timeout(function () {
                    elem[0].focus();
                }, 100);
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fireworks', directive);

    /** @ngInject */
    function directive() {
        return {
            replace: true,
            scope: {},
            template: function (tElement, tAttrs) {
                return '<canvas id="canvas-fireworks" class="full-height-width"></canvas>';
            },
            transclude: true,
            link: function (scope, element, attributes) {
                var fireworks;
                scope.$on('$destroy', function () {
                   if (fireworks) fireworks.endFireworks();
                });

                scope.$watch( function() {
                if (!fireworks) fireworks = new Fireworks(element[0], element.height(), element.width());
                else fireworks.updateSize(element.height(), element.width());
            } );
            }
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('PowerController', PowerController);

    /** @ngInject */
    function PowerController($scope, $animate, $mdDialog) {
        var vm = this;

        vm.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        vm.monthlyData = {};

        vm.yearTotal = 0;

        Utils.forLoop(vm.months, function (item) {
            vm.monthlyData[item] = {};
            vm.monthlyData[item].isActive = true;
            vm.monthlyData[item].name = item;
            switch (item) {
                case 'January':
                    vm.monthlyData[item].kwhUsage = 499;
                    break;
                case 'February':
                    vm.monthlyData[item].kwhUsage = 488;
                    break;
                case 'March':
                    vm.monthlyData[item].kwhUsage = 457;
                    break;
                case 'April':
                    vm.monthlyData[item].kwhUsage = 541;
                    break;
                case 'May':
                    vm.monthlyData[item].kwhUsage = 979;
                    break;
                case 'June':
                    vm.monthlyData[item].kwhUsage = 1498;
                    break;
                case 'July':
                    vm.monthlyData[item].kwhUsage = 2822;
                    break;
                case 'August':
                    vm.monthlyData[item].kwhUsage = 2853;
                    break;
                case 'September':
                    vm.monthlyData[item].kwhUsage = 551;
                    break;
                case 'October':
                    vm.monthlyData[item].kwhUsage = 574;
                    break;
                case 'November':
                    vm.monthlyData[item].kwhUsage = 445;
                    break;
                case 'December':
                    vm.monthlyData[item].kwhUsage = 495;
                    break;
            }
        });

        vm.hasCalced = false;

        vm.calculate = function () {
            vm.yearTotal = 0;
            var fivehundred = vm.fivehundred ? vm.fivehundred * .01 : 0;
            var thousand = vm.thousand ? vm.thousand * .01 : 0;
            var twothousand = vm.twothousand ? vm.twothousand * .01 : 0;

            for (var key in vm.monthlyData) {

                var month = vm.monthlyData[key];

                var kwUsage = month.kwhUsage;
                if (!kwUsage) kwUsage = 0;

                var monthCost = 0;

                if (kwUsage < 999) {
                    monthCost = fivehundred * kwUsage;
                } else if (kwUsage < 1999) {
                    monthCost = thousand * kwUsage;
                } else {
                    monthCost = twothousand * kwUsage;
                }

                if (vm.minUsageFeeActive && vm.minUsageFeeKW > kwUsage) {
                    monthCost += vm.minUsageFee;
                }

                if (vm.maxUsageFeeActive && vm.maxUsageFeeKW < kwUsage) {
                    monthCost += vm.maxUsageFee;
                }

                if (vm.underCreditActive && vm.underCreditKW > kwUsage) {
                    monthCost -= vm.underCredit;
                }

                if (vm.overCreditActive && vm.overCreditKW < kwUsage) {
                    monthCost -= vm.overCredit;
                }

                month.monthCost = monthCost;

                if (month.isActive) vm.yearTotal += monthCost;

            }

            vm.hasCalced = true;
        }

        vm.monthlyFees = [];
        vm.KWhFees = [];

        vm.addFee = function (feeType, feeArray, ev) {
            $mdDialog.show({
                controller: AddFeeController,
                templateUrl: 'app/main/power/power-add-fee.html',
                targetEvent: ev,
                locals: {
                    title: feeType
                },
                clickOutsideToClose: true,
                fullscreen: true
            })
                .then(function (fee) {
                    feeArray.push(fee);
                }, function () {
                });
        }

        function AddFeeController($mdDialog, $scope, title) {
            $scope.title = title;
            $scope.fee = {};
            $scope.hide = function () {
                $mdDialog.hide();
            }

            $scope.proceed = function (form) {
                if (form.$invalid || form.$pristine) {
                    return;
                }
                $mdDialog.hide($scope.fee);
            }
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle', [
            'app.vehicle.recalls',
            'app.vehicle.settings',
            'app.vehicle.gas',
            'app.vehicle.maintenance',
            'app.vehicle.history_report',
            'app.vehicle.image',
            'app.vehicle.details'

        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle', {
                url: '/Vehicle/:vin?animate',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle': {
                        templateUrl: 'app/main/vehicle/vehicle.html',
                        controller: 'VehicleController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null,
                    animate: null
                }
            });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle')
        .controller('VehicleController', VehicleController);

    /** @ngInject */
    function VehicleController($scope, $controller, $rootScope, $mdToast, $state, $timeout, vehicleService, $http, vehicle) {
        $scope.forceOverrideState = 'app.garage';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;



        $scope.vs = vehicleService;

        vm.estimatedImage;

        vm.estimatedImage;

        var counterSpecs = 0;

        if (mVehicle.formattedJson) for (var key in mVehicle.formattedJson) {
            counterSpecs++;
        }

        vm.specsCount = counterSpecs;

        if (mVehicle.estimatedMPG && mVehicle.estimatedMPG.trending) switch (mVehicle.estimatedMPG.trending) {
            case "DOWN":
                vm.estimatedImage = "assets/images/cartraxx/down_arrow_orange.svg";
            case "UP":
                vm.estimatedImage = "assets/images/cartraxx/up_arrow_green.svg";
            default:
                vm.estimatedImage = "assets/images/cartraxx/steady_arrow_blue.svg";
        }

        vm.shouldAnimate = $state.params.animate === "Y";

        vm.firstMaintenance = vehicleService.getFirstMaintenance();

        vm.animate = [
            vm.shouldAnimate,
            vm.shouldAnimate,
            vm.shouldAnimate,
            vm.shouldAnimate,
            vm.shouldAnimate
        ];

        $scope.valueId = '34';

        vm.showLogonNow = true;

        $timeout(function () {
            vm.showLogonNow = true;
        }, 800);

        $scope.$watch('valueId', function () {
            $scope.value =
                $scope.valueId && mVehicle.formattedJson[$scope.valueId] ?
                    mVehicle.formattedJson[$scope.valueId] : null;
        }, true);


        vm.getHeadline = vehicleService.getHeadline;

        vm.getSubHeader = vehicleService.getSubHeader;

        vm.goToSettings = function (focus) {
            $rootScope.isHeroTransition = true;
            vm.focus = focus;
            $timeout(function () {
                $state.go('app.vehicle.settings', { focus: focus });
            });
        }

        vm.goToImage = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.image');
            });
        }

        vm.recalls = function () {
            if (vehicleService.hasRecalls()) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.recalls');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Recalls')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToSpecs = function () {
            if (vm.vehicle.formattedJson) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.specs');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Specs')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.goToDetails = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.details');
            });
        }

        vm.goToOptions = function () {
            if (vm.vehicle.styleDetailsJson.options) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.options');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Options')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }
        }

        vm.maintenance = function () {

            if (vehicleService.hasMaintenance()) {
                $rootScope.isHeroTransition = true;
                $timeout(function () {
                    $state.go('app.vehicle.maintenance');
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No Maintenance')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }

        }

        vm.inputGas = function () {
            vm.loading = true;
            vehicleService.getVehiclePromise(mVehicle.vin)
                .then(function () {
                    vm.loading = false;
                    $rootScope.isHeroTransition = true;
                    $timeout(function () {
                        $state.go('app.vehicle.gas.input');
                    });
                }, function (failed) {
                    vm.loading = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(failed.data.message)
                            .position('bottom')
                            .hideDelay(3000)
                    );
                });

            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.gas.input');
            });
        }


        vm.inputMaintenance = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.maintenance.input');
            });
        }

        vm.historyReport = function () {
            $rootScope.isHeroTransition = true;
            $timeout(function () {
                $state.go('app.vehicle.history_report');
            });
        }

        vm.checkGas = function () {
            vm.loading = true;

            vehicleService.getVehiclePromise(mVehicle.vin)
                .then(function () {
                    vm.loading = false;
                    $timeout(function () {
                        if (vm.vehicle.estimatedMPG) {
                            $rootScope.isHeroTransition = true;
                            $state.go('app.vehicle.gas.view');
                        }
                        else $state.go('app.vehicle.gas.input');
                    });
                }, function (failed) {
                    vm.loading = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(failed.data.message)
                            .position('bottom')
                            .hideDelay(3000)
                    );
                });


        }

        vm.getMPG = vehicleService.getMPG;


        if (vm.shouldAnimate) {

            var counter = 0;

            var timeout_length = 400;

            var animateFunction = function () {
                vm.animate[counter] = false;
                $scope.$apply();
                counter++;
                if (counter < vm.animate.length) setTimeout(animateFunction, timeout_length);
                else {
                    vm.shouldAnimate = false;
                    $state.go('.', { animate: null }, { notify: false });
                }
            }

            setTimeout(animateFunction, 600);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vehicle')
        .controller('BaseVehicleController', BaseVehicleController);

    /** @ngInject */
    function BaseVehicleController($scope, $window, $rootScope, $state, $timeout, vehicleService) {

        var vm = this;

        vm.vehicle = mVehicle;

        $scope.vs = vehicleService;

        vm.goBack = function () {
            if (!$scope.noHeroTransitionBack) $rootScope.isHeroTransition = true;
            $timeout(function () {
                if ($scope.forceOverrideState) {
                    $state.go($scope.forceOverrideState, $state.params);
                    return;
                }
                if (!onBack()) $state.go('app.garage');
            });
        };

        $timeout(function () {
            $rootScope.isHeroTransition = false;
        }, 500);

        var originatorEv;

        vm.openMenu = function ($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.garage', [
            'app.garage.add'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.garage', {
                url: '/Garage',
                  views: {
                    'content@app': {
                        templateUrl: 'app/main/garage/garage.html',
                        controller: 'GarageController as vm'
                    }
                },
                 resolve: {
                    user: function (firebaseService) {
                        return firebaseService.getUserDataPromise();
                    }
                }
            });

              msNavigationServiceProvider.saveItem('garage', {
            title: 'Garage',
            icon: 'icon-garage',
            state: 'app.garage',
            /*stateParams: {
                'param1': 'page'
             },*/
            weight: 1
        });

                    NavItems.addItem('app.garage', "assets/images/cartraxx/garage.svg", 'Garage');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.garage')
        .controller('GarageController', GarageController);

    /** @ngInject */
    function GarageController($scope, $document, $controller, user, $rootScope, firebaseService, vehicleService, $state, $http, $timeout) {

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;
        vm.garage = [];
        vm.initialized = false;

        function loadGarage() {
            vm.loading = true;
            var url = 'https://cartraxx.azurewebsites.net/api/getHistory?type=getGarage&userId=' + user.account.uid;

            Utils.httpGet($http, url, function (garage) {
                vm.garage = garage;
                console.log(vm.garage);
                vm.initialized = true;
                vm.loading = false;
            }, function (error) {
                vm.initialized = true;
                vm.loading = false;
            });

        }
        var scroller = document.getElementById("scrollingaragenew");

        scroller.addEventListener("scroll", function(test){

         // TODO Scroll listener   console.log(scroller);

        });

        loadGarage();        

        function textColor(count) {
            if (!count || count <= 0) return { color: 'green' };
            return { color: '#FF5722' };
        }

        vm.textColor = textColor;

        function formatNumber(count) {
            if (!count || count <= 0) return 0;
            return count;
        }

        vm.formatNumber = formatNumber;

        vm.getImage = function (isTrue) {
            return !isTrue ? "assets/images/cartraxx/caution.svg" : "assets/images/cartraxx/checked.svg";
        }

        vm.recallsTitle = function (recall) {
            return recall.openRecallsCount > 0 ? recall.openRecallsCount + ' Open Recalls' : 'No Open Recalls';
        }

         vm.getMaintenanceStatusTitle = function (vehicle) {
             return (vehicle.dueMaintenanceCount > 0 ? vehicle.dueMaintenanceCount + " Maintenance Due" : "Maintenance Up to Date");
        }


        function getMakeModelYear(vehicle) {
            var headline = vehicle.make;
            if (vehicle.model) headline += " " + vehicle.model;
            if (vehicle.year) headline += " " + vehicle.year;
            return headline;
        }

        vm.getHeadline = vehicleService.getHeadline;

        vm.test = function ($index) {
            if (!(typeof $index === "number")) return;
            $timeout(function () { vm.garage[$index].color = false; }, 100);
        }


        vm.getSubHeader = vehicleService.getSubHeader;

        vm.openVehicle = function (vehicle) {
            vm.loading = true;
            vm.clickedVin = vehicle.vin;
            $rootScope.isHeroTransition = true;

            $timeout(function () {
                vehicleService.loadVehicle(vehicle.vin, function () {

                vm.vehicleImage = vehicle.vin;
                
                $timeout(function () {
                    $state.go('app.vehicle', { vin: vehicle.vin, animate : null });
                });

                }, function (failed) {
                    vm.loading = false;
                    $rootScope.isHeroTransition = false;

                    //TODO : Handle error
                });
            });


        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.achievements', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.achievements', {
                 url: '/Achievements',
                  views: {
                    'content@app': {
                      templateUrl: 'app/main/achievements/achievements.html',
                        controller: 'VehicleAchievementsController as vm'
                    }
                },
                resolve: {
                    user: function (firebaseService) {
                        return firebaseService.getUserDataPromise();
                    }
                },
                params: {
                    vin: null
                }
            });


                    NavItems.addItem('app.achievements', "assets/images/cartraxx/trophy.svg", 'Achievements');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.achievements')
        .controller('VehicleAchievementsController', VehicleAchievementsController);

    /** @ngInject */
    function VehicleAchievementsController($scope, $controller, $state, vehicleService, $window, $http) {

        $scope.forceOverrideState = 'app.garage';

        angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        var vm = this;

        $scope.test = false;

        setTimeout(function(){$scope.test = true;}, 3000);

        $scope.carfax = function () {
            $window.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getCarfaxDiscount");
        }

         $scope.vinaudit = function () {
            $window.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getVINAudit");
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes) {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if (customTheme) {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName) {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        $mdThemingProvider.theme('greenTheme')
            .primaryPalette('green');

        $mdThemingProvider.theme('orangeTheme')
            .primaryPalette('orange');

        $mdThemingProvider.theme('inputTheme')
            .primaryPalette('blue');

        $mdThemingProvider.theme('docs-dark', 'default')
            .primaryPalette('yellow')
            .dark();
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('vehicleService', vehicleService);

    /** @ngInject */
    function vehicleService($q, $http, $state, $rootScope, $firebaseStorage, firebaseService, $templateRequest) {

        var vm = {};

        vm.usedStates = [
            {
                id: 34,
                title: "Retail"
            },
            {
                id: 35,
                title: "Private Party"
            },
            {
                id: 36,
                title: "Trade-in"
            }
        ];

        vm.vehicle = {};

        vm.decodeVehiclePromise = function (vin, styleId, yearId) {

            return $q(function (resolve, reject) {

                vm.decodeVehicle(vin, styleId, yearId, function (vehicle) {
                    resolve(vehicle);
                }, function (error) {
                    reject("DECODE_FAILED");
                });

            });

        }

        vm.uploadPrimaryImage = function (vin) {
            return $q(function (resolve, reject) {

                var storageRef = firebase.storage().ref("users/" + mFirebaseUser.account.uid + "/" + vin + "/primary.jpg");
                var storage = $firebaseStorage(storageRef);
                var htmlFile = new Blob(["<html></html>"], { type: "text/html" });
                var uploadTask = storage.$put(htmlFile, { contentType: "text/html" });
                storage.$getDownloadURL().then(function (url) {
                    console.log(url);
                });

            }, function (error) {
                console.log(error);
                reject(error);
            })
                .catch(function (error) {
                    console.log(error);

                });
        }

        vm.getVehiclePrimaryImage = function (vin) {
            return $q(function (resolve, reject) {
                var storageRef = firebase.storage().ref("users/" + mFirebaseUser.account.uid + "/" + vin + "/primary.jpg");
                var storage = $firebaseStorage(storageRef);
                //   var htmlFile = new Blob(["<html></html>"], { type: "text/html" });
                //   var uploadTask = storage.$put(htmlFile, { contentType: "text/html" });
                storage.$getDownloadURL().then(function (url) {
                    resolve(url);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }

        vm.decodeVehicle = function (vin, styleId, yearId, successCallback, failCallback) {
            firebaseService.getUserDataPromise().then(function (firebaseUser) {
                if (!vin || vin.length !== 17) {
                    failCallback({ message: "invalid VIN" });
                    return;
                }

                var url = 'https://cartraxx.azurewebsites.net/api/decodeVIN?vin=' + vin + '&userId=' + mFirebaseUser.account.uid;

                if (styleId) url += "&styleId=" + styleId;
                if (yearId) url += "&yearId=" + yearId;

                Utils.httpGet($http, url, function (vehicle) {
                    switch (vehicle.resultType) {
                        case "decoded":
                            gotVehicle(vehicle);
                        default:
                            successCallback(vehicle);
                    }
                }, function (error) {
                    failCallback(error.data);
                });

            }, function (error) {
                failCallback(error);
            });
        }

        vm.loadVehicle = function (vin, successCallback, failCallback) {

            if (mVehicle && mVehicle.vin === vin) {
                successCallback(mVehicle);
                return;
            }

            firebaseService.getUserDataPromise().then(function (firebaseUser) {

                var url = 'https://cartraxx.azurewebsites.net/api/getVIN?userId=' + firebaseUser.account.uid + '&vin=' + vin + '&includeColumns=';

                if (!mFirebaseUser) mFirebaseUser = firebaseUser;

                Utils.httpGet($http, url, function (vehicle) {

                    gotVehicle(vehicle);

                    successCallback(mVehicle);

                }, failCallback);

            }, function (error) {
                failCallback(404, error);
            });
        }

        function gotVehicle(vehicle) {
            if (vehicle.hasOwnProperty('gasJson' && !vehicle.gasJson)) vehicle.gasJson = {};
            mVehicle = vehicle;
            vm.vehicle = vehicle;
            console.log(mVehicle);
        };

        var vehiclePromiseJson = {};

        vm.getVehiclePromise = function (vin) {

            if (vehiclePromiseJson[vin]) return vehiclePromiseJson[vin];

            vehiclePromiseJson[vin] = $q(function (resolve, reject) {

                firebaseService.getUserDataPromise().then(function (firebaseUser) {

                    if (!vin) {
                        if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
                        return reject("VEHCILE_GET_FAILED");
                    }

                    vm.loadVehicle(vin, function (vehicle) {
                        if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
                        resolve(vehicle);
                    }, function (code, fail) {
                        if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
                        reject("VEHCILE_GET_FAILED");
                    });

                }, function (error) {
                    if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
                    reject(error);
                });
            });

            return vehiclePromiseJson[vin];
        }

        vm.getRecallsPromise = function (vin, openedOnly) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var recalls = vm.getRecalls(openedOnly);
                            if (recalls.length > 0) {
                                resolve(recalls);
                            } else {
                                reject(openedOnly ? "NO_OPEN_RECALLS" : "NO_RECALLS")
                            }
                        } catch (e) {
                            reject("NO_RECALLS");
                        }
                    })
                    .then(function (failed) {
                        reject("NO_RECALLS");
                    });
            });

        }


        vm.getNHTSAPromise = function (vin, openedOnly) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            console.log(vehicle);
                            if (vehicle.nhtsaInfoJson.id) {
                                resolve(vehicle.nhtsaInfoJson);
                            } else {
                                reject("__NO_NHTSA")
                            }
                        } catch (e) {
                            reject("__NO_NHTSA");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_NHTSA");
                    });
            });

        }

        function nhtsaBase(vin, trueIf, failMessage) {
            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getNHTSAPromise(vin)
                    .then(function (nhtsa) {
                        try {
                            console.log(nhtsa);
                            var item = trueIf(nhtsa);
                            console.log(item);
                            if (item) {
                                resolve(item);
                            } else {
                                reject(failMessage)
                            }
                        } catch (e) {
                            reject(failMessage);
                        }
                    })
                    .then(function (failed) {
                        reject(failMessage);
                    });
            });
        }

        function baseVehiclePromise(vin, trueIf, failMessage) {
            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var item = trueIf(vehicle);
                            if (item) {
                                resolve(item);
                            } else {
                                reject(failMessage)
                            }
                        } catch (e) {
                            reject(failMessage);
                        }
                    })
                    .then(function (failed) {
                        reject(failMessage);
                    });
            });
        }

        vm.getNHTSAComplaintsPromise = function (vin, openedOnly) {

            var func = function (vehicle) {
                if (vehicle.nhtsaInfoJson.complaintsJson.length > 0) return vehicle.nhtsaInfoJson.complaintsJson;
                return null;
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_COMPLAINTS");

        }

        vm.getNHTSAComplaintItemPromise = function (vin, id, openedOnly) {

            var func = function (vehicle) {
                return Utils.listContains(vehicle.nhtsaInfoJson.complaintsJson, function (item) { return item.nhtsaIdNumber == id });
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_COMPLAINTS_ITEM");

        }

        vm.getNHTSACrashTestPromise = function (vin, openedOnly) {

            var func = function (nhtsa) {
                if (nhtsa.crashTestJson.length > 0) return nhtsa.crashTestJson;
                return false;
            };

            return nhtsaBase(vin, func, "__NO_NHTSA_CRASH_TEST");

        }

        vm.getNHTSAInvestigationsPromise = function (vin, openedOnly) {

            var func = function (nhtsa) {
                if (nhtsa.investigationsJson.length > 0) return nhtsa.investigationsJson;
                return null;
            };

            return nhtsaBase(vin, func, "__NO_NHTSA_INVESTIGATIONS");

        }

        vm.getNHTSAManComPromise = function (vin, openedOnly) {

            var func = function (vehicle) {
                if (vehicle.nhtsaInfoJson.manufacturerCommJson.length > 0) return vehicle.nhtsaInfoJson.manufacturerCommJson;
                return null;
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS");

        }

        vm.getNHTSAManComItemPromise = function (vin, id, openedOnly) {

            var func = function (vehicle) {
                return Utils.listContains(vehicle.nhtsaInfoJson.manufacturerCommJson, function (item) { return item.nhtsaIdNumber == id });
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_MAN_COMM_ITEM");

        }

        vm.getNHTSACrashPromise = function (vin, openedOnly) {

            var func = function (vehicle) {
                if (vehicle.nhtsaInfoJson.crashTestJson.length > 0) return vehicle.nhtsaInfoJson.crashTestJson;
                return null;
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS");

        }

        vm.getNHTSACrashItemPromise = function (vin, id, openedOnly) {

            var func = function (vehicle) {
                return Utils.listContains(vehicle.nhtsaInfoJson.crashTestJson, function (item) { return item.type == id });
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_MAN_COMM_ITEM");

        }

        vm.getNHTSAInvestigationsPromise = function (vin, openedOnly) {

            var func = function (vehicle) {
                if (vehicle.nhtsaInfoJson.investigationsJson.length > 0) return vehicle.nhtsaInfoJson.investigationsJson;
                return null;
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS");

        }

        vm.getNHTSAInvestigationsItemPromise = function (vin, id, openedOnly) {

            var func = function (vehicle) {
                return Utils.listContains(vehicle.nhtsaInfoJson.investigationsJson, function (item) { return item.nhtsaActionNumber == id });
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM");

        }

        vm.getNHTSARecFeaturesPromise = function (vin, openedOnly) {

            var func = function (vehicle) {
                if (vehicle.nhtsaInfoJson.recommendedFeaturesJson.length > 0) return vehicle.nhtsaInfoJson.recommendedFeaturesJson;
                return null;
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS");

        }

        vm.getNHTSARecFeaturesItemPromise = function (vin, id, openedOnly) {

            var func = function (vehicle) {
                console.log(vehicle.nhtsaInfoJson.recommendedFeaturesJson[id]);
                return vehicle.nhtsaInfoJson.recommendedFeaturesJson[id];      
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM");

        }
 
        vm.getNHTSASafetyFeaturesItemPromise = function (vin, id, openedOnly) {

            var func = function (vehicle) {
                return vehicle.nhtsaInfoJson.safetyFeaturesJson[id];
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM");

        }


        vm.getNHTSASafetyFeaturesPromise = function (vin, openedOnly) {

            var func = function (nhtsa) {
                if (nhtsa.safetyFeaturesJson.length > 0) return nhtsa.safetyFeaturesJson;
                return null;
            };

            return nhtsaBase(vin, func, "__NO_NHTSA_SAFETY_FEAT");

        }

        vm.getBulletinsPromise = function (vin, openedOnly) {

            var func = function (vehicle) {
                if (vehicle.bulletinsJson.serviceBulletinHolder.length > 0) return vehicle.bulletinsJson.serviceBulletinHolder;
                return null;
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS");

        }

        vm.getBulletinsItemPromise = function (vin, id, openedOnly) {
            var func = function (vehicle) {
                return Utils.listContains(vehicle.bulletinsJson.serviceBulletinHolder, function (item) { return item.id == id });
            };

            return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM");

        }



        vm.getRecallsItem = function (recallId) {
            var recalls = vm.getRecalls();
            for (var i = 0; i < recalls.length; i++) {
                if (recalls[i].recallNumber === recallId) return recalls[i];
            }
            return null;
        }

        vm.getMilesAndMonthText = function (item) {
            var text = '';
            if (item.intervalMileage) text += item.intervalMileage;
            if (item.intervalMileage && item.intervalMonth) text += " , ";
            if (item.intervalMonth) text += item.intervalMonth;
        }

        vm.getRecallItemPromise = function (vin, recallId) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getRecallsPromise(vin)
                    .then(function (recalls) {
                        var item = vm.getRecallsItem(recallId);
                        if (item) {
                            resolve(item);
                        } else {
                            reject("NO_RECALL_ITEM");
                        }
                    })
                    .then(function (failed) {
                        reject("NO_RECALL_ITEM");
                    });
            });
        }

        vm.getVehicleSpecsPromise = function (vin) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var specs = vm.getSpecsArray();
                            if (specs.length > 0) {
                                resolve(specs);
                            } else {
                                reject("__NO_SPECS")
                            }
                        } catch (e) {
                            reject("__NO_SPECS");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_SPECS");
                    });
            });

        }

        vm.getSpecsArray = function () {
            if (!mVehicle || !mVehicle.formattedJson) return null;
            var arrayItem = [];
            var index = 0;
            for (var key in mVehicle.formattedJson) {
                mVehicle.formattedJson[key].literalIndex = index;
                arrayItem.push(mVehicle.formattedJson[key]);
                index++;
            }
            return arrayItem;
        }

        vm.getVehicleOptionsPromise = function (vin) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var options = vm.getOptions();
                            if (options.length > 0) {
                                resolve(options);
                            } else {
                                reject("__NO_OPTIONS")
                            }
                        } catch (e) {
                            reject("__NO_OPTIONS");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_OPTIONS");
                    });
            });

        }

        vm.getOptions = function () {
            if (!mVehicle || !mVehicle.styleDetailsJson || !mVehicle.styleDetailsJson.options) return null;
            return mVehicle.styleDetailsJson.options;
        }

        vm.getVehicleOptionItemsPromise = function (vin, category) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehicleOptionsPromise(vin)
                    .then(function (optionsList) {
                        try {
                            var option = Utils.listContains(optionsList, function (item) { return item.category === category });
                            var options = option.options;
                            if (options.length > 0) {
                                resolve(option);
                            } else {
                                reject("__NO_OPTION_ITEMS")
                            }
                        } catch (e) {
                            reject("__NO_OPTION_ITEMS");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_OPTION_ITEMS");
                    });
            });

        }


        vm.getVehicleOptionItemsItemPromise = function (vin, category, itemId) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehicleOptionItemsPromise(vin, category)
                    .then(function (options) {
                        try {
                            var item = Utils.listContains(options.options, function (item) { return item.id === itemId });
                            if (item) {
                                resolve(item);
                            } else {
                                reject("__NO_OPTION_ITEMS_ITEM")
                            }
                        } catch (e) {
                            reject("__NO_OPTION_ITEMS_ITEM");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_OPTION_ITEMS_ITEM");
                    });
            });

        }

        vm.getVehicleStandardPromise = function (vin) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var standard = vm.getStandardArray();
                            if (standard.length > 0) {
                                resolve(standard);
                            } else {
                                reject("__NO_STANDARD")
                            }
                        } catch (e) {
                            reject("__NO_STANDARD");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_STANDARD");
                    });
            });

        }


        vm.getVehicleStandardItemPromise = function (vin, itemId) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehicleStandardPromise(vin)
                    .then(function (standard) {
                        try {
                            for (var i = 0; i < standard.length; i++) {
                                if (standard[i].id === itemId) {
                                    if (standard[i].attributes.length > 0) {
                                        resolve(standard[i]);
                                        return;
                                    }
                                }
                            }
                            reject("__NO_STANDARD_ITEM")
                        } catch (e) {
                            reject("__NO_STANDARD_ITEM");
                        }
                    })
                    .then(function (failed) {
                        reject("__NO_STANDARD");
                    });
            });

        }

        vm.getStandardArray = function () {
            if (!mVehicle || !mVehicle.standardJson || !mVehicle.standardJson.equipment) return null;
            return mVehicle.standardJson.equipment;
        }

        vm.getMaintenancePromise = function (vin) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var Maintenance = vehicle.formattedMaintenanceJson;
                            for (var key in Maintenance) {
                                resolve(Maintenance);
                                return;
                            }
                            reject("NO_MAINTENANCE");
                        } catch (e) {
                            reject("NO_MAINTENANCE");
                        }
                    })
                    .then(function (failed) {
                        reject("NO_MAINTENANCE");
                    });
            });
        }

        vm.getMaintenanceItemPromise = function (vin, itemId) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getMaintenancePromise(vin)
                    .then(function (Maintenance) {
                        try {
                            for (var key in Maintenance) {
                                if (Maintenance[key].id != itemId) continue;
                                resolve(Maintenance[key]);
                                return;
                            }
                            reject("NO_MAINTENANCE_ITEM");
                        } catch (e) {
                            reject("NO_MAINTENANCE_ITEM");
                        }
                    })
                    .then(function (failed) {
                        reject("NO_MAINTENANCE_ITEM");
                    });
            });
        }

        vm.getGasPromise = function (vin) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getVehiclePromise(vin)
                    .then(function (vehicle) {
                        try {
                            var gas = vehicle.gasJson;
                            for (var key in gas) {
                                resolve(gas);
                                return;
                            }
                            reject("NO_GAS");
                        } catch (e) {
                            reject("NO_GAS");
                        }
                    })
                    .then(function (failed) {
                        reject("NO_GAS");
                    });
            });
        }

        vm.getGasItemPromise = function (vin, itemId) {

            return $q(function (resolve, reject) {
                if (!vin) vin = $state.params.vin;

                vm.getGasPromise(vin)
                    .then(function (gas) {
                        try {
                            if (gas.hasOwnProperty(itemId)) {
                                resolve(gas[itemId]);
                            } else {
                                reject("NO_GAS_ITEM");
                            }
                        } catch (e) {
                            reject("NO_GAS_ITEM");
                        }
                    })
                    .then(function (failed) {
                        reject("NO_GAS_ITEM");
                    });
            });
        }

        vm.updateVehicle = function (data, successCallback, failCallback) {
            Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=update',
                data,
                function (success) {
                    gotVehicle(success);
                    successCallback(success);
                }, failCallback);
        }

        vm.updateGas = function (data, successCallback, failCallback) {
            Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=updateGas&vin=' + mVehicle.vin,
                data,
                function (vehicle) {
                    gotVehicle(vehicle);
                    successCallback(vehicle);
                }, failCallback);
        }

        vm.getHeadline = function (vehicle) {
            return vehicle.nickname ? vehicle.nickname : vm.getMakeModelYear(vehicle);
        }

        vm.getSubHeader = function (vehicle) {
            return !vehicle.nickname ? vehicle.vin : vm.getMakeModelYear(vehicle);
        }

        vm.getMakeModelYear = function (vehicle) {
            var headline = vehicle.make;
            if (vehicle.model) headline += " " + vehicle.model;
            if (vehicle.year) headline += " " + vehicle.year;
            return headline;
        }

        vm.getOpenRecallsCount = function () {
            try {
                var count = mVehicle.nhtsaInfoJson.openRecallsCount;
                if (typeof count !== "number" || count < 0) count = 0;
                return count;
            } catch (e) {
            }
            return 0;
        }

        vm.hasOpenRecalls = function () {
            return (vm.getOpenRecallsCount() > 0);
        }

        vm.hasRecalls = function () {

            try {
                for (var key in mVehicle.nhtsaInfoJson.recallsJson) {
                    return true;
                }
            } catch (e) {

            }
            return false;
        }

        vm.getRecalls = function (onlyOpened) {

            var tempRecallsList = [];

            try {
                for (var key in mVehicle.nhtsaInfoJson.recallsJson) {
                    if (onlyOpened && !mVehicle.nhtsaInfoJson.recallsJson[key].isOpenRecall) continue;
                    tempRecallsList.push(mVehicle.nhtsaInfoJson.recallsJson[key]);
                }
            } catch (e) {

            }

            return tempRecallsList;
        }

        vm.getOpenRecalls = function () {
            return vm.getRecalls(true);
        }


        vm.getOpenRecallsImage = function (recall) {
            return (recall ? recall.isOpenRecall : vm.hasOpenRecalls()) ? "assets/images/cartraxx/caution.svg" : "assets/images/cartraxx/checked.svg";
        }

        vm.getGoodImage = function (isGood) {
            return !isGood ? "assets/images/cartraxx/caution.svg" : "assets/images/cartraxx/checked.svg";
        }

        vm.recallsTitle = function () {
            return vm.hasOpenRecalls() ? vm.getOpenRecallsCount() + ' Open Recalls' : 'No Open Recalls';
        }

        vm.getDueMaintenanceCount = function () {
            try {
                var count = mVehicle.dueMaintenanceCount;
                if (typeof count !== "number" || count < 0) count = 0;
                return count;
            } catch (e) {

            }
            return 0;
        }

        vm.getOdometer = function () {
            try {
                var count = mVehicle.odometer;
                if (typeof count !== "number" || count < 0) count = 0;
                return count;
            } catch (e) {

            }
            return 0;
        }

        vm.hasDueMaintenanceCount = function () {
            return vm.getDueMaintenanceCount() > 0;
        }

        vm.getMaintenanceStatusImage = function (maintenanceItem) {
            if (!maintenanceItem ? vm.hasDueMaintenanceCount() : maintenanceItem.duePercentage > 1) {
                return "assets/images/cartraxx/car-repair_due.png";
            } else {
                return "assets/images/cartraxx/car-repair_good.png";
            }
        }

        vm.getMaintenanceStatusTitle = function () {
            if (vm.hasDueMaintenanceCount()) {
                return vm.getDueMaintenanceCount() + " Maintenance Overdue";
            } else {
                return "Maintenance Up to Date";
            }
        }

        vm.componentsToString = function (recall) {
            try {
                var formatted = "";
                for (var i = 0; i < recall.components.length; i++) {
                    var comp = recall.components[i];
                    formatted += comp.name;
                    if (i > 0) formatted += " : ";
                }
                return formatted;
            } catch (e) {

            }
            return "";
        }

        vm.getMaintenance = function () {
            try {
                for (var key in vm.vehicle.formattedMaintenanceJson) {
                    return vm.vehicle.formattedMaintenanceJson;
                }
            } catch (e) {

            }
            return {};
        }

        vm.getMaintenanceArray = function (sort, andTracking) {
            var arrayOf = [];
            var items = vm.getMaintenance();
            for (var key in items) {
                items[key].keyId = key;
                arrayOf.push(items[key]);
            }

            var sortByStatus = function (a, b) {
                if (!a.status && !b.status) return 0;
                if (!a.status) return 1;
                if (!b.status) return -1;
                if (a.status < b.status) return 1;
                if (a.status > b.status) return -1;
                return 0;
            };

            var sortByTitle = function (a, b) {
                var aAI = a.action + a.item;
                var bAI = b.action + b.item;
                if (aAI < bAI) return -1;
                if (aAI > bAI) return 1;
                return 0;
            };

            var sortByPercentage = function (a, b) {
                if (a.duePercentage > b.duePercentage) return -1;
                if (a.duePercentage < b.duePercentage) return 1;
                return 0;
            }


            var sortBy;

            if (!sort || sort === "title") {
                sortBy = sortByTitle;
            } else if (sort === "status") {
                sortBy = sortByStatus;
            } else if (sort === "percentage") {
                sortBy = sortByPercentage;
            } else {
                sortBy = sortByTitle;
            }

            arrayOf.sort(sortBy);

            var length = arrayOf.length;

            if (andTracking) for (var i = 0; i < length; i++) {
                if (arrayOf[i].tracking) continue;
                arrayOf.move(i, arrayOf.length - 1);
                i--;
                length--;

            }

            return arrayOf;
        }

        vm.hasMaintenance = function () {
            for (var key in vm.getMaintenance()) {
                return true;
            }
            return false;
        }

        vm.getFirstRecall = function () {
            var recallsItem = vm.getRecalls();

            return (recallsItem && recallsItem.length > 0) ? recallsItem[0] : null;
        }

        vm.getFirstMaintenance = function () {
            try {
                for (var key in vm.vehicle.formattedMaintenanceJson) {
                    return vm.vehicle.formattedMaintenanceJson[key];
                }
            } catch (e) {

            }
            return null;
        }

        vm.addMaintanceRepair = function (data, successCallback, failCallback) {
            var url = 'https://cartraxx.azurewebsites.net/api/maintenance?userId=' + mFirebaseUser.account.uid + '&type=newMaintenanceDone'
                + '&vin=' + mVehicle.vin;

            Utils.httpPost($http, url, data, function (result) {
                gotVehicle(result);
                if (typeof successCallback === "function") successCallback(mVehicle);
            }, failCallback);
        }

        vm.udpateMaintenanceTracking = function (data, successCallback, failCallback) {
            var url = 'https://cartraxx.azurewebsites.net/api/maintenance?userId=' + mFirebaseUser.account.uid + '&type=updateTrackedItems'
                + '&vin=' + mVehicle.vin;

            Utils.httpPost($http, url, data, function (result) {
                gotVehicle(result);
                if (typeof successCallback === "function") successCallback(mVehicle);
            }, failCallback);
        }

        vm.deleteVehicle = function (vin, ev) {

            return $q(function (resolve, reject) {

                var url = 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=deleteVehicle'
                    + '&vin=' + vin;

                var data = {
                    vin: vin
                };

                Utils.httpPost($http, url, data, function (result) {
                    resolve();
                    getVehicle(undefined);
                }, reject);

            });

        }

        return vm;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('firebaseService', firebaseService)
        .factory("Auth", ["$firebaseAuth",
            function ($firebaseAuth) {
                return $firebaseAuth();
            }]);

    /** @ngInject */
    function firebaseService($firebaseAuth, appProxy, $timeout, $q, Auth, $firebaseObject, $firebaseArray, $window, $mdDialog, $rootScope, $state) {

        var vm = {};

        Auth.$onAuthStateChanged(function (firebaseUser) {
        });

        var gettingUserDataPromise;

        var afterUserSignedIn = function (firebaseUser, resolve, reject, extraData) {

            if (!extraData) extraData = {};

            try {
                if (mFirebaseUser.account.uid !== firebaseUser.uid) {
                    clearUser();
                    mFirebaseUser.account = firebaseUser;
                }
            } catch (e) {
                clearUser();
                mFirebaseUser.account = firebaseUser;
            }

            var counter = 0;

            var check = function () {
                counter++;

                if (counter !== 2) return;

                $rootScope.firebaseUser = mFirebaseUser;

                gettingUserDataPromise = undefined;

                if (!mDeviceInfo) appProxy.deviceInfo({ userUID: mFirebaseUser.account.uid })
                    .then(function (data) {
                        if (!mFirebaseUser.settings.devices) mFirebaseUser.settings.devices = {};
                        mFirebaseUser.settings.devices[data.deviceId] = data;
                        mFirebaseUser.settings.$save().then(function (ref) {

                        }, function (error) {
                            console.log("Error:", error);
                        });

                        appProxy.storeDataPreferences(data);

                    }, function (error) {

                    });

                if (extraData.requireEmailVerification && !mFirebaseUser.account.isAnonymous && !mFirebaseUser.account.emailVerified) {
                    reject("EMAIL_VERIFICATION_REQUIRED");

                } else {
                    resolve(mFirebaseUser);
                }

            };

            if (!mFirebaseUser.settings.$ref || mFirebaseUser.settings.$ref().key !== firebaseUser.uid) mFirebaseUser.settings = $firebaseObject(firebase.database().ref().child("userSettings/" + firebaseUser.uid));
            if (!mFirebaseUser.global.$destroy) mFirebaseUser.global = $firebaseObject(firebase.database().ref().child("appSettings"));

            mFirebaseUser.settings.$loaded().then(check);
            mFirebaseUser.global.$loaded().then(check);
        };

        function checkUserValidity(data) {
            if (!data) data = {};

        }

        vm.getUserDataPromise = function (requireEmailVerification) {

            if (typeof requireEmailVerification === "undefined") {
                requireEmailVerification = true;
            }

            var extraData = {
                requireEmailVerification: requireEmailVerification
            };

            if (!gettingUserDataPromise) {
                gettingUserDataPromise = $q(function (resolve, reject) {

                    if (mFirebaseUser.account.$signOut) {
                        resolve(mFirebaseUser);
                        return;
                    }

                    var temp = function (user) {
                        afterUserSignedIn(user, resolve, reject, extraData);
                    };

                    Auth.$requireSignIn(false).then(temp, function (error) {
                        Auth.$signInAnonymously().then(temp).catch(function (error) {
                            gettingUserDataPromise = undefined;
                            reject(error);
                        });
                    });

                });
            }

            return gettingUserDataPromise;

        }

        //Run on startup
        vm.getUserDataPromise();


        vm.reloadUser = function () {

            return $q(function (resolve, reject) {

                var temp = function (user) {
                    afterUserSignedIn(Auth.$getAuth(), resolve, reject);
                };

                $firebaseAuth().$getAuth().reload().then(temp, reject).catch(reject);

            });
        }

        function createUserWithEmailAndPassword(email, password, displayName, callback, ev) {

            var success = function (firebaseUser) {

                sendEmailVerification(firebaseUser, function (isEmailVerified, sentEmail, message) {
                    if (isEmailVerified) {
                        $state.go('app.garage');
                    } else if (message) {
                        if (Utils.isFunction(callback)) callback(false, message);
                    }
                });

                firebaseUser.updateProfile({ 'displayName': displayName }).then(function () {
                    firebaseUser.reload().then(function () {
                    }, function (error) {
                    });
                }, function (error) {

                });
            };

            var failed = function (error) {

                if (error.code === "auth/email-already-in-use") {
                    signInEmail(email, password, function (result, message) {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Error')
                                .textContent(error.message)
                                .ariaLabel('Alert Dialog Demo')
                                .ok("OK")
                                .targetEvent(ev)
                        );
                        if (message && Utils.isFunction(callback)) callback(result, message);
                    }, ev, true);
                    return;
                }

                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Error')
                        .textContent(error.message)
                        .ariaLabel('Alert Dialog Demo')
                        .ok("OK")
                        .targetEvent(ev)
                );

                if (callback && typeof callback === 'function') callback(false, error);


            };

            if (!mFirebaseUser || !mFirebaseUser.account || mFirebaseUser.account.isAnonymous) {
                $firebaseAuth().$createUserWithEmailAndPassword(email, password)
                    .then(success, failed).catch(failed);
            } else {
                var credential = firebase.auth.EmailAuthProvider.credential(email, password);
                mFirebaseUser.account.link(credential).then(success, failed);
            }


        }

        function signOut(ev) {
            var confirm = $mdDialog.confirm()
                .title('Sign Out')
                .textContent("Are you sure you would like to log out?")
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                clearUser();
                $rootScope.firebaseUser = undefined;
                $firebaseAuth().$signOut().then(function () {
                    $state.go('app.settings_login');
                });
            }, function () {
            });

        }

        function getFirebaseObj(refPath) {
            var ref = firebase.database().ref().child(refPath); // assume value here is { foo: "bar" }
            return $firebaseObject(ref);
        }

        function signInEmail(email, password, callback, ev, dontHandleErrorDialog) {
            $firebaseAuth().$signInWithEmailAndPassword(email, password).then(function (firebaseUsertemp) {
                sendEmailVerification(firebaseUsertemp, function (isEmailVerified, sentEmail, message) {
                    if (isEmailVerified) {
                        $state.go('app.garage');
                    } else if (message) {
                        if (Utils.isFunction(callback)) callback(false, message);
                    }
                });
            }).catch(function (error) {
                if (!dontHandleErrorDialog) $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Auth Failed')
                        .textContent(error.message)
                        .ariaLabel('Alert Dialog Demo')
                        .ok("OK")
                        .targetEvent(ev)
                );
                if (Utils.isFunction(callback)) callback(false, error.message);
            });
        }

        function sendEmailVerification(user, callback) {
            if (user) {
                if (user.emailVerified) {
                    if (callback && typeof callback === 'function') callback(true, false, "User is verified");
                } else {
                    user.sendEmailVerification();
                    //  if (callback && typeof callback === 'function') callback(false, true);
                    if ($state.current.name !== 'app.settings_emailverify') $state.go('app.settings_emailverify');
                }
            } else {
                if (callback && typeof callback === 'function') callback(false, "No logged on user");
            }
        }

        function signInWithGoogle(callback, ev) {

            var errorFunc = function (error) {
                if (typeof error === "string" && error.startsWith("__")) {
                    signInThirdParty("google", "Google Authentication Failed", callback, ev);
                } else {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Auth Failed')
                            .textContent(error)
                            .ariaLabel('Alert Dialog Demo')
                            .ok("OK")
                    );
                    callback();
                }
            };

            appProxy.attemptGoogleSignIn().then(function (data) {
                applyIdToken("google", "Google Authentication Failed", data.token);
            }, errorFunc).catch(errorFunc);
        }

        function applyIdToken(provider, failMessage, token) {

            var dialog = function (error) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Auth Failed')
                        .textContent(error.message)
                        .ariaLabel('Alert Dialog Demo')
                        .ok("OK")
                );
            };

            var error = function (error) {
                if (error.code === "auth/credential-already-in-use") {
                    logon(error.credential);
                    return;
                }
            };

            var logon = function (credential) {
                firebase.auth().signInWithCredential(credential).then(function (user) {
                    $state.go('app.garage');
                }).catch(function (error) {
                    dialog(error);
                });
            }
            // Build Firebase credential with the Google ID token.
            var credential = provider === "google" ? firebase.auth.GoogleAuthProvider.credential(token) : firebase.auth.GoogleAuthProvider.credential(token);

            if (mFirebaseUser && mFirebaseUser.account && mFirebaseUser.account.isAnonymous) {
                // Sign in with credential from the Google user.
                mFirebaseUser.account.linkWithCredential(credential).then(function (user) {
                    $state.go('app.garage');
                }, error);
            } else {
                logon(credential);
            }

        }

        function redirectInit() {

            var dialog = function (error) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Auth Failed')
                        .textContent(error.message)
                        .ariaLabel('Alert Dialog Demo')
                        .ok("OK")
                );
            };

            var resultFunc = function (result) {
                if (result.credential) {
                    // console.log(result);
                }
            };

            var errorFunc = function (error) {
                if (error.code === "auth/credential-already-in-use") {
                    firebase.auth().signInWithCredential(error.credential).then(function (user) {
                        $state.go('app.garage');
                    }).catch(function (error) {
                        dialog(error);
                    });
                    return;
                }

                dialog(error);
            };

            firebase.auth().getRedirectResult().then(resultFunc).catch(errorFunc);

        }

        redirectInit();

        function signInThirdParty(provider, failMessage, callback, ev) {

            var resultFunc = function (result) {
                //    $state.go('app.garage');
            };

            var errorFunc = function (error) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Auth Failed')
                        .textContent(error.message)
                        .ariaLabel('Alert Dialog Demo')
                        .ok("OK")
                );
            };

            if (mFirebaseUser && mFirebaseUser.account && mFirebaseUser.account.isAnonymous) {

                switch (provider) {
                    case "google":
                        provider = new firebase.auth.GoogleAuthProvider();
                        break;
                }
                mFirebaseUser.account.linkWithRedirect(provider);
                //   
            } else {
                $firebaseAuth().$signInWithRedirect(provider).then(resultFunc).catch(errorFunc);
            }

        }

        var temp = {
            signInEmail: signInEmail,
            getFirebaseObj: getFirebaseObj,
            signOut: signOut,
            createUserWithEmailAndPassword: createUserWithEmailAndPassword,
            sendEmailVerification: sendEmailVerification,
            signInWithGoogle: signInWithGoogle,
        };

        for (var key in temp) {
            vm[key] = temp[key];
        }

        return vm;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('dialogsService', dialogsService);

    /** @ngInject */
    function dialogsService($mdDialog, $state, $http, $templateRequest) {

        function showMessageDialog(titleOf, messageOf, buttonText, callback) {

            var alert = $mdDialog.alert({
                title: titleOf,
                textContent: messageOf,
                ok: buttonText
            });

            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                });

        }

        function showDialog(titleOf, messageOf, yesButton, noButton, dontClickOutToClose, callback) {
            showBasicChoiceDialog(titleOf, messageOf, yesButton, noButton, dontClickOutToClose, callback);
        }


        function showBasicChoiceDialog(titleOf, messageOf, yesButton, noButton, dontClickOutToClose, callback) {

            $mdDialog.show({
                controller: 'BasicDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/services/dialogs/generic_yes_no/basic_dialog.html',
                clickOutsideToClose: (dontClickOutToClose ? false : true),
                locals: {
                    title: titleOf,
                    message: messageOf,
                    yesButtonTitle: yesButton,
                    noButtonTitle: noButton
                }
            }).then(callback);
        }

        function showProgressDialog(title, message, allowClickOutsideToClose) {

            showSpinnerDialog(title, message, allowClickOutsideToClose);
        }

        function showSpinnerDialog(titleOf, messageOf, allowClickOutsideToClose) {

            $mdDialog.show({
                controller: 'VINDecodedProgressDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/services/dialogs/progress_dialog/progress-dialog.html',
                //  parent: angular.element($document.find('#content-container')),
                //////  clickOutsideToClose: allowClickOutsideToClose ? true : false,
                clickOutsideToClose: true,
                locals: {
                    message: messageOf,
                    title: titleOf,
                    clickOutsideToClose: allowClickOutsideToClose ? true : false
                }
            });
        }

        function emailVerificationDialog(callback) {

            $mdDialog.show({
                controller: 'EmailVerificationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/services/dialogs/email_verification/email_verification.html',
            }).then(function () {
            });
        }

        function embedDialog(html, controller, title, clickOutsideToClose, callback) {

            $templateRequest(html).then(function (template) {

                var embedHtml = "<md-dialog class='md-blue-grey-50-bg' style='width:75%;'>" +
                    "<md-toolbar class='md-whiteframe-4dp z-index-4 pl-10 md-blue-bg min-height-56' layout='row' layout-align='space-between center'>" +
                    "<div style='font-size: 20px; margin-left:8px; font-weight:600; color: white;'>" + title + "</div>";

                if (clickOutsideToClose) embedHtml +=
                    "<md-button class='md-icon-button' ng-click='vm.close()' aria-label='Clear Search'>" +
                    "<md-icon style='color: white;' md-font-icon='icon-close'></md-icon>" +
                    "</md-button>";

                embedHtml +=
                    "</md-toolbar>" +
                    "<md-dialog-content style='padding:0;'>" +
                    template +
                    "</md-dialog-content>" +
                    "</md-dialog>";

                $mdDialog.show({
                    controller: controller,
                    controllerAs: 'vm',
                    template: embedHtml,
                    fullscreen: true,
                    clickOutsideToClose: true,
                }).then(callback);


            }, function () {
                // An error has occurred
            });

        }

        function closeDialog() {
            $mdDialog.hide();
        }
        function hideDialog() {
            $mdDialog.hide();
        }

        return {
            showMessageDialog: showMessageDialog,
            showBasicChoiceDialog: showBasicChoiceDialog,
            showSpinnerDialog: showSpinnerDialog,
            closeDialog: closeDialog,
            showDialog: showDialog,
            showProgressDialog: showProgressDialog,
            hideDialog: hideDialog,
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('appProxy', service);

    /** @ngInject */
    function service($q, $http, $timeout, $state, $rootScope, $window, $templateRequest) {

        var vm = {};

        vm.isAndroid = function () {
            return (typeof Android !== "undefined" && Android.hasOwnProperty('attemptGoogleSignIn'));
        }

        vm.isIOS = function () {
            return (typeof webkit !== "undefined" && webkit.messageHandlers && webkit.messageHandlers.attemptGoogleSignIn);
        }

        vm.isApp = function () {
            return (vm.isAndroid() || vm.isIOS());
        }

        vm.isNotApp = function (){
            return !vm.isApp();
        }

        vm.sendData = function (title, data) {
            if (vm.isAndroid() && Android.hasOwnProperty(title)) return Android[title](data);
            if (vm.isIOS() && webkit.messageHandlers.hasOwnProperty(title)) return webkit.messageHandlers[title].postMessage(data);
        }

        vm.handlerContains = function (title) {
            if (vm.isAndroid() && Android.hasOwnProperty(title)) return true;
            if (vm.isIOS() && webkit.messageHandlers.hasOwnProperty(title)) return true;
            return false;
        }

        function setCallback(title, successCallback) {
            $window[title] = function (a, b, c, d, e, f, g, h) {
                $window[title] = null;
                if (typeof successCallback === "function") successCallback(a, b, c, d, e, f, g, h);
            };
        }

        var listOfFunctions = [
           { name : 'attemptGoogleSignIn'},
           { name :  'storeDataPreferences'},
           { name :  'decodeByBarcode'},
           { name :  'deviceInfo', postFunction : function (returnedData){  mDeviceInfo = returnedData; console.log(mDeviceInfo); }},
           { name :  'getDebugMode'},
           { name :  'setDebugMode'},
           { name :  'loadComplete'},
           { name :  'getDeepLink'},
           { name :  'getImage'}
        ]

        var customPostFunctions = [
            { name : ""}
        ]

        function functionName(fun) {
            var ret = fun.toString();
            ret = ret.substr('function '.length);
            ret = ret.substr(0, ret.indexOf('('));
            return ret;
        }

        function init() {
            for (var i = 0; i < listOfFunctions.length; i++) {
                const item = listOfFunctions[i];
                vm[item.name] = function (data) {
                    return $q(function (resolve, reject) {
                        if (!vm.isApp()) return reject("__NOT_APP");
                        if (!vm.handlerContains(item.name)) return reject("__NOT_CONTAINS");
                        if (!data || data.constructor !== {}.constructor) data = {};
                        data.callbackUUID = Utils.randomUUID("_");
                        data.methodName = item.name;
                        $window[item.name + "_" + data.callbackUUID] = function (returnedData) {
                            returnedData = JSON.parse(returnedData);
                            if (returnedData.constructor !== {}.constructor) {
                                throw { returnStatus: "THROW", errorMessage: "Not valid JSON" };
                            } else if (returnedData.returnStatus === "THROW") {
                                throw returnedData;
                            } else if (returnedData.returnStatus === "SUCCESS") {
                                if (item.postFunction) item.postFunction(returnedData);
                                resolve(returnedData);
                            } else {
                                reject(returnedData);
                            }
                            $window[item.name + "_" + data.callbackUUID] = null;
                        };
                        vm.sendData(item.name, JSON.stringify(data));
                    });
                }
            }

        }

        init();

        vm.deepLinkTo = function (deepLink) {
            var json = Utils.convertURLtoJson(deepLink);
            var state = vm.getStateFromUrl(json);
            if (!state || !state.state || !state.state.name) return;
            json.params = vm.getParamsFromUrl(state.pathArray, json.pathArray, json.params);
            $timeout(function () {
                $state.go(state.state.name, json.params, { reload: true });
            });
        }

        $window.deepLinkTo = vm.deepLinkTo;

        vm.getParamsFromUrl = function (statePath, path, temp) {
            if (!angular.isArray(statePath) || !angular.isArray(path)) return temp;
            if (statePath.length !== path.length) return temp;
            if (!temp) temp = {};
            for (var i = 0; i < statePath.length; i++) {
                var item = statePath[i];
                if (!item.startsWith(':')) continue;
                temp[item.replace(':', '')] = path[i];
            }
            return temp;
        }

        vm.getStateFromUrl = function (urlJson) {
            var array = $state.get();

            var getUrl = function (name) {
                for (var j = 0; j < array.length; j++) {
                    if (array[j].abstract || array[j].name !== name) continue;
                    var indexOf = array[j].name.lastIndexOf(".");
                    var url = array[j].url;
                    if (url.lastIndexOf("?") > -1) {
                        url = url.substring(0, url.lastIndexOf("?"));
                    }
                    if (indexOf === -1) return url;
                    return getUrl(array[j].name.substring(0, indexOf)) + url;
                }
                return "";
            }

            for (var i = 0; i < array.length; i++) {
                try {
                    var state = array[i];
                    if (!state.url || state.abstract) continue;
                    var json = Utils.convertURLtoJson(getUrl(state.name));
                    if (json.url === "^") continue;
                    if (json.pathArray.length !== urlJson.pathArray.length) continue;
                    var worked = true;
                    for (var j = 0; j < json.pathArray.length; j++) {
                        var item = json.pathArray[j];
                        if (item.startsWith(':')) continue;
                        if (item !== urlJson.pathArray[j]) {
                            worked = false;
                            break;
                        }
                    }
                    if (worked) {
                        json.state = state;
                        return json;
                    }
                } catch (e) {

                }
            }
            return null;
        }

        return vm;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('range', function () {
            return function (input, total) {
                total = parseInt(total);
                for (var i = 0; i < total; i++)
                    input.push(i);
                return input;
            };
        });

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : false,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, firebaseService, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, SidebarJS, msNavigationService)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            SidebarJS.toggle(sidebarName);
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout(ev)
        {
            firebaseService.signOut(ev);
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';



    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            'firebase',
            'angularSpectrumColorpicker',
            'ng-vkThread',
            'ngMessages',
            'ngFx',
            'ngTouch',
            'alAngularHero',
            'vs-repeat',
            'ngSidebarJS',
            'chart.js',
            'ngImgCrop',
           // 'ngVirtualRepeat',
         //   'teropa.virtualDom',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Sample
          //  'app.sample',
            'app.settings',
            'app.desc',
            'app.power',
            'app.garage',
            'app.vehicle',
            'app.achievements'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, appProxy, $state) {
        // Data
        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {

                if (mLoadComplete) return;
                mLoadComplete = true;

                var done = function () {
                    appProxy.loadComplete();
                    $rootScope.$broadcast('msSplashScreen::remove');
                }

                done();
            }
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('DescController', DescController)
        .directive('myTable', function () {
            return {
                restrict: 'E',
                scope: {
                    width: '=',
                    height: '='
                },
                link: function (scope, el, attrs) {
                    scope.$watch('height', function (newValue, oldValue) {
                        var MyComponent = React.createFactory(selectTable);
                        ReactDOM.render(
                            MyComponent({ width: scope.width, height: scope.height }),
                            el[0]
                        );
                    })
                }
            }
        }).directive('pixel', pixelDirective);

    function pixelDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };
        function link(scope, element, attrs, ngModel) {

            ngModel.$formatters.push(function (viewmodel) {
                if (!viewmodel) return viewmodel;

                return parseInt(viewmodel.toString().replace('px', ''));
            });

            ngModel.$parsers.push(function (model) {
                if (!model) return model;

                return model + 'px';
            });
        }
    }
    /** @ngInject */
  /*  function DescController($scope, $rootScope) {

        $scope.width = 1000;
        $scope.height = 1000;
    }

    var selectTable = React.createClass({
        displayName: 'selectTable',
        render: function () {
            var width = this.props.width;
            var height = this.props.height;
            var rows = [];
            for (var line = 0; line < height; line++) {
                var row = [];
                for (var i = 0; i < width; i++) {
                    row.push(React.DOM.td(null, i))
                }
                rows.push(
                    React.DOM.tr({},
                        row
                    ))
            }
            return (
                React.DOM.table(null,
                    React.DOM.tbody(null, rows)
                )
            );
        }
    });

    var GRID = React.createClass({
        displayName: 'GRID',
        render: function () {
            var grid = this.props.grid;
            var rows = [];
            for (var line = 0; line < grid; line++) {
                var length = Math.floor(Math.random() * 100 + 1);
                var row = [];
                for (var i = 0; i < length; i++) {
                    row.push(React.DOM.td(null, i))
                }
                rows.push(
                    React.DOM.tr({},
                        row
                    ))
            }
            return (
                React.DOM.table(null,
                    React.DOM.tbody(null, rows)
                )
            );
        }
    });

    */
        /** @ngInject */
    function DescController($scope) {
        var vm = this;
        vm.active = 0;
        vm.tabs = [
            { title: 'Home', template: 'grid.html' }
        ];

        vm.rows = 1000;
        vm.cols = 1000;
        vm.styles = {
            width: '800px',
            height: '500px'
        };
        vm.cellStyle = {
            width: 70,
            height: 40
        };
        vm.grid = undefined;
        vm.apply = apply;
        vm.getRenderedCellCount = getRenderedCellCount;
        vm.$onInit = init;

        function init() {
            apply();
        }

        function apply() {
            vm.rows = parseInt(vm.rows || 0);
            vm.cols = parseInt(vm.cols || 0);
            if (vm.rows * vm.cols > 1000000) {
                alert('Cant process a matrix bigger than 1,000,000 cells :(.');
                return;
            }
            vm.grid = generateGrid(vm.rows, vm.cols);
        }

        vm.items = [];

        function getRenderedCellCount() {
            return document.querySelectorAll(".ng-virtual-repeat-container table tr td").length;
        }

        function generateGrid(size, cols) {
            var res = [];

            for (var i = 0; i < size; i++) {
                var row = [];
                for (var j = 0; j < cols; j++) {
                    row.push('[' + i + ', ' + j + ']');
                    vm.items.push(j);
                    // row.push((Math.random() * 100 + 50));
                }
                res.push(row);
            }
            return res;
        }

    }

})();
(function () {
    Array.prototype.move = function (old_index, new_index) {
        if (new_index >= this.length) {
            var k = new_index - this.length;
            while ((k--) + 1) {
                this.push(undefined);
            }
        }
        this.splice(new_index, 0, this.splice(old_index, 1)[0]);
        return this; // for testing purposes
    };
    Array.prototype.getBy = function (functionToFindBy) {
        for (var i = 0; i < this.length; i++) {
            if (functionToFindBy(this[i])) return this[i];
        }
        return null;
    };

    Array.prototype.shuffle = function () {
        var currentIndex = this.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = this[currentIndex];
            this[currentIndex] = this[randomIndex];
            this[randomIndex] = temporaryValue;
        }

        return this;
    };
    mDeviceInfo = null;
    mEstimatedCOOperGallon = 8.91;
    FirebaseInstance = null;
    mFirebaseUser = {
        account: {},
        settings: {},
        global: {}
    };
    clearUser = function () {
        if (mFirebaseUser) {
            if (mFirebaseUser.settings.$destroy) {
                mFirebaseUser.settings.$destroy();
            }
            if (mFirebaseUser.global.$destroy) {
                mFirebaseUser.global.$destroy();
            }
            if (mFirebaseUser.account.$signOut) {
                mFirebaseUser.account.$signOut();
            }
        }
        mFirebaseUser = {
            account: {},
            settings: {},
            global: {}
        };
    };
    mVehicle = null;
    isHeroTransition = false;
    mLoadComplete = false;
    mDeviceInfoComplete = false;
    stateHistory = [];
    name = function () {
        if (mFirebaseUser && mFirebaseUser.account) {
            if (mFirebaseUser.account.displayName) return mFirebaseUser.account.displayName;
            if (mFirebaseUser.account.email) return mFirebaseUser.account.email;
        }
        return "";
    };
    onBack = function () {
        if (stateHistory.length > 1) {
            window.history.back();
            return true;
        } else {
            stateHistory = [];
            return false;
        }
    }
    onPixelClicked = function (X, Y) {
        console.log(X);
    };
    changeBGColor = function (el, color) {
        el.style.backgroundColor = color;
    };
    Utils = {
        loadComplete: false,
        isFunction: function (functionTest) {
            return typeof functionTest === "function";
        },
        getCurrentUrl: function () {
            var url = window.location.href;
            url = url.replace(window.location.origin, 'https://vindecoded.com').replace('/www/', '/').replace('/android_asset/', '/');
            return url;
        },
        forEach: function (list, callback) {
            if (typeof callback === 'function') {
                if (angular.isArray(list)) {
                    for (var i = 0; i < list.length; i++) {
                        var returned = callback(list[i], i);
                        switch (returned) {
                            case "return":
                            case 0:
                                return;
                            case "continue":
                            case 1:
                                continue;
                        }
                    }
                } else if (angular.isObject(list)) {
                    var i = 0;
                    for (var key in list) {
                        var returned = callback(list[key], i, key);
                        switch (returned) {
                            case "return":
                            case 0:
                                return;
                            case "continue":
                            case 1:
                                continue;
                        }
                        i++;
                    }
                } else if (typeof list === "string") {
                    for (var i = 0, len = list.length; i < len; i++) {
                        var returned = callback(list[i], i);
                        switch (returned) {
                            case "return":
                            case 0:
                                return;
                            case "continue":
                            case 1:
                                continue;
                        }
                    }
                } else if (typeof list === "number") {
                    for (var i = 0; i < list; i++) {
                        var returned = callback(i, i);
                        switch (returned) {
                            case "return":
                            case 0:
                                return;
                            case "continue":
                            case 1:
                                continue;
                        }
                    }
                } else {
                    return false;
                }
            }
            return true;
        },

        forLoop: function (list, callback) {
            return Utils.forEach(list, callback);
        },

        for: function (list, callback) {
            return Utils.forEach(list, callback);
        },

        filter: function (list, isEqualFunction) {
            var newList;
            var type;
            if (angular.isObject(list)) { newList = {}; type = "object"; }
            else if (angular.isArray(list)) { newList = []; type = "array"; }
            else if (typeof list === "string") { newList = ""; type = "string"; }
            else if (typeof list === "number") { newList = []; type = "number" }
            else { return null; }

            if (type === "object" || type === "array") {
                Utils.forEach(newList, function (item, i, key) {
                    try {
                        if (isEqualFunction(item)) {
                            if (type === "object") { newList[key] = item; }
                            else if (type === "array") { newList.push(item); }
                        }
                    } catch (e) {

                    }
                });
            } else if (type === "string") {
                Utils.forEach(newList, function (item, i, key) {
                    try {
                        if (isEqualFunction(item)) {
                            newList += item;
                        }
                    } catch (e) {

                    }
                });
            } else if (type === "number") {
                Utils.forEach(newList, function (item, i, key) {
                    try {
                        if (isEqualFunction(item)) {
                            newList.push(item);
                        }
                    } catch (e) {

                    }
                });
            }

            return newList;

        },

        convertURLtoJson: function (url) {
            var temp = {};
            temp.url = url;

            temp.completePathArray = url.split('/');

            if (url.startsWith('http')) {
                temp.protocol = temp.completePathArray[0];
                temp.host = temp.completePathArray[2];
                temp.origin = temp.protocol + '//' + temp.host;
            }

            temp.path = url.replace(temp.origin, '');
            temp.params = Utils.getUrlParams(temp.url);
            if (temp.path.indexOf('?') > -1) {
                temp.path = temp.path.slice(0, temp.path.indexOf('?'));
                temp.paramsString = url.slice(url.indexOf('?'));
            }
            temp.pathArray = temp.path.split('/');
            return temp;
        },

        getUrlParams: function (url) {
            if (url.indexOf('?') === -1) return {};
            var hash;
            var myJson = {};
            var hashes = url.slice(url.indexOf('?') + 1).split('&');
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                myJson[hash[0]] = hash[1];
            }
            return myJson;
        },

        removeObjectKey: function (object, key) {
            if (!angular.isObject(object)) return null;

            var newObj = {};

            for (var keyOf in object) {
                if (keyOf == key) continue;
                newObj[keyOf] = object[keyOf];
            }

            return newObj;
        },

        S4: function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        },

        generateUID: function (insteadOfDash) {
            if (!insteadOfDash) insteadOfDash = "-";
            return (Utils.S4() + Utils.S4() + insteadOfDash + Utils.S4() + insteadOfDash + "4" + Utils.S4().substr(0, 3) + insteadOfDash + Utils.S4() + insteadOfDash + Utils.S4() + Utils.S4() + Utils.S4()).toLowerCase();
        },

        randomUUID: function (insteadOfDash) {
            return Utils.generateUID(insteadOfDash);
        },

        getCurrentDate: function () {
            return new Date().toISOString();
        },

        newObject: function (obj, userUID, noUid) {
            if (!angular.isObject(obj)) obj = {};
            obj.uniqueId = Utils.generateUID();
            obj.dateCreated = Utils.getCurrentDate();
            obj.dateUpdated = Utils.getCurrentDate();
            if (!noUid) obj.uid = Utils.generateUID();;
            if (userUID) obj.createdBy = userUID;
            if (userUID) obj.updatedBy = userUID;
            return obj;
        },

        asyncForEach: function (list, loopFunction, completeCallback) {
            var index = 0;
            var done = false;
            var iterations = -1;
            var isObject = false;

            var temp = [];

            if (angular.isArray(list)) {

                temp = angular.copy(list);
                iterations = temp.length;

            } else if (angular.isObject(list)) {

                isObject = true;

                Utils.forEach(list, function (item, i, key) {
                    var twotemp = {};
                    twotemp.item = item;
                    twotemp.i = i;
                    twotemp.key = key;
                    temp.push(twotemp);
                });

                iterations = temp.length;

            } else {
                done = true;
            }

            // console.error(list);

            var loop = {
                next: function () {
                    if (done) {
                        return;
                    }

                    if (index < iterations) {

                        index++;

                        var objtemp = temp[index - 1];

                        if (isObject) {
                            loopFunction(loop, objtemp.item, index - 1, objtemp.key);
                        } else {
                            loopFunction(loop, objtemp, index - 1);
                        }

                    } else {
                        done = true;
                        completeCallback();
                    }
                },

                iteration: function () {
                    return index - 1;
                },

                break: function () {
                    done = true;
                    completeCallback();
                }
            };

            loop.next();
            return loop;
        },

        objectEquals: function (objOne, objTwo) {
            if (!angular.isObject(objOne) || !angular.isObject(objTwo)) return false;
            for (var key in objOne) {
                if (!key || !objOne[key]) continue;
                if (!objTwo.hasOwnProperty(key)) return false;
                if (objTwo[key] !== objOne[key]) return false;
            }
            for (var key in objTwo) {
                if (!key || !objTwo[key]) continue;
                if (!objOne.hasOwnProperty(key)) return false;
                if (objOne[key] !== objTwo[key]) return false;
            }
            return true;
        },

        listContains: function (list, containsFunction) {
            if (!angular.isArray(list)) return false;
            for (var i = 0; i < list.length; i++) {
                try {
                    if (containsFunction(list[i])) return list[i];
                } catch (e) {

                }
            }
            return false;
        },

        isTrue: function (isTrueFunction) {
            try {
                var temp = isTrueFunction();
                return temp;
            } catch (e) {
                return false;
            }
        },

        try: function (tryFunction) {
            try {
                return tryFunction();
            } catch (e) {
                return e;
            }
        },

        inArray: function (item, array) {
            return (-1 !== array.indexOf(item));
        },

        test: function () {
            return "Test";
        },

        getObjectLength: function (obj) {
            try {
                return Object.keys(obj).length > 0 ? Object.keys(obj).length : 0
            } catch (e) {
                return 0;
            }
        },

        exists: function (returnValue) {
            try {
                var value = returnValue();
                return (value ? true : false);
            } catch (e) {
                return false;
            }
        },

        pfx: [{ name: "webkit", caps: true },
        { name: "moz", caps: false },
        { name: "MS", caps: true },
        { name: "o", caps: false },
        { name: "", caps: false }],

        PrefixedEventAdd: function (element, type, callback) {
            for (var p = 0; p < Utils.pfx.length; p++) {
                if (!Utils.pfx[p].caps) type = type.toLowerCase();
                element.addEventListener(Utils.pfx[p].name + type, callback, false);
            }
        },

        PrefixedEventRemove: function (element, type, callback) {
            for (var p = 0; p < Utils.pfx.length; p++) {
                if (!Utils.pfx[p].caps) type = type.toLowerCase();
                element.removeEventListener(Utils.pfx[p].name + type, callback, false);
            }
        },

        addAnimationEndListener: function (timeout, element, callback, dontTryTimeout) {

            if ((typeof callback !== "function") || !element) return;

            var newElement;

            if (typeof element === "string") {
                newElement = document.getElementById(element);
            } else {
                newElement = element;
            }

            if (!newElement && !dontTryTimeout) {
                timeout(function () {
                    Utils.addAnimationEndListener(timeout, element, callback, true);
                });
                return;
            }

            if (!newElement) return;

            Utils.PrefixedEventAdd(newElement, 'TransitionEnd', callback);

        },

        removeAnimationEndListener: function (timeout, element, callback, dontTryTimeout) {
            if ((typeof callback !== "function") || !element) return;

            var newElement;

            if (typeof element === "string") {
                newElement = document.getElementById(element);
            } else {
                newElement = element;
            }

            if (!newElement && !dontTryTimeout) {
                timeout(function () {
                    Utils.removeAnimationEndListener(timeout, element, callback, true);
                });
                return;
            }

            if (!newElement) return;

            Utils.PrefixedEventRemove(newElement, 'TransitionEnd', callback);
        },

        /**
            * detect IE
            * returns version of IE or false, if browser is not Internet Explorer
            */
        detectIE: function () {
            var ua = window.navigator.userAgent;

            // Test values; Uncomment to check result …

            // IE 10
            // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

            // IE 11
            // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

            // Edge 12 (Spartan)
            // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

            // Edge 13
            // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        },

        sortJsonByKey: function (obj) {
            if (typeof obj !== "object") return {};
            var keys = Object.keys(obj);
            keys.sort();
            var temp = {};
            for (var i = 0; i < keys.length; i++) {
                temp[keys[i]] = obj[keys[i]];
            }
            return temp;
        },

        isIE: function () {
            // Get IE or Edge browser version
            var version = Utils.detectIE();

            if (version === false) {
                return false;
            } else if (version >= 12) {
                return true;
            } else {
                return true;
            }

            // add details to debug result
            //  document.getElementById('details').innerHTML = window.navigator.userAgent;
        },

        getYearsByLetter: function (vin) {
            var tenthChar = vin.toUpperCase().charAt(9);
            var array = [];
            if (tenthChar == 'A') {
                array.push('2010'); array.push('1980');
            } else if (tenthChar == 'B') {
                array.push('2011'); array.push('1981');
            } else if (tenthChar == 'C') {
                array.push('2012'); array.push('1982');
            } else if (tenthChar == 'D') {
                array.push('2013'); array.push('1983');
            } else if (tenthChar == 'E') {
                array.push('2014'); array.push('1984');
            } else if (tenthChar == 'F') {
                array.push('2015'); array.push('1985');
            } else if (tenthChar == 'G') {
                array.push('2016'); array.push('1986');
            } else if (tenthChar == 'H') {
                array.push('2017'); array.push('1987');
            } else if (tenthChar == 'J') {
                array.push('2018'); array.push('1988');
            } else if (tenthChar == 'K') {
                array.push('2019'); array.push('1989');
            } else if (tenthChar == 'L') {
                array.push('1990');
            } else if (tenthChar == 'M') {
                array.push('1991');
            } else if (tenthChar == 'N') {
                array.push('1992');
            } else if (tenthChar == 'P') {
                array.push('1993');
            } else if (tenthChar == 'R') {
                array.push('1994');
            } else if (tenthChar == 'S') {
                array.push('1995');
            } else if (tenthChar == 'T') {
                array.push('1996');
            } else if (tenthChar == 'V') {
                array.push('1997');
            } else if (tenthChar == 'W') {
                array.push('1998');
            } else if (tenthChar == 'X') {
                array.push('1999');
            } else if (tenthChar == 'Y') {
                array.push('2000');
            } else if (tenthChar == '1') {
                array.push('2001');
            } else if (tenthChar == '2') {
                array.push('2002');
            } else if (tenthChar == '3') {
                array.push('2003');
            } else if (tenthChar == '4') {
                array.push('2004');
            } else if (tenthChar == '5') {
                array.push('2005');
            } else if (tenthChar == '6') {
                array.push('2006');
            } else if (tenthChar == '7') {
                array.push('2007');
            } else if (tenthChar == '8') {
                array.push('2008');
            } else if (tenthChar == '9') {
                array.push('2009');
            }
            return array;
        },

        isYearCorrect: function (vin, year) {
            var arrayOf = getYearsByLetter(vin);
            if (!angular.isArray(arrayOf)) return false;
            for (var i = 0; i < arrayOf.length; i++) {
                if (arrayOf[i] == year) return true;
            }
            return false;
        },


        httpUtil: function ($http, url, postData, successCallback, failedCallback, methodType, dontNeedToken) {

            var httpFunction = function (token) {
                var req = {
                    method: methodType,
                    url: url,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: postData
                }

                if (methodType === "POST") req.data = postData;

                if (token) req.headers = {
                    'token': token
                };

                req.headers.app = "cartraxx";

                $http(req)
                    .then(function success(response) {
                        if (response && response.status === 200) {
                            if (typeof successCallback === "function") successCallback(response.data);
                        } else if (response) {
                            if (typeof failedCallback === "function") failedCallback(response);
                        } else {
                            if (typeof failedCallback === "function") failedCallback({ status: 500, data: "Invalid Data" });
                        }
                    }, function error(response) {
                        if (typeof failedCallback === "function") failedCallback(response);
                    });
            }
            if (dontNeedToken)
                httpFunction();
            else if (mFirebaseUser && mFirebaseUser.account)
                mFirebaseUser.account.getToken().then(httpFunction);
            else
                if (typeof failedCallback === "function") failedCallback({ message: "No token found" });

        },

        httpGet: function ($http, url, successCallback, failedCallback, dontNeedToken) {
            Utils.httpUtil($http, url, {}, successCallback, failedCallback, "GET", dontNeedToken);
        },

        httpPostNoData: function ($http, url, successCallback, failedCallback, dontNeedToken) {
            Utils.httpUtil($http, url, {}, successCallback, failedCallback, "POST", dontNeedToken);
        },

        httpPost: function ($http, url, postData, successCallback, failedCallback, dontNeedToken) {
            Utils.httpUtil($http, url, postData, successCallback, failedCallback, "POST", dontNeedToken);
        },

        sortJsonObject: function (jsonObject, sortFunction, sortByKey) {
            if (typeof jsonObject != "object") return jsonObject;
            console.log(jsonObject);
            for (var key in jsonObject) {
                tempArray.push({
                    id: key,
                    object: jsonObject[key]
                });
            }
            tempArray = tempArray.sort(function (a, b) {
                return sortFunction(sortByKey ? a.id : a.object, sortByKey ? b.id : b.object);
            });

            var tempObj = {};
            for (var i = 0; i < tempArray.length; i++) {
                tempObj[tempArray[i].id] = tempArray[i].object;
            }
            return tempObj;
        },
    };
    NavItems = {
        items: [],
        addItem: function (stateId, svgIcon, title) {
            NavItems.items.push({
                stateId: stateId,
                svgIcon: svgIcon,
                title: title
            });
        },
        getItem: function (stateId) {
            for (var i = 0; i < NavItems.items.length; i++) {
                if (NavItems.items[i].stateId == stateId) return NavItems.items[i];
            }
            return {};
        },
        currentItem: {}
    };
    Number.prototype.formatMoney = function (addCommans) {
        var n = 2;
        var x = addCommans ? 3 : 200;
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
    };
    String.prototype.replaceAll = function (str1, str2, ignore) {
        return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof (str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);
    };
}
)();

(function () {
    // Options

    Fireworks = function (canvasToUse, height, width) {

        endFireworks = false;

        Fireworks.prototype.endFireworks = function () {
            endFireworks = true;
        };

        var options = {
            /* Which hue should be used for the first batch of rockets? */
            startingHue: 120,
            /* How many ticks the script should wait before a new firework gets spawned, if the user is holding down his mouse button. */
            clickLimiter: 5,
            /* How fast the rockets should automatically spawn, based on ticks */
            timerInterval: 40,
            /* Show pulsing circles marking the targets? */
            showTargets: true,
            /* Rocket movement options, should be self-explanatory */
            rocketSpeed: 2,
            rocketAcceleration: 1.03,
            /* Particle movement options, should be self-explanatory */
            particleFriction: 0.95,
            particleGravity: 1,
            /* Minimum and maximum amount of particle spawns per rocket */
            particleMinCount: 25,
            particleMaxCount: 40,
            /* Minimum and maximum radius of a particle */
            particleMinRadius: 3,
            particleMaxRadius: 5
        };

        // Local variables
        var fireworks = [];
        var particles = [];
        var mouse = { down: false, x: 0, y: 0 };
        var currentHue = options.startingHue;
        var clickLimiterTick = 0;
        var timerTick = 0;
        var cntRocketsLaunched = 0;

        // Helper function for canvas animations
        window.requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                function (cb) {
                    window.setTimeout(callback, 1000 / 60);
                }
        })();

        // Helper function to return random numbers within a specified range
        function random(min, max) {
            return Math.random() * (max - min) + min;
        }

        // Helper function to calculate the distance between 2 points
        function calculateDistance(p1x, p1y, p2x, p2y) {
            var xDistance = p1x - p2x;
            var yDistance = p1y - p2y;
            return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
        }

        // Setup some basic variables
        var canvas = canvasToUse ? canvasToUse : document.getElementById('canvas-fireworks');
        var canvasCtx = canvas.getContext('2d');
        var canvasWidth;
        var canvasHeight;

        function updateSize(height, width) {

            console.log(height);

            if (canvasWidth !== width) {
                canvasWidth = width;
                canvas.width = canvasWidth;
            }

            if (canvasHeight !== height) {
                canvasHeight = height;
                canvas.height = canvasHeight;
            }
        }

        Fireworks.prototype.updateSize = updateSize;

        updateSize(height, width);

        // Firework class
        function Firework(sx, sy, tx, ty) {
            // Set coordinates (x/y = actual, sx/sy = starting, tx/ty = target)
            this.x = this.sx = sx;
            this.y = this.sy = sy;
            this.tx = tx; this.ty = ty;

            // Calculate distance between starting and target point
            this.distanceToTarget = calculateDistance(sx, sy, tx, ty);
            this.distanceTraveled = 0;

            // To simulate a trail effect, the last few coordinates will be stored
            this.coordinates = [];
            this.coordinateCount = 3;

            // Populate coordinate array with initial data
            while (this.coordinateCount--) {
                this.coordinates.push([this.x, this.y]);
            }

            // Some settings, you can adjust them if you'd like to do so.
            this.angle = Math.atan2(ty - sy, tx - sx);
            this.speed = options.rocketSpeed;
            this.acceleration = options.rocketAcceleration;
            this.brightness = random(50, 80);
            this.hue = currentHue;
            this.targetRadius = 1;
            this.targetDirection = false;  // false = Radius is getting bigger, true = Radius is getting smaller

            // Increase the rockets launched counter
            cntRocketsLaunched++;
        };

        // This method should be called each frame to update the firework
        Firework.prototype.update = function (index) {
            // Update the coordinates array
            this.coordinates.pop();
            this.coordinates.unshift([this.x, this.y]);

            // Cycle the target radius (used for the pulsing target circle)
            if (!this.targetDirection) {
                if (this.targetRadius < 8)
                    this.targetRadius += 0.15;
                else
                    this.targetDirection = true;
            } else {
                if (this.targetRadius > 1)
                    this.targetRadius -= 0.15;
                else
                    this.targetDirection = false;
            }

            // Speed up the firework (could possibly travel faster than the speed of light) 
            this.speed *= this.acceleration;

            // Calculate the distance the firework has travelled so far (based on velocities)
            var vx = Math.cos(this.angle) * this.speed;
            var vy = Math.sin(this.angle) * this.speed;
            this.distanceTraveled = calculateDistance(this.sx, this.sy, this.x + vx, this.y + vy);

            // If the distance traveled (including velocities) is greater than the initial distance
            // to the target, then the target has been reached. If that's not the case, keep traveling.
            if (this.distanceTraveled >= this.distanceToTarget) {
                createParticles(this.tx, this.ty);
                fireworks.splice(index, 1);
            } else {
                this.x += vx;
                this.y += vy;
            }
        };

        // Draws the firework
        Firework.prototype.draw = function () {
            var lastCoordinate = this.coordinates[this.coordinates.length - 1];

            // Draw the rocket
            canvasCtx.beginPath();
            canvasCtx.moveTo(lastCoordinate[0], lastCoordinate[1]);
            canvasCtx.lineTo(this.x, this.y);
            canvasCtx.strokeStyle = 'hsl(' + this.hue + ',100%,' + this.brightness + '%)';
            canvasCtx.stroke();

            // Draw the target (pulsing circle)
            if (options.showTargets) {
                canvasCtx.beginPath();
                canvasCtx.arc(this.tx, this.ty, this.targetRadius, 0, Math.PI * 2);
                canvasCtx.stroke();
            }
        };

        // Particle class
        function Particle(x, y) {
            // Set the starting point
            this.x = x;
            this.y = y;

            // To simulate a trail effect, the last few coordinates will be stored
            this.coordinates = [];
            this.coordinateCount = 5;

            // Populate coordinate array with initial data
            while (this.coordinateCount--) {
                this.coordinates.push([this.x, this.y]);
            }

            // Set a random angle in all possible directions (radians)
            this.angle = random(0, Math.PI * 2);
            this.speed = random(1, 10);

            // Add some friction and gravity to the particle
            this.friction = options.particleFriction;
            this.gravity = options.particleGravity;

            // Change the hue to a random number
            this.hue = random(currentHue - 20, currentHue + 20);
            this.brightness = random(50, 80);
            this.alpha = 1;

            // Set how fast the particles decay
            this.decay = random(0.01, 0.03);
        }

        // Updates the particle, should be called each frame
        Particle.prototype.update = function (index) {
            // Update the coordinates array
            this.coordinates.pop();
            this.coordinates.unshift([this.x, this.y]);

            // Slow it down (based on friction)
            this.speed *= this.friction;

            // Apply velocity to the particle
            this.x += Math.cos(this.angle) * this.speed;
            this.y += Math.sin(this.angle) * this.speed + this.gravity;

            // Fade out the particle, and remove it if alpha is low enough
            this.alpha -= this.decay;
            if (this.alpha <= this.decay) {
                particles.splice(index, 1);
            }
        }

        // Draws the particle
        Particle.prototype.draw = function () {
            var lastCoordinate = this.coordinates[this.coordinates.length - 1];
            var radius = Math.round(random(options.particleMinRadius, options.particleMaxRadius));

            // Create a new shiny gradient
            var gradient = canvasCtx.createRadialGradient(this.x, this.y, 0, this.x, this.y, radius);
            gradient.addColorStop(0.0, 'white');
            gradient.addColorStop(0.1, 'white');
            gradient.addColorStop(0.1, 'hsla(' + this.hue + ',100%,' + this.brightness + '%,' + this.alpha + ')');
            gradient.addColorStop(1.0, 'black');

            // Draw the gradient
            canvasCtx.beginPath();
            canvasCtx.fillStyle = gradient;
            canvasCtx.arc(this.x, this.y, radius, Math.PI * 2, false);
            canvasCtx.fill();
        }

        // Create a bunch of particles at the given position
        function createParticles(x, y) {
            var particleCount = Math.round(random(options.particleMinCount, options.particleMaxCount));
            while (particleCount--) {
                particles.push(new Particle(x, y));
            }
        }

        // Add an event listener to the window so we're able to react to size changes
        /*
        window.addEventListener('resize', function(e) {
          canvas.width = canvasWidth = window.innerWidth;
          canvas.height = canvasHeight = window.innerHeight;
        });
        */

        var move = function (e) {
            e.preventDefault();
            if (e instanceof TouchEvent) {
                mouse.x = e.touches[0].clientX - canvas.parentElement.offsetLeft;
                mouse.y = e.touches[0].clientY - canvas.parentElement.offsetTop;
            } else {
                mouse.x = e.pageX - canvas.offsetLeft;
                mouse.y = e.pageY - canvas.offsetTop;
            }
        };

        // Add event listeners to the canvas to handle mouse interactions
        canvas.addEventListener('mousemove', move);

        canvas.addEventListener('touchmove', move);

        var down = function (e) {
            e.preventDefault();
            mouse.down = true;
            if (e instanceof TouchEvent) {
                move(e);
            }
        };

        var up = function (e) {
            e.preventDefault();
            mouse.down = false;
        };

        canvas.addEventListener('mousedown', down);

        canvas.addEventListener('mouseup', up);

        canvas.addEventListener('touchstart', down);

        canvas.addEventListener('touchend', up);

        // Main application / script, called when the window is loaded
        function gameLoop() {

            if (endFireworks) {
                endFireworks = false;
                return;
            }

            // This function will rund endlessly by using requestAnimationFrame (or fallback to setInterval)
            requestAnimFrame(gameLoop);

            // Increase the hue to get different colored fireworks over time
            currentHue += 0.5;

            // 'Clear' the canvas at a specific opacity, by using 'destination-out'. This will create a trailing effect.
            canvasCtx.globalCompositeOperation = 'destination-out';
            canvasCtx.fillStyle = 'rgba(0, 0, 0, 0.5)';
            canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
            canvasCtx.globalCompositeOperation = 'lighter';

            // Loop over all existing fireworks (they should be updated & drawn)
            var i = fireworks.length;
            while (i--) {
                fireworks[i].draw();
                fireworks[i].update(i);
            }

            // Loop over all existing particles (they should be updated & drawn)
            var i = particles.length;
            while (i--) {
                particles[i].draw();
                particles[i].update(i);
            }

            // Launch fireworks automatically to random coordinates, if the user does not interact with the scene
            if (timerTick >= options.timerInterval) {
                if (!mouse.down) {
                    fireworks.push(new Firework(canvasWidth / 2, canvasHeight, random(0, canvasWidth), random(0, canvasHeight / 2)));
                    timerTick = 0;
                }
            } else {
                timerTick++;
            }

            // Limit the rate at which fireworks can be spawned by mouse
            if (clickLimiterTick >= options.clickLimiter) {
                if (mouse.down) {
                    fireworks.push(new Firework(canvasWidth / 2, canvasHeight, mouse.x, mouse.y));
                    clickLimiterTick = 0;
                }
            } else {
                clickLimiterTick++;
            }

        }
        gameLoop();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : false
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);
    /*
    .run(['rippleConfig', function (rippleConfig) {
        rippleConfig.rippleOpacity = .2;
        rippleConfig.rippleDelay = 100;
        rippleConfig.mobileTouch = true; // False (default): Mobile use ONLY click || True: mobile use touchstart and touchend
    }]);
    */


    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, appProxy) {

        $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error, msNavigationServiceProvider) {
            // We can catch the error thrown when the $requireSignIn promise is rejected
            // and redirect the user back to the home page
            console.log(error);

            var errorMessage = error;

            if (error.constructor === {}.constructor) {
                errorMessage = error.message;
            }

            if (errorMessage.startsWith("__")) {
                $state.go('app.garage');
            }
            else switch (errorMessage) {
                case "DEEP_LINK":
                    return appProxy.deepLinkTo(error.json.deepLink);
                    break;
                case "EMAIL_ALREADY_VERIFIED":
                case "VEHCILE_GET_FAILED":
                case "GO_TO_GARAGE":
                    return $state.go('app.garage');
                    break;
                case "NO_RECALLS":
                case "NO_OPEN_RECALLS":
                    return $state.go('app.vehicle');
                    break;
                case "AUTH_REQUIRED":
                    return $state.go('app.settings_register');
                    break;
                case "EMAIL_VERIFICATION_REQUIRED":
                    return $state.go('app.settings_emailverify');
                    break;
            }
        });

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                var tempHistory = [];
                for (var i = 0; i < stateHistory.length; i++) {
                    if (stateHistory[i] === $state.current.name) break;
                    tempHistory.push(stateHistory[i]);
                }
                stateHistory = tempHistory;
                stateHistory.push($state.current.name);
                $rootScope.loadingProgress = false;
                $rootScope.currentNavItem = NavItems.getItem($state.current.name);
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/Garage');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                },
                resolve: {
                    deepLink: function (appProxy, $q) {

                        return $q(function (resolve, reject) {
                            appProxy.getDeepLink().then(
                                function (deepLinkJson) {
                                    var temp = {
                                        message : "DEEP_LINK",
                                        json : deepLinkJson
                                    }
                                    if (deepLinkJson && typeof deepLinkJson.deepLink === "string" && deepLinkJson.deepLink.length > 1) reject(temp);
                                    else resolve();
                                }, resolve
                            ).catch(resolve);

                        });
                    }
                },
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $rootScope, firebaseService, appProxy)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;


        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, ChartJsProvider, $stateProvider) {
        // Put your common app configurations here

        $stateProvider.decorator('parent', function(internalStateObj, parentFn) {
            internalStateObj.self.$$state = function() {
                return internalStateObj;
            };
            return parentFn(internalStateObj);
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        var firebaseConfig = {
            apiKey: "AIzaSyAGYIIjldFkz1hUr_ioU7Lsc4e-9J1CjCM",
            authDomain: "cartraxx-aad4b.firebaseapp.com",
            databaseURL: "https://cartraxx-aad4b.firebaseio.com",
            projectId: "cartraxx-aad4b",
            storageBucket: "cartraxx-aad4b.appspot.com",
            messagingSenderId: "894796422902"
        };
        FirebaseInstance = firebase.initializeApp(firebaseConfig);

    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.vehicle.gas', [
            'app.vehicle.gas.input',
            'app.vehicle.gas.view',
            'app.vehicle.gas.past'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.vehicle.gas', {
                url: '/Gas',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.vehicle.gas.input': {
                        templateUrl: 'app/main/vehicle/gas/input-gas/input-gas.html',
                        controller: 'VehicleInputGasController as vm'
                    }
                },
                resolve: {
                    vehicle: function (vehicleService, $stateParams) {
                        return vehicleService.getVehiclePromise($stateParams.vin);
                    }
                },
                params: {
                    vin: null
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.power', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.power', {
                url: '/Power',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/power/power.html',
                        controller: 'PowerController as vm'
                    }
                }
            });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings', [
            'app.settings.register',
            'app.settings.login',
            'app.settings.email_verify',
            'app.settings.generic',
            'app.settings.privacy',
            'app.settings.contactus',
            'app.settings.download'
        ])
        .config(config);

    /** @ngInject */
    function config( msNavigationServiceProvider)
    {
     

        // Navigation
        msNavigationServiceProvider.saveItem('settings', {
            title : 'Settings',
            group : true,
            weight: 100
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.desc', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.desc', {
                url: '/Desc',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.desc': {
                        templateUrl: 'app/main/desc.html',
                        controller: 'DescController as vm'
                    }
                }
            });


    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/desc.html","<div id=\"desc\" style=\"width:100%; height: 100%\"><div test-directive>TESETTE</div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp min-height-56\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex>sdffds<md-toolbar\n id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><sidebarjs \non-close=\"app.onSidebarClose()\" on-open=\"app.onSidebarOpen()\"><div layout=\"column\" class=\"md-headline\" \nlayout-align=\"start stretch\"><md-toolbar class=\"md-tall md-accent-bg min-height-56\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center \"><img src=\"assets/images/cartraxx/car_white_shadow_heart_grey.png\" class=\"main-icon m-0\" \naria-label=\"Cake\"><div class=\"md-display-1 ml-16\">Cartraxx</div></div></md-toolbar><div class=\"border-bottom-grey\"><div\n ng-if=\"firebaseUser && !firebaseUser.account.isAnonymous\"><div layout=\"column\" class=\"p-16\" \nlayout-align=\"start start \"><div class=\"md-subheader\">Welcome,</div><div class=\"md-title ml-8\" md-truncate>\n{{firebaseUser.account.displayName ? firebaseUser.account.displayName : firebaseUser.account.email }}</div></div></div>\n<div class=\"pt-4 pb-4\" ng-if=\"!(firebaseUser && !firebaseUser.account.isAnonymous)\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button ui-sref=\"app.settings_login\" sidebarjs-toggle md-theme=\"inputTheme\" \nclass=\"md-raised md-primary\">Login</md-button><md-button ui-sref=\"app.settings_register\" sidebarjs-toggle \nmd-theme=\"inputTheme\" class=\"md-raised md-primary\">Register</md-button></div></div><div class=\"scrollable\"><div \nsidebarjs-toggle touched-now ui-sref=\"app.garage\" ui-sref-active=\"selected-item\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center \"><md-icon md-svg-src=\"assets/images/cartraxx/garage.svg\" class=\"s24 m-0\" aria-label=\"Cake\">\n</md-icon><div class=\"ml-16\">Garage</div></div></div><div sidebarjs-toggle touched-now ui-sref=\"app.achievements\" \nui-sref-active=\"selected-item\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center \"><md-icon \nmd-svg-src=\"assets/images/cartraxx/trophy.svg\" class=\"s24 m-0\" aria-label=\"Cake\"></md-icon><div class=\"ml-16\">\nAchievements</div></div></div><div sidebarjs-toggle touched-now ui-sref=\"app.settings\" ui-sref-active=\"selected-item\">\n<div layout=\"row\" class=\"p-16\" layout-align=\"start center \"><md-icon md-svg-src=\"assets/images/cartraxx/settings.svg\" \nclass=\"s24 m-0\" aria-label=\"Cake\"></md-icon><div class=\"ml-16\">Settings</div></div></div><div sidebarjs-toggle \ntouched-now ui-sref=\"app.settings_contactus\" ui-sref-active=\"selected-item\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center \"><md-icon md-svg-src=\"assets/images/cartraxx/mail_outline.svg\" class=\"s24 m-0\" \naria-label=\"Cake\"></md-icon><div class=\"ml-16\">Contact Us</div></div></div></div></div></sidebarjs><div \nid=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/achievements/achievements.html","<fireworks class=\"position-absolute\"></fireworks><div class=\"full-height-width position-absolute\" \nstyle=\"pointer-events: none\" layout=\"column\" layout-align=\"start center\"><div layout=\"column\" style=\"width : 50%\" \nclass=\"\" layout-align=\"center center\"><img ng-src=\"assets/images/cartraxx/trophy.png\" \nclass=\"full-width height-auto hero\" hero-id=\"maintenanceListImage\" aria-label=\"Cake\"></div><div \nclass=\"md-headline centering\">Coming Soon!</div><div ng-if=\"test\" layout=\"row\"><div layout=\"column\" \nstyle=\"width : 100px\" class=\"\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/trophy_sans_background.svg\" class=\"full-width height-auto\" aria-label=\"Cake\">\n</md-icon></div><div layout=\"column\" style=\"width : 100px\" class=\"\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/trophy_sans_background.svg\" class=\"full-width height-auto\" aria-label=\"Cake\">\n</md-icon></div><div layout=\"column\" style=\"width : 100px\" class=\"\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/trophy_sans_background.svg\" class=\"full-width height-auto\" aria-label=\"Cake\">\n</md-icon></div></div></div>");
$templateCache.put("app/main/garage/garage.html","<div id=\"garage\" class=\"full-width-height\" ng-cloak><div vs-repeat ng-if=\"vm.initialized && vm.garage.length > 0\" \nstyle=\"overflow-y: scroll\" class=\"pointer full-height-width position-absolute animate-if md-white-bg\"><div \nlayout=\"column\" layout-align=\"center start\" md-ink-ripple class=\"position-relative height-200 border-bottom-grey\" \ntouched-now ng-repeat=\"vehicle in ::vm.garage track by vehicle.vin\" ng-click=\"vm.openVehicle(vehicle);\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"p-16\"><div layout=\"column\" \nng-class=\"vm.clickedVin === vehicle.vin ? \'width-100 mr-24 hero\' : \'width-100 mr-24\'\" hero-id=\"carImage\" \nlayout-align=\"center center\"><image ng-if=\"vehicle.vehicleImage\" class=\"full-width height-auto hero\" \nng-src=\"{{::vehicle.vehicleImage}}\" hero-id=\"{{vm.vehicleImage == vehicle.vin ? \'vehicleImage\' : \'\'}}\"><image \nng-if=\"!vehicle.vehicleImage && vehicle.vehiclePicture\" class=\"full-width height-auto hero\" \nng-src=\"{{::vehicle.vehiclePicture}}\" hero-id=\"{{vm.vehicleImage == vehicle.vin ? \'vehicleImage\' : \'\'}}\"><md-icon \nng-if=\"!vehicle.vehicleImage && !vehicle.vehiclePicture\" md-svg-src=\"assets/images/cartraxx/car.svg\" \nclass=\"full-width height-auto hero\" hero-id=\"{{vm.vehicleImage == vehicle.vin ? \'vehicleImage\' : \'\'}}\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\"><div hero-id=\"headline\" class=\"truncate-2\" \nng-class=\"vm.clickedVin === vehicle.vin ? \'md-headline mb-8 hero\' : \'md-headline mb-8\'\">{{::vm.getHeadline(vehicle)}}\n</div><div hero-id=\"subheader\" class=\"truncate-2\" style=\"min-width: 0\" \nng-class=\"vm.clickedVin === vehicle.vin ? \'md-subheader mb-16 transparent hero\' : \'md-subheader mb-16 transparent\'\">\n{{::vm.getSubHeader(vehicle)}}</div><div layout=\"row\" class=\"mb-8\" layout-align=\"start start\"><md-icon \nmd-svg-src=\"{{::vm.getImage(vehicle.openRecallsCount <= 0)}}\" class=\"width-16 height-16 m-0\" aria-label=\"Cake\">\n</md-icon><div class=\"md-subheader-content ml-8 md-truncate\" style=\"font-weight: 600; text-align:center\" \nng-style=\"vm.textColor(vehicle.openRecallsCount)\">{{::vm.recallsTitle(vehicle)}}</div></div><div layout=\"row\" \nclass=\"mb-8\" layout-align=\"start start\"><md-icon md-svg-src=\"{{::vm.getImage(vehicle.dueMaintenanceCount <= 0)}}\" \nclass=\"width-16 height-16 m-0\" aria-label=\"Cake\"></md-icon><div class=\"md-subheader-content ml-8 md-truncate\" \nstyle=\"font-weight: 600; text-align:center\" ng-style=\"vm.textColor(vehicle.dueMaintenanceCount)\">\n{{::vm.getMaintenanceStatusTitle(vehicle)}}</div></div></div></div></div></div><div id=\"scrollingaragenew\" \nng-show=\"vm.garage.length === 0 && vm.initialized\" style=\"overflow-y: scroll\" \nclass=\"pointer full-height-width position-absolute animate-if md-white-bg\"><div class=\"border-bottom-grey pt-16\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-display-2 center pb-16\" \nstyle=\"color : #707070; font-weight: 800\">Cartraxx</div><image class=\"logo main-icon height-auto mb-16\" \nstyle=\"border-radius: 22px; width: 125px; background: #00E676\" ng-src=\"assets/images/cartraxx/car-green-square.png\">\n</image><div class=\"mb-16\" md-theme=\"inputTheme\"><md-button ui-sref=\"app.garage.add\" class=\"md-raised md-primary\"><div \nlayout=\"row\"><div>Add a Vehicle Now!</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/cartraxx/ic_add_circle_outline_white_24px.svg\"></md-icon></div></md-button></div></div><div \nclass=\"border-bottom-grey\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" \nclass=\"width-50 mr-24\" layout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/sustainable.svg\" \nclass=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\"><div \nclass=\"md-title text-black transparent mb-8\">Eco Friendly</div><div class=\"md-subheader transparent\">\nLearn the CO2 output of your vehicle and how to keep it running eco friendly!</div></div></div></div><div \nclass=\"border-bottom-grey\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" \nclass=\"width-50 mr-24\" layout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/dummy.svg\" \nclass=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\"><div \nclass=\"md-title text-black transparent mb-8\">Open Recalls</div><div class=\"md-subheader transparent\">\nKnowing what recalls are open on your vehicle keeps you and your family safe!</div></div></div></div><div \nclass=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div \nlayout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/engine.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div><div \nlayout=\"column\"><div class=\"md-title text-black transparent mb-8\">Maintenance</div><div \nclass=\"md-subheader transparent\">\nYour vehicle desrves to be pampered, and keeping it healthy will extend it\'s life! Best of all, consistent maintenance decreases your \n<b style=\"font-weight : 800; color :#404040\">carbon footprint</b> by up to <b \nstyle=\"font-weight : 800; color : #404040\">30%</b> and reduce costs over the life of your vehicle by <b \nstyle=\"font-weight : 800; color : #404040\">24%</b>!</div></div></div></div><div \nclass=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div \nlayout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/gas-station.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div>\n<div layout=\"column\"><div class=\"md-title text-black transparent mb-8\">Gas</div><div class=\"md-subheader transparent\">\nTracking your fuel efficency and get recommendations from <b style=\"font-weight : 800; color :#404040\">Cartraxx</b>\n on how to improve your efficency!</div></div></div></div><div class=\"position-relative border-bottom-grey\"><div \nlayout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/money-bag.svg\" class=\"full-width height-auto\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\"><div class=\"md-title text-black transparent mb-8\">Value</div>\n<div class=\"md-subheader transparent\">Manage costs and keep track of savings by using <b \nstyle=\"font-weight : 800; color :#404040\">Cartraxx</b>! See your vehicle\'s value as it changes over time. Know the <b \nstyle=\"font-weight : 800; color :#404040\">Cost to Own</b> for the vehicle and where your vehicle stands!</div></div>\n</div></div><div class=\"full-width height-110\" layout=\"column\" layout-align=\"center end\"></div></div><md-button \nui-sref=\"app.garage.add\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/cartraxx/ic_add_white_24px.svg\"></md-icon></md-button><progress-view ng-if=\"vm.loading\">\n</progress-view></div>");
$templateCache.put("app/main/power/power-add-fee.html","<md-dialog flex=\"50\" aria-label=\"Mango (Fruit)\"><md-toolbar class=\"md-blue-bg min-height-56\"><div \nclass=\"md-toolbar-tools\"><span class=\"md-headline\">{{title}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><i class=\"icon s18 icon-close\" style=\"color : white\" \naria-label=\"Close dialog\"></i></md-button></div></md-toolbar><md-dialog-content><form novalidate name=\"feeForm\"><div \nclass=\"md-headline\" layout=\"column\" layout-align=\"space-around stretch\"><md-input-container class=\"md-block\"><label>\nFee Name</label><input autocomplete=\"off\" required name=\"name\" ng-model=\"fee.name\" md-autofocus><div \nng-messages=\"feeForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Fee Name is Required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Fee Cost ($)</label><input autocomplete=\"off\" \nrequired name=\"cost\" ng-model=\"fee.cost\" type=\"number\"><div ng-messages=\"feeForm.cost.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Fee Cost is Required</span></div></div></md-input-container></div><md-button type=\"submit\" \nng-click=\"proceed(feeForm)\" class=\"md-raised md-blue-bg\" style=\"color : white\">Proceed</md-button></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/power/power.html","<div style=\"width: 100%; height: 100%\" layout=\"column\"><div style=\"width: 100%; overflow-y: auto\" flex><md-card \nstyle=\"padding:16px\"><span class=\"md-headline\">Costs per KWh</span><div layout=\"row\" layout-wrap \nlayout-align=\"space-around stretch\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"80\"><label>500 KWh (¢)\n</label><input autocomplete=\"off\" ng-model=\"vm.fivehundred\" type=\"number\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\" flex=\"80\"><label>1000 KWh (¢)</label><input autocomplete=\"off\" ng-model=\"vm.thousand\" \ntype=\"number\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"80\"><label>2000 KWh (¢)\n</label><input autocomplete=\"off\" ng-model=\"vm.twothousand\" type=\"number\"></md-input-container></div></md-card><div \nlayout=\"row\" layout-wrap layout-align=\"space-around stretch\"><md-card flex-gt-sm=\"20\" flex=\"80\" \nstyle=\"position:relative\" ng-repeat=\"(key, month) in vm.monthlyData\"><div style=\"padding:16px\" layout=\"row\" \nlayout-align=\"start start\"><md-checkbox ng-model=\"month.isActive\" style=\"padding-right: 16px\" \nng-change=\"vm.calculate()\" aria-label=\"Checkbox 1\"></md-checkbox><div layout=\"column\"><span class=\"md-headline\">{{key}}\n</span><md-input-container class=\"md-block\" flex><label>KWh Average Usage</label><input autocomplete=\"off\" \nng-model=\"month.kwhUsage\" type=\"number\"></md-input-container><div ng-if=\"month.monthCost\" style=\"font-size: 36px\">\n${{month.monthCost.toFixed(2).toLocaleString()}}</div></div></div></md-card><md-card \nstyle=\"padding:16px; width:100%; margin: 16px\"><span class=\"md-headline\">Options</span><div layout=\"row\" layout-wrap \nlayout-align=\"space-around stretch\"><div flex-gt-sm=\"25\" flex=\"100\"><md-checkbox ng-model=\"vm.minUsageFeeActive\" \nstyle=\"padding-right: 32px; padding-top: 16px\" aria-label=\"Checkbox 1\">Minimum Usage Fee ($)</md-checkbox><div \nstyle=\"padding-left: 32px\" ng-if=\"vm.minUsageFeeActive\"><md-input-container class=\"md-block\" flex=\"grow\"><label>\nMinimum Usage Fee ($)</label><input autocomplete=\"off\" ng-model=\"vm.minUsageFee\" type=\"number\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"grow\"><label>Less Than KWh Used</label><input autocomplete=\"off\" \nng-model=\"vm.minUsageFeeKW\" type=\"number\"></md-input-container></div></div><div flex-gt-sm=\"25\" flex=\"100\"><md-checkbox\n ng-model=\"vm.maxUsageFeeActive\" style=\"padding-right: 32px; padding-top: 16px\" aria-label=\"Checkbox 1\">\nMaximum Usage Fee ($)</md-checkbox><div style=\"padding-left: 32px\" ng-if=\"vm.maxUsageFeeActive\"><md-input-container \nclass=\"md-block\" flex=\"grow\"><label>Maximum Usage Fee ($)</label><input autocomplete=\"off\" ng-model=\"vm.maxUsageFee\" \ntype=\"number\"></md-input-container><md-input-container class=\"md-block\" flex=\"grow\"><label>More Than KWh Used</label>\n<input autocomplete=\"off\" ng-model=\"vm.maxUsageFeeKW\" type=\"number\"></md-input-container></div></div><div \nflex-gt-sm=\"25\" flex=\"100\"><md-checkbox ng-model=\"vm.underCreditActive\" style=\"padding-right: 32px; padding-top: 16px\" \naria-label=\"Checkbox 1\">Used Under Credit ($)</md-checkbox><div style=\"padding-left: 32px\" \nng-if=\"vm.underCreditActive\"><md-input-container class=\"md-block\" flex=\"grow\"><label>Used Under Credit ($)</label>\n<input autocomplete=\"off\" ng-model=\"vm.underCredit\" type=\"number\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"grow\"><label>Less Than KWh Used</label><input autocomplete=\"off\" ng-model=\"vm.underCreditKW\" \ntype=\"number\"></md-input-container></div></div><div flex-gt-sm=\"25\" flex=\"100\"><md-checkbox \nng-model=\"vm.overCreditActive\" style=\"padding-right: 32px; padding-top: 16px\" aria-label=\"Checkbox 1\">\nUsed Over Credit ($)</md-checkbox><div style=\"padding-left: 32px\" ng-if=\"vm.overCreditActive\"><md-input-container \nclass=\"md-block\" flex=\"grow\"><label>Used Over Credit ($)</label><input autocomplete=\"off\" ng-model=\"vm.overCredit\" \ntype=\"number\"></md-input-container><md-input-container class=\"md-block\" flex=\"grow\"><label>More Than KWh Used</label>\n<input autocomplete=\"off\" ng-model=\"vm.overCreditKW\" type=\"number\"></md-input-container></div></div></div></md-card>\n</div><md-card style=\"padding:16px\"><span class=\"md-headline\" style=\"border-bottom: thin solid lightgrey\">Monthly Fees\n</span><div ng-repeat=\"fee in vm.monthlyFees\" class=\"p-8 fx-fade-down\" style=\"border-bottom: thin solid lightgrey\"><div\n class=\"md-headline color-black\">{{fee.name}}</div><div class=\"md-subtitle pl-8 pt-8\" style=\"color : grey\">\n${{fee.cost.toFixed(2).toLocaleString()}}</div></div><div layout=\"row\" layout-align=\"start start\"><md-button \nstyle=\"color: white\" class=\"md-raised mt-16 md-black-bg color-white\" \nng-click=\"vm.addFee(\'Monthly Fee\', vm.monthlyFees, $event)\">Add</md-button></div></md-card></div><div layout=\"row\" \nstyle=\"width : 100%; background : black\"><div style=\"padding : 9px\" flex></div><md-button flex=\"none\" \nstyle=\"color: white !important; background : green !important\" class=\"md-raised\" ng-click=\"vm.calculate();\">Calculate\n</md-button><div style=\"font-size : 48px; font-weight : 600; color : white; padding : 16px\">\nSelected Total : ${{vm.yearTotal.toFixed(2).toLocaleString()}}</div></div></div>");
$templateCache.put("app/main/vehicle/vehicle.html","<div id=\"vehicle\" layout=\"column\" class=\"full-width-height screen2\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-button ui-sref=\"app.garage\" \nclass=\"md-icon-button\" aria-label=\"Back\"><md-icon md-svg-icon=\"assets/images/cartraxx/ic_close_black_24px.svg\">\n</md-icon></md-button><h2 flex md-truncate>{{::vm.getHeadline(vm.vehicle)}}</h2></div></md-toolbar><md-content \nng-class=\"\" class=\"md-grey-100-bg\" layout=\"column\" flex><div class=\"position-relative border-bottom-grey md-white-bg\">\n<div layout=\"row\" class=\"p-16 mb-8\" style=\"min-height: 50px\"><div layout=\"column\" class=\"width-100 mr-24 hero\" \ntouched-now ng-click=\"vm.goToImage()\" layout-align=\"center center\"><image ng-if=\"vm.vehicle.vehicleImage\" \nclass=\"full-width height-auto hero\" hero-id=\"vehicleImage\" ng-src=\"{{::vm.vehicle.vehicleImage}}\"><md-icon \nng-if=\"!vm.vehicle.vehicleImage\" md-svg-src=\"assets/images/cartraxx/car.svg\" hero-id=\"vehicleImage\" \nclass=\"full-width height-auto hero\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\"><div \nclass=\"md-headline mb-8 hero\" hero-id=\"headline\">{{::vm.getHeadline(vm.vehicle)}}</div><div \nclass=\"md-subheader transparent hero\" hero-id=\"subheader\">{{::vm.getSubHeader(vm.vehicle)}}</div></div></div><div \nlayout=\"row\" class=\"pl-16 pr-8 pb-8 md-white-bg\" layout-align=\"start stretch\"><div flex=\"grow\" layout=\"row\" \nlayout-align=\"start space-around\"><div touched-now ng-click=\"vm.goToSettings(\'odometer\')\" layout=\"row\"><div \nlayout=\"column\" class=\"width-24 mr-8\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/edit.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div><div \nlayout=\"column\"><div ng-class=\"vm.focus === \'odometer\' ? \'hero\' : \'\'\" class=\"md-subheader transparent\" \nhero-id=\"odometer\">Odometer</div><div layout=\"row\"><div flex=\"grow\" class=\"md-body-1\" \nstyle=\"color: #42A5F5; text-align : start\">{{::vs.getOdometer() | number}}</div></div></div></div></div><div \nng-if=\"::vs.hasMaintenance()\" touched-now ng-click=\"vm.inputMaintenance()\" layout=\"column\" \nclass=\"width-30 ml-8 mr-8 md-white-bg\" layout-align=\"center center\"><img \nsrc=\"assets/images/cartraxx/car-repair_plus.png\" class=\"full-width height-auto hero\" hero-id=\"maintenanceImage\" \naria-label=\"Settings\"></div><div touched-now ng-click=\"vm.inputGas()\" layout=\"column\" class=\"width-30 ml-8 mr-8\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/gas-station_blue.svg\" \nclass=\"full-width height-auto hero\" hero-id=\"gasImage\" aria-label=\"Settings\"></md-icon></div><div touched-now \nng-click=\"vm.goToSettings()\" layout=\"column\" class=\"width-30 pl-8 pr-8\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/settings.svg\" class=\"full-width height-auto hero\" hero-id=\"settingsImage\" \naria-label=\"Settings\"></md-icon></div></div></div><div \nng-if=\"(!firebaseUser || firebaseUser.account.isAnonymous) && vm.showLogonNow\" \nclass=\"border-bottom-grey pt-16 pl-16 pr-16 pb-16 md-grey-800-bg animate-if-slide-160-6\"><div \nclass=\"md-subheader md-transparent-bg text-white pb-16\">\nCreate an account to get notified about open recalls, due maintenance, and recommendations to keep your car green!\n</div><div layout=\"row\" layout-align=\"start center\"><md-button ui-sref=\"app.settings_login\" md-theme=\"inputTheme\" \nclass=\"md-raised md-primary\">Login</md-button><div flex></div><md-button ui-sref=\"app.settings_register\" \nmd-theme=\"inputTheme\" class=\"md-raised md-primary\">Register</md-button></div></div><div \nng-show=\"vm.animate[0] != true\" touched-now ng-click=\"vm.recalls()\" \nclass=\"border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"{{::vs.getOpenRecallsImage()}}\" class=\"full-width height-auto hero\" hero-id=\"recallImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"md-subheader-black transparent\">{{::vs.recallsTitle()}}</div><div ng-if=\"vs.hasOpenRecalls()\" \nclass=\"md-subheader mt-8 transparent font-weight-300 truncate-2\">{{::vs.getFirstRecall().summary}}</div></div></div>\n</div><div ng-if=\"::vs.hasMaintenance()\" ng-show=\"vm.animate[1] != true\" touched-now ng-click=\"vm.maintenance()\" \nclass=\"position-relative md-white-bg border-bottom-grey {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><img \nng-src=\"{{::vs.getMaintenanceStatusImage()}}\" class=\"full-width height-auto hero\" hero-id=\"maintenanceListImage\" \naria-label=\"Cake\"></div><div layout=\"column\" layout-align=\"center start\"><div class=\"md-subheader-black transparent\">\n{{::vs.getMaintenanceStatusTitle()}}</div><div \nng-if=\"vs.hasDueMaintenanceCount() && vm.firstMaintenance.itemDescription\" \nclass=\"md-subheader mt-8 transparent font-weight-300 truncate-2\">\n{{::vm.firstMaintenance.action + \" \" + vm.firstMaintenance.item + \" - \" + vm.firstMaintenance.itemDescription}}</div>\n</div></div></div><div ng-show=\"vm.animate[2] != true\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/money-bag.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon>\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Vehicle Value</div>\n<div layout=\"row\" class=\"mt-8\" layout-align=\"start center\"><div ng-if=\"value.item\" class=\"md-header transparent mr-16\" \nstyle=\"color: #808080; text-align: center; font-size : 20px\">${{value.item | number}}</div><md-select \nng-model=\"valueId\" class=\"m-0\"><md-option ng-if=\"vm.vehicle.formattedJson[\'34\']\" value=\"34\">Used Retail</md-option>\n<md-option ng-if=\"vm.vehicle.formattedJson[\'35\']\" value=\"35\">Used Private Party</md-option><md-option \nng-if=\"vm.vehicle.formattedJson[\'36\']\" value=\"36\">Used Trade-in</md-option></md-select></div></div></div></div><div \nng-show=\"vm.animate[3] != true\" touched-now ng-click=\"vm.checkGas()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/gasoline-station-green.svg\" class=\"full-width height-auto hero\" \nhero-id=\"gasOverviewImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Monitor Gas Usage</div><div ng-if=\"vm.vehicle.estimatedMPG.newMPG\" layout=\"row\">\n<div class=\"md-subheader font-weight-300 transparent mt-16\"><span class=\"md-header transparent\" \nstyle=\"color: #000000; font-size : 20px\">{{::vm.vehicle.estimatedMPG.newMPG | number : 2}}</span>&nbsp;mpg</div>\n<md-icon md-svg-src=\"{{::vm.estimatedImage}}\" class=\"s24 ml-8\" style=\"margin-top : 12px\" aria-label=\"Cake\"></md-icon>\n</div><div ng-if=\"!vm.vehicle.estimatedMPG.newMPG\" class=\"md-subheader mt-8\">Start Tracking Gas Now!</div></div></div>\n</div><div ng-show=\"vm.animate[4] != true\" touched-now ng-click=\"vm.historyReport()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/medical-history.svg\" class=\"full-width height-auto hero\" \nhero-id=\"historyReportImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Vehicle History Report</div><div layout=\"row\" class=\"mt-8\" \nlayout-align=\"start start\"><md-icon md-svg-src=\"assets/images/cartraxx/checked.svg\" class=\"width-16 height-16 m-0\" \naria-label=\"Cake\"></md-icon><div class=\"md-subheader transparent ml-8\" style=\"color : green\"><b>FOUND</b></div></div>\n</div></div></div><div ng-if=\"vm.vehicle.formattedJson\" ng-show=\"vm.animate[5] != true\" touched-now \nng-click=\"vm.goToDetails()\" \nclass=\"position-relative md-white-bg border-bottom-grey {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24 hero\" layout-align=\"center center\">\n<image ng-if=\"vm.vehicle.vehicleImage\" class=\"full-width height-auto hero\" hero-id=\"vehicleDetailsImage\" \nng-src=\"{{::vm.vehicle.vehicleImage}}\"><md-icon ng-if=\"!vm.vehicle.vehicleImage\" \nmd-svg-src=\"assets/images/cartraxx/car.svg\" hero-id=\"vehicleDetailsImage\" class=\"full-width height-auto hero\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Vehicle Details</div></div></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></div>");
$templateCache.put("app/core/directives/go-back/go-back.html","<div touch-now ng-click=\"vm.goBack()\" class=\"md-icon-button pr-8\" aria-label=\"Back\"><md-icon \nmd-svg-icon=\"assets/images/cartraxx/ic_arrow_back_black_24px.svg\"></md-icon></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input autocomplete=\"off\" id=\"ms-search-bar-input\" \ntype=\"text\" placeholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input autocomplete=\"off\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/progress-view/progress-view.html","<div class=\"full-width-height\" style=\"background: rgba(0,0,0,.3); z-index: 100\" layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular class=\"m-8\" md-diameter=\"100\"></md-progress-circular></div>");
$templateCache.put("app/main/common/dialogs/dialog_list.html","<md-dialog aria-label=\"List\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools min-height-56\"><h2>{{title}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content><div touched-now ng-click=\"vm.select(item)\" class=\"border-bottom-grey p-16\" \nng-repeat=\"item in items\"><div ng-if=\"item.htmlPath\" ng-include=\"item.htmlPath\"></div><div ng-if=\"!item.htmlPath\" \nclass=\"md-headline\">{{item[text]}}</div></div></md-content></form></md-dialog>");
$templateCache.put("app/main/garage/add/select_item.html","<div class=\"md-headline\">{{item.name}}</div>");
$templateCache.put("app/main/garage/add/vehicle-add.html","<form name=\"vUpdates\" id=\"vehicle-add\" layout=\"column\" class=\"full-width-height screen2\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/plus.svg\" class=\"s24 hero\" hero-id=\"settingsImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left: 16px\" flex md-truncate>Add Vehicle</h2></div></md-toolbar>\n<md-content ng-class=\"md-white-bg\" layout=\"column\" flex><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div md-theme=\"inputTheme\" \nclass=\"position-relative p-16 border-bottom-grey md-headline\"><md-input-container class=\"md-block mb-0 mt-40\" \nflex-gt-sm><label>VIN</label><input autocomplete=\"off\" autocomplete=\"off\" required type=\"text\" \nstyle=\"text-transform: uppercase\" name=\"vin\" ng-model=\"vin\" minlength=\"17\" md-maxlength=\"17\"><div \nng-messages=\"vUpdates.vin.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\" \nclass=\"my-message\">VIN cannot be more than 17 digits</div><div ng-message=\"minlength\" class=\"my-message\">\nVIN cannot be less than 17 digits</div><div ng-message=\"required\" class=\"my-message\">VIN is required</div></div>\n</md-input-container><div class=\"animate-if-slide-80 mt-8 height-70 position-relative\" ng-if=\"vm.yearGuide\">\n<md-input-container class=\"full-width position-absolute md-block\"><label>Choose Style...</label><md-select name=\"year\" \nrequired ng-model=\"vm.year\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"year in vm.yearGuide track by year.id\" ng-value=\"year\"><div>{{year.name}}</div></md-option></md-select><div \nng-messages=\"vUpdates.year.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message\">Year is required</div></div></md-input-container><div \nng-click=\"vm.getList(\'Year\', vm.yearGuide, $event)\" class=\"position-absolute full-width-height\"></div></div><div \nclass=\"animate-if-slide-80 height-70 mt-8 position-relative\" ng-if=\"vm.styleGuide\"><md-input-container md-no-asterick \nclass=\"full-width position-absolute md-block\"><label>Choose Style...</label><md-select name=\"style\" required \nng-model=\"vm.style\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"style in vm.styleGuide track by style.id\" ng-value=\"style\"><div>{{style.name}}</div></md-option></md-select>\n<div ng-messages=\"vUpdates.style.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div \nng-if=\"vUpdates.style.$invalid\" style=\"font-size : 12px\" class=\"my-message\">Style is required</div></div>\n</md-input-container><div ng-click=\"vm.getList(\'Style\', vm.styleGuide, $event)\" \nclass=\"position-absolute full-width-height\"></div></div><div class=\"mt-16\" layout=\"row\" layout-align=\"end end\">\n<md-button ng-click=\"vm.decode($event)\" type=\"submit\" class=\"md-raised md-accent\">Submit</md-button></div><md-button \nng-if=\"app.handlerContains(\'decodeByBarcode\')\" ng-click=\"vm.scanVIN()\" class=\"md-raised md-primary\"><div layout=\"row\">\n<div>Scan Barcode</div><md-icon class=\"s16 ml-8\" md-svg-icon=\"assets/images/cartraxx/ic_photo_camera_white_24px.svg\">\n</md-icon></div></md-button></div><div class=\"position-relative p-16 border-bottom-grey\"><div \nclass=\"md-headline mt-24\">Where is the VIN located?</div><img ng-src=\"assets/images/cartraxx/vin_location.jpg\"><div \nclass=\"md-body-1-grey mt-24\">\nYour VIN is usually located on the windshield of the driver\'s side, or inside the driver\'s side door. There may also be a barcode which can be scanned.\n<br><br>The VIN will be 17 digits.</div></div><div class=\"position-relative p-16 border-bottom-grey\"><div \nclass=\"md-headline mt-24\">Why do you need my VIN?</div><div class=\"md-body-1-grey mt-24\">\nYour VIN is the unique identifier of your car, and with it we can deduce what make, model, and year you have. This allows us to track open recalls specific to your vehicle, give you maintenance reminders for your vehicle, and get vehicle history reports. Essentially, you will get the best catered experience for your vehicle and help you maintain it for a maximum efficiency, longetivity, and enjoyment!\n</div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/achievements/achievements.html","<form name=\"vUpdates\" id=\"vehicle-achievements\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/medical-history.svg\" class=\"s24 hero\" \nhero-id=\"historyReportImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>History Reports\n</h2></div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div touched-now \nng-click=\"carfax()\" target=\"_blank\" class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-100 mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/cartraxx/carfox.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"column\" style=\"width : 175px\" class=\"mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/cartraxx/carfax_logo.jpg\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nclass=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">$29.99!</span></div></div></div></div><div touched-now ng-click=\"vinaudit()\" \ntarget=\"_blank\" class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-100 mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/cartraxx/vinaudit_big.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"column\" style=\"width : 175px\" class=\"mr-24\" \nlayout-align=\"center center\"><img ng-src=\"assets/images/cartraxx/vinaudit_text.png\" class=\"full-width height-auto\" \naria-label=\"Cake\"></div><div class=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">$7.99!</span></div></div></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/details/details.html","<div id=\"vehicle_details\" layout=\"column\" class=\"full-width-height screen2\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><div \nlayout=\"column\" class=\"width-24 mr-8\" layout-align=\"center center\"><image ng-if=\"vm.vehicle.vehicleImage\" \nclass=\"full-width height-auto hero\" hero-id=\"vehicleDetailsImage\" ng-src=\"{{::vm.vehicle.vehicleImage}}\"><md-icon \nng-if=\"!vm.vehicle.vehicleImage\" md-svg-src=\"assets/images/cartraxx/car.svg\" hero-id=\"vehicleDetailsImage\" \nclass=\"full-width height-auto hero\" aria-label=\"Cake\"></md-icon></div><h2 flex md-truncate>\n{{::vm.getHeadline(vm.vehicle)}}</h2></div></md-toolbar><md-content ng-class=\"\" class=\"md-grey-100-bg\" layout=\"column\" \nflex><div ng-if=\"(!firebaseUser || firebaseUser.account.isAnonymous) && vm.showLogonNow\" \nclass=\"border-bottom-grey pt-16 pl-16 pr-16 pb-16 md-grey-800-bg animate-if-slide-160-6\"><div \nclass=\"md-subheader md-transparent-bg text-white pb-16\">\nCreate an account to get notified about open recalls, due maintenance, and recommendations to keep your car green!\n</div><div layout=\"row\" layout-align=\"start center\"><md-button ui-sref=\"app.settings_login\" md-theme=\"inputTheme\" \nclass=\"md-raised md-primary\">Login</md-button><div flex></div><md-button ui-sref=\"app.settings_register\" \nmd-theme=\"inputTheme\" class=\"md-raised md-primary\">Register</md-button></div></div><div \nng-if=\"vm.vehicle.formattedJson\" ng-show=\"vm.animate[5] != true\" touched-now ng-click=\"vm.goToSpecs()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/engine.svg\" class=\"full-width height-auto hero\" hero-id=\"specsImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Specs</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.specsCount | number}} items</div></div></div></div><div ng-if=\"vm.vehicle.standardJson.equipment\" \nng-show=\"vm.animate[6] != true\" touched-now ng-click=\"vm.goToDetails()\" \nclass=\"position-relative md-white-bg border-bottom-grey {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/details.svg\" class=\"full-width height-auto hero\" hero-id=\"standardImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Details</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.standardJson.equipment.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.styleDetailsJson.options\" ng-show=\"vm.animate[7] != true\" touched-now ng-click=\"vm.goToOptions()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/bullet-list.svg\" class=\"full-width height-auto hero\" \nhero-id=\"optionsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Options</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.styleDetailsJson.options.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.complaintsJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToComplaints()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/failed-chat.svg\" class=\"full-width height-auto hero\" \nhero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Complaints</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.complaintsJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.manufacturerCommJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToManComms()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/comms.svg\" class=\"full-width height-auto hero\" hero-id=\"manCommsImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Manufacturer Communications</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.manufacturerCommJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.crashTestJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToCrash()\" class=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\">\n<div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/dummy.svg\" \nclass=\"full-width height-auto hero\" hero-id=\"crashImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">Crash Tests</div><div \nclass=\"md-subheader transparent mt-8\">{{::vm.vehicle.nhtsaInfoJson.crashTestJson.length | number}} items</div></div>\n</div></div><div ng-if=\"vm.vehicle.nhtsaInfoJson.investigationsJson.length > 0\" ng-show=\"vm.animate[7] != true\" \ntouched-now ng-click=\"vm.goToInvestigations()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/microscope.svg\" class=\"full-width height-auto hero\" \nhero-id=\"investigationsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Investigations</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.investigationsJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToRecFeatures()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/like.svg\" class=\"full-width height-auto hero\" hero-id=\"recFeaturesImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Recommended Features</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.safetyFeaturesJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToSafetyFeatures()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/seatbelt.svg\" class=\"full-width height-auto hero\" hero-id=\"safetyImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Safety Features</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.safetyFeaturesJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.bulletinsJson.serviceBulletinHolder.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToBulletins()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/cartraxx/sticky-note.svg\" class=\"full-width height-auto hero\" \nhero-id=\"bulletinsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Bulletins</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.bulletinsJson.serviceBulletinHolder.length | number}} items</div></div></div></div><progress-view \nng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/vehicle/history/history.html","<form name=\"vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/medical-history.svg\" class=\"s24 hero\" \nhero-id=\"historyReportImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>History Reports\n</h2></div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div touched-now \nng-click=\"carfax()\" target=\"_blank\" class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-100 mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/cartraxx/carfox.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"column\" style=\"width : 175px\" class=\"mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/cartraxx/carfax_logo.jpg\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nclass=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">$29.99!</span></div></div></div></div><div touched-now ng-click=\"vinaudit()\" \ntarget=\"_blank\" class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-100 mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/cartraxx/vinaudit_big.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"column\" style=\"width : 175px\" class=\"mr-24\" \nlayout-align=\"center center\"><img ng-src=\"assets/images/cartraxx/vinaudit_text.png\" class=\"full-width height-auto\" \naria-label=\"Cake\"></div><div class=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">$7.99!</span></div></div></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/image/image-bottom-sheet.html","<md-bottom-sheet class=\"md-list md-has-header\"><input class=\"position-absolute m-0\" \nstyle=\"bottom : 24px; color : white;display:none\" type=\"file\" id=\"fileInput\" accept=\"image/*\"><md-subheader ng-cloak>\nVehicle Image Actions</md-subheader><md-list ng-cloak><md-list-item ng-if=\"isApp\"><md-button ng-click=\"camera($event)\" \nclass=\"md-list-item-content\"><md-icon md-svg-src=\"assets/images/cartraxx/ic_photo_camera_black_24px.svg\"></md-icon>\n<span class=\"md-inline-list-icon-label ml-8\">Camera</span></md-button></md-list-item><md-list-item><md-button \nng-click=\"upload($event)\" class=\"md-list-item-content\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_file_upload_black_24px.svg\"></md-icon><span \nclass=\"md-inline-list-icon-label ml-8\">Upload</span></md-button></md-list-item><md-list-item><md-button \nng-click=\"default($event)\" class=\"md-list-item-content\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_file_upload_black_24px.svg\"></md-icon><span \nclass=\"md-inline-list-icon-label ml-8\">Default</span></md-button></md-list-item></md-list></md-bottom-sheet>");
$templateCache.put("app/main/vehicle/image/image.html","<form name=\"vUpdates\" id=\"vehicle-image\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-content \nclass=\"position-relative full-width md-black-500-bg\" flex=\"grow\" layout=\"column\" layout-align=\"center center\"><image \nng-if=\"vm.vehicle.vehicleImage\" class=\"full-width height-auto hero md-white-500-bg\" hero-id=\"vehicleImage\" \nng-src=\"{{::vm.vehicle.vehicleImage}}\"><md-icon ng-if=\"!vm.vehicle.vehicleImage\" \nmd-svg-src=\"assets/images/cartraxx/car.svg\" class=\"full-width height-auto hero md-white-500-bg\" hero-id=\"vehicleImage\" \naria-label=\"Cake\"></md-icon><progress-view ng-if=\"vm.loading\"></progress-view><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_close_white_24px.svg\" class=\"s24 position-absolute\" \nstyle=\"top: 16px; left : 16px\" ng-click=\"vm.goBack()\" aria-label=\"Cake\"></md-icon><md-button ng-if=\"true === false\" \nclass=\"position-absolute m-0\" style=\"bottom : 24px; color : white\" ng-click=\"showListBottomSheet()\">Edit</md-button>\n</md-content></form>");
$templateCache.put("app/main/vehicle/maintenance/maintenance.html","<form name=\"vUpdates\" id=\"vehicle-maintenance\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index: 10\" md-scroll-shrink class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><img ng-src=\"{{vs.getMaintenanceStatusImage()}}\" style=\"width:24px; height:24px\" class=\"s24 hero\" \nhero-id=\"maintenanceListImage\" aria-label=\"Cake\"><h2 style=\"margin-left:16px\" flex md-truncate>Maintenance</h2>\n<md-button ng-if=\"vm.editTracking\" class=\"md-icon-button animate-if\" aria-label=\"More\" \nng-click=\"vm.editTrackingFunc()\"><md-icon md-menu-origin md-svg-icon=\"assets/images/cartraxx/save.svg\"></md-icon>\n</md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\">\n<md-icon md-menu-origin md-svg-icon=\"assets/images/cartraxx/ic_more_vert_black_24px.svg\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.editTracking ? vm.editTracking = false : vm.editTrackingFunc()\"><md-icon \nmd-svg-icon=\"assets/images/cartraxx/mail.svg\" md-menu-align-target></md-icon>\n{{!vm.editTracking ? \'Edit Tracking\' : \'Cancel Edit\'}}</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools\"><md-icon md-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\">\n</md-icon><input autocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" \nplaceholder=\"Filter...\"></div></md-toolbar><div flex=\"fill\" class=\"position-relative\"><div ng-if=\"mItems.length > 0\" \nid=\"scroll-vs-repeat\" class=\"full-height-width md-white-bg scrollable position-absolute\" vs-repeat><div \nng-style=\"item.style\" ng-repeat=\"item in mItems track by item.item.keyId\"><div ng-if=\"item.type === \'header\'\" \nlayout=\"row\" layout-align=\"start center\" style=\"background:  #3C4252\" \nclass=\"border-bottom-grey p-8 full-height font-weight-600\"><div style=\"color : white; font-weight : 300\">\n{{item.item.text}}</div></div><div ng-if=\"item.type === \'item\'\" layout=\"row\" touched-now ng-click=\"vm.goTo(item.item)\" \nclass=\"border-bottom-grey p-16\"><div class=\"position-relative width-25 mr-24\"><md-switch \nng-click=\"$event.stopPropagation()\" ng-if=\"vm.editTracking\" ng-model=\"item.item.tracking\" \nclass=\"position-absolute-center m-0 animate-if\"></md-switch><div layout=\"column\" class=\"position-absolute-center\" \nlayout-align=\"center center\"><md-icon ng-if=\"!vm.editTracking\" \nmd-svg-src=\"{{vs.getGoodImage(!(item.item.status.indexOf(\'DUE\') > -1))}}\" class=\"full-width height-auto animate-if\" \naria-label=\"Cake\"></md-icon></div></div><div layout=\"column\" flex><div \nclass=\"md-subheader-black md-truncate mb-8 md-2-line\">{{item.item.action}} {{item.item.item}}</div><div \nclass=\"md-subheader md-transparent-bg line-clamp-3\">{{item.item.itemDescription}}</div><div ng-if=\"true === false\" \nlayout=\"row\" class=\"md-body-1 mt-8\"><div ng-if=\"item.item.intervalMileage\">{{item.item.intervalMileage | number}} miles\n</div><div ng-if=\"item.item.intervalMileage && item.item.intervalMonth\">&nbsp;,&nbsp;</div><div \nng-if=\"item.item.intervalMonth\">{{item.item.intervalMonth | number}} months</div></div><div class=\"mt-8\"></div><div \nng-if=\"item.item.nextDueOdomoter\" ng-style=\"vm.textColor(item.item)\">{{vm.dueMileage(item.item)}}</div><div \nng-if=\"item.item.nextDueDate\" ng-style=\"vm.textColor(item.item)\">{{vm.dueInTime(item.item)}}</div><md-progress-linear \nmd-theme=\"{{item.item.duePercentage > 1 ? \'orangeTheme\' : \'greenTheme\'}}\" class=\"md-green-bg mt-8\" \nmd-mode=\"determinate\" value=\"{{item.item.duePercentage * 100}}\"></md-progress-linear></div></div></div></div><div \nstyle=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height md-white-bg p-32\" ng-if=\"mItems.length === 0\"><div>\nNo Maintenance Found for Filter!</div></div><progress-view ng-if=\"vm.loading\"></progress-view></div></form>");
$templateCache.put("app/main/vehicle/recalls/recalls.html","<div id=\"recalls\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"{{vs.getOpenRecallsImage()}}\" class=\"s24 hero\" hero-id=\"recallImage\" aria-label=\"Cake\"></md-icon><h2 \nstyle=\"margin-left:16px\" flex md-truncate>{{vm.getTitle()}}</h2></div></md-toolbar><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.recalls.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height md-white-bg scrollable\" \nvs-repeat><div touched-now layout=\"row\" ng-click=\"vm.goTo(recall)\" class=\"border-bottom-grey p-16\" \nng-repeat=\"recall in vm.recalls track by recall.id\"><div layout=\"column\" class=\"width-25 mr-24\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"{{vs.getOpenRecallsImage(recall)}}\" class=\"full-width height-auto\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" flex><div class=\"md-subheader-black md-truncate\">\n{{vm.getTitleItem(recall)}}</div><div class=\"md-subheader md-transparent-bg mt-8\">\nIssued : {{recall.reportReceivedDate | date:\'longDate\'}}</div><div class=\"md-body-1 mt-8\">\n{{vs.componentsToString(recall)}}</div></div></div></div><div style=\"text-align: center\" layout=\"column\" \nlayout-align=\"center center\" class=\"md-headline full-width-height md-white-bg p-32\" ng-if=\"vm.recalls.length === 0\">\n<div>No Recalls Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/settings/settings.html","<form name=\"vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/settings.svg\" class=\"s24 hero\" hero-id=\"settingsImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Vehicle Settings</h2><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"md-icon-button\" aria-label=\"Save\"><md-icon \nmd-svg-icon=\"assets/images/cartraxx/save.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div class=\"position-relative border-bottom-grey p-16\" \nlayout-align=\"start stretch\"><div class=\"md-headline mb-32\">{{vs.getMakeModelYear(vm.vehicle)}}</div>\n<md-input-container class=\"md-block mb-0 md-title\" flex-gt-sm><label>Nickname</label><input autocomplete=\"off\" \nname=\"nickname\" ng-model=\"vm.updatedSettings.nickname\" placeholder=\"Max\'s Car\" md-maxlength=\"30\"><div \nng-messages=\"vUpdates.nickname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\" \nclass=\"my-message\">Nickname cannot be more than 30 characters</div></div></md-input-container><md-input-container \nclass=\"md-block mb-0 md-title\" flex-gt-sm><label>License Plate</label><input autocomplete=\"off\" name=\"licensePlate\" \nng-model=\"vm.updatedSettings.licensePlate\" placeholder=\"ACD-123\" md-maxlength=\"10\"><div \nng-messages=\"vUpdates.licensePlate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\" \nclass=\"my-message\">License plate cannot be more than 10 characters</div></div></md-input-container><md-input-container \nclass=\"md-block mb-16 md-title\" flex-gt-sm><label>Postal Code</label><input autocomplete=\"off\" type=\"number\" \nname=\"postalCode\" ng-model=\"vm.updatedSettings.postalCode\" placeholder=\"12345\" ng-pattern=\"/^[0-9]{5}$/\" max=\"99999\" \nmax=\"5\"><div ng-messages=\"vUpdates.postalCode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\" \nclass=\"my-message\">That doesn\'t look like a valid postal code.</div><div ng-message=\"max\" class=\"my-message\">\nZipcode cannot be more than 5 digits</div></div></md-input-container><md-input-container \nclass=\"md-block mb-0 md-title\" flex-gt-sm><label>VIN</label><input ng-disabled=\"true === true\" \nng-model=\"vm.vehicle.vin\"></md-input-container></div><div layout=\"column\" \nclass=\"position-relative border-bottom-grey p-16\" layout-align=\"start stretch\"><div class=\"md-headline mb-24\">Mileage\n</div><md-input-container class=\"md-block mb-0 md-title\" flex-gt-sm><label hero-id=\"odometer\" class=\"hero\">Odometer\n</label><input autocomplete=\"off\" focus-on=\"vm.focus === \'odometer\';\" scroll-if=\"vm.focus === \'odometer\';\" \ntype=\"number\" name=\"odometer\" ng-model=\"vm.updatedSettings.odometer\" placeholder=\"123,456\" max=\"9999999\"><div \nng-messages=\"vUpdates.odometer.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">\nOdometer cannot be more than 8 digits</div></div></md-input-container><div \nng-if=\"vm.updatedSettings.autoUpdateMileage\" class=\"animate-if-slide-80 md-title\"><md-input-container \nclass=\"md-block mb-0\" flex-gt-sm><label>Mileage per day added</label><input autocomplete=\"off\" type=\"number\" \nname=\"nickname\" ng-model=\"vm.updatedSettings.updateMileagePerDay\" placeholder=\"37 (default)\" max=\"9999\"><div \nng-messages=\"vUpdates.nickname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">\nMileage can be no more than 9,999 per day</div></div></md-input-container></div><md-switch \nng-model=\"vm.updatedSettings.autoUpdateMileage\" aria-label=\"Switch 2\">Auto Update Odometer Daily</md-switch></div><div \nlayout=\"column\" class=\"position-relative border-bottom-grey p-16\" layout-align=\"start\"><div class=\"md-headline mb-24\">\nTracking</div><md-switch ng-model=\"vm.updatedSettings.trackRecalls\" aria-label=\"Switch 2\">Track Recalls</md-switch>\n<md-switch ng-model=\"vm.updatedSettings.trackMaintenance\" aria-label=\"Switch 2\">Track Maintenance</md-switch></div><div\n layout=\"column\" class=\"position-relative border-bottom-grey p-16\"><md-button class=\"md-raised md-warn\" \nng-click=\"vm.deleteVehicle($event)\">Delete Vehicle</md-button></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/settings/download/download.html","<form name=\"myForm\" id=\"download\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-content \nclass=\"position-relative full-width md-grey-100-bg\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div id=\"scrollingaragenew\" style=\"overflow-y: scroll\" \nclass=\"pointer full-height-width position-absolute animate-if md-white-bg\"><div class=\"border-bottom-grey pt-16\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-display-2 center pb-16\" ui-sref=\"app.garage\" \nstyle=\"color : #707070; font-weight: 800\">Cartraxx</div><image class=\"logo main-icon height-auto mb-16\" \nui-sref=\"app.garage\" ng-src=\"assets/images/cartraxx/car-white-square.png\"></image><div layout=\"row\" \nlayout-align=\"space-around center\"><a target=\"_blank\" \nhref=\"https://play.google.com/store/apps/details?id=com.mtsdealersolutions.cartraxx&hl=en\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/google_play.svg\" style=\"height : 64px; width : 128px\" class=\"mr-16\" \naria-label=\"Cake\"></md-icon></a><a target=\"_blank\" href=\"https://itunes.apple.com/us/app/cartraxx/id1268858007?mt=8\">\n<md-icon md-svg-src=\"assets/images/cartraxx/app_store.svg\" style=\"height : 64px; width : 128px\" class=\"ml-16\" \naria-label=\"Cake\"></md-icon></a></div></div><div class=\"border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/sustainable.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div>\n<div layout=\"column\"><div class=\"md-title text-black transparent mb-8\">Eco Friendly</div><div \nclass=\"md-subheader transparent\">Learn the CO2 output of your vehicle and how to keep it running eco friendly!</div>\n</div></div></div><div class=\"border-bottom-grey\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div \nlayout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/dummy.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div><div \nlayout=\"column\"><div class=\"md-title text-black transparent mb-8\">Open Recalls</div><div \nclass=\"md-subheader transparent\">Knowing what recalls are open on your vehicle keeps you and your family safe!</div>\n</div></div></div><div class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/engine.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div><div \nlayout=\"column\"><div class=\"md-title text-black transparent mb-8\">Maintenance</div><div \nclass=\"md-subheader transparent\">\nYour vehicle desrves to be pampered, and keeping it healthy will extend it\'s life! Best of all, consistent maintenance decreases your \n<b style=\"font-weight : 800; color :#404040\">carbon footprint</b> by up to <b \nstyle=\"font-weight : 800; color : #404040\">30%</b> and reduce costs over the life of your vehicle by <b \nstyle=\"font-weight : 800; color : #404040\">24%</b>!</div></div></div></div><div \nclass=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div \nlayout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/gas-station.svg\" class=\"full-width height-auto\" aria-label=\"Cake\"></md-icon></div>\n<div layout=\"column\"><div class=\"md-title text-black transparent mb-8\">Gas</div><div class=\"md-subheader transparent\">\nTracking your fuel efficency and get recommendations from <b style=\"font-weight : 800; color :#404040\">Cartraxx</b>\n on how to improve your efficency!</div></div></div></div><div class=\"position-relative border-bottom-grey\"><div \nlayout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/money-bag.svg\" class=\"full-width height-auto\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\"><div class=\"md-title text-black transparent mb-8\">Value</div>\n<div class=\"md-subheader transparent\">Manage costs and keep track of savings by using <b \nstyle=\"font-weight : 800; color :#404040\">Cartraxx</b>! See your vehicle\'s value as it changes over time. Know the <b \nstyle=\"font-weight : 800; color :#404040\">Cost to Own</b> for the vehicle and where your vehicle stands!</div></div>\n</div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></form>");
$templateCache.put("app/main/settings/contact-us/contact-us.html","<form name=\"myForm\" id=\"contact-us\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/mail_outline.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon><h2 \nstyle=\"margin-left:16px\" flex md-truncate>Contact Us</h2><md-button type=\"submit\" ng-click=\"vm.send(myForm)\" \nstyle=\"min-width : 48px\" class=\"\"><md-icon class=\"s32\" md-font-icon=\"icon-send\" style=\"color:black\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Send</md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"position-relative full-width md-grey-100-bg\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">\nSelect Group</span> <span class=\"md-subhead\">Tell us which group you would like to contact.</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"row\"><md-input-container><label>Contact...</label><md-select required \nng-model=\"vm.obj.contact\"><md-option ng-repeat=\"contact in vm.contacts\" ng-value=\"contact.value\">{{contact.name}}\n</md-option></md-select></md-input-container></div></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Your Contact Info</span> <span class=\"md-subhead\">\nWho should we respond back to?</span></md-card-title-text></md-card-title><md-card-content><div layout=\"column\">\n<md-input-container flex><label>First/Last Name</label><input name=\"name\" ng-model=\"vm.obj.name\" required \nmd-maxlength=\"70\" md-minlength=\"3\"><div ng-messages=\"myForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a name.</span></div><div ng-message=\"pattern\"><span>\nThat is not a valid odometer reading.</span></div><div ng-message=\"md-maxlength\"><span>\nName can\'t be longer than 70 characters.</span></div><div ng-message=\"md-minlength\"><span>\nName must be longer than 3 characters.</span></div></div></md-input-container><md-input-container flex><label>Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.obj.email\" required><div ng-messages=\"myForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><span class=\"error\" ng-show=\"myForm.email.$error.required\">Required!</span> <span \nclass=\"error\" ng-show=\"myForm.email.$error.email\">Not valid email</span></div></md-input-container></div>\n</md-card-content></md-card><md-card style=\"margin-bottom: 55px\"><md-card-title><md-card-title-text><span \nclass=\"md-headline\">Description</span> <span class=\"md-subhead\">How can we help you?</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"column\"><md-input-container flex><label>Subject</label><input \nname=\"subject\" ng-model=\"vm.obj.subject\" required md-maxlength=\"250\" md-minlength=\"5\"><div \nng-messages=\"myForm.subject.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou must supply a subject.</span></div><div ng-message=\"pattern\"><span>That is not a valid odometer reading.</span>\n</div><div ng-message=\"md-maxlength\"><span>Subject can\'t be longer than 250 characters.</span></div><div \nng-message=\"md-minlength\"><span>Subject must be longer than 5 characters.</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-title\"><label>Message Body</label><textarea ng-model=\"vm.obj.description\" \nmd-maxlength=\"5000\" rows=\"6\" md-select-on-focus></textarea></md-input-container><div layout=\"row\" \nlayout-align=\"end end\"><md-button type=\"submit\" ng-click=\"vm.send(myForm)\" class=\"md-fab md-blue-bg position-relative\">\n<md-icon class=\"s32\" md-font-icon=\"icon-send\" style=\"color:white\"></md-icon><md-tooltip md-direction=\"top\">Send\n</md-tooltip></md-button></div></div></md-card-content></md-card></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/settings/email_verify/email.html","<div id=\"emailverify\" class=\"flex-scrollable pt-64 pb-64 full-width-height\" layout=\"row\" layout-align=\"center center\" \nms-scroll><md-card flex-gt-sm=\"50\" flex=\"90\" class=\"p-16\"><div class=\"md-headline\">\nPlease verify your email to use Cartraxx! There should be an email in your inbox already!</div><div class=\"mt-32\" \nlayout=\"row\" layout-align=\" space-around\"><md-button ng-click=\"vm.signOut($event)\" \nstyle=\"color:white; text-align: center\" class=\"md-raised md-red-500-bg center\" border=\"0\" name=\"submit\">Log Out\n</md-button><md-button ng-click=\"vm.sendEmailVerification()\" style=\"color:white; text-align: center\" \nclass=\"md-raised md-green-500-bg center\" border=\"0\" name=\"submit\">Resend Email</md-button></div><div class=\"mt-32\" \nlayout=\"row\" layout-align=\" space-around\"><md-button ng-click=\"vm.checkAgain()\" \nstyle=\"color:white; text-align: center\" class=\"md-raised md-blue-500-bg center\" border=\"0\" name=\"submit\">\nI have already validated</md-button></div></md-card></div>");
$templateCache.put("app/main/settings/generic/generic.html","<form name=\"vUpdates\" id=\"garage\" class=\"full-width-height\"><div style=\"overflow-y: scroll\" \nclass=\"pointer full-height-width position-absolute animate-if md-white-bg\"><div md-theme=\"inputTheme\" layout=\"column\" \nclass=\"md-headline position-relative border-bottom-grey p-16\"><div class=\"mt-16\"><md-input-container flex \nclass=\"md-block\"><label>Labor per Hour ($)</label><md-select name=\"laborCost\" required \nng-model=\"tempSettings.laborCost\" ng-model-options=\"{trackBy: \'$value\'}\"><md-option \nng-repeat=\"cost in vm.laborCosts track by cost\" ng-value=\"cost\"><div>{{cost}}</div></md-option></md-select><div \nng-messages=\"vUpdates.laborCost.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message\">Labor Cost per Hour ($) is required</div></div></md-input-container></div></div><div layout=\"row\" \ntouched-now ng-click=\"vm.contactUs()\" class=\"md-headline position-relative border-bottom-grey p-16\"><md-icon \nclass=\"s24 m-0 mr-16 center-vertical\" md-svg-icon=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\"></md-icon>\nContact Us</div><div ng-if=\"firebaseUser.account && !firebaseUser.account.isAnonymous\" layout=\"column\" \nclass=\"position-relative border-bottom-grey p-16\"><md-button class=\"md-raised md-warn\" ng-click=\"fs.signOut($event)\">\nLog out</md-button></div></div><progress-view ng-if=\"vm.loading\"></progress-view></form>");
$templateCache.put("app/main/settings/login/login.html","<div id=\"login\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/cartraxx/user.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex \nmd-truncate>Login</h2></div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div \nmd-theme=\"inputTheme\" class=\"position-absolute scroll-y full-width\"><div layout=\"column\"><div id=\"login-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><img \nclass=\"logo main-icon\" style=\"border-radius: 22px\" src=\"assets/images/cartraxx/car-white-square.png\"><div \nclass=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><md-button ng-click=\"vm.signInWithGoogle($event)\" \nclass=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" \nclass=\"s16\"></md-icon><span translate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><div \nclass=\"separator\"><span class=\"text\" translate=\"LOGIN.OR\">OR</span></div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input autocomplete=\"off\" type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input autocomplete=\"off\" type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" style=\"width: 100%\" layout=\"column\" \nlayout-align=\"center center\"><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" ng-click=\"vm.signInEmail(vm.form.email, vm.form.password, $event)\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.settings_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content>\n</div>");
$templateCache.put("app/main/settings/privacy/privacy.html","<style>\n#ppBody\n    {\n        font-size:11pt;\n        width:100%;\n        margin:0 auto;\n        text-align:justify;\n    }\n    \n    #ppHeader\n    {\n        font-family:verdana;\n        font-size:21pt;\n        width:100%;\n        margin:0 auto;\n    }\n    \n    .ppConsistencies\n    {\n        display:none;\n    }\n</style><div style=\"background: white\" class=\"p-16\"><div id=\"ppHeader\">Cartraxx.com Privacy Policy</div><div \nid=\"ppBody\"><div class=\"ppConsistencies\"><div class=\"col-2\"><div class=\"quick-links text-center\">Information Collection\n</div></div><div class=\"col-2\"><div class=\"quick-links text-center\">Information Usage</div></div><div class=\"col-2\">\n<div class=\"quick-links text-center\">Information Protection</div></div><div class=\"col-2\"><div \nclass=\"quick-links text-center\">Cookie Usage</div></div><div class=\"col-2\"><div class=\"quick-links text-center\">\n3rd Party Disclosure</div></div><div class=\"col-2\"><div class=\"quick-links text-center\">3rd Party Links</div></div><div\n class=\"col-2\"></div></div><div style=\"clear:both;height:10px\"></div><div class=\"ppConsistencies\"><div class=\"col-2\">\n<div class=\"col-12 quick-links2 gen-text-center\">Google AdSense</div></div><div class=\"col-2\"><div \nclass=\"col-12 quick-links2 gen-text-center\">Fair Information Practices<div \nclass=\"col-8 gen-text-left gen-xs-text-center\" style=\"font-size:12px;position:relative;left:20px\">Fair information<br>\nPractices</div></div></div><div class=\"col-2\"><div class=\"col-12 quick-links2 gen-text-center coppa-pad\">COPPA</div>\n</div><div class=\"col-2\"><div class=\"col-12 quick-links2 quick4 gen-text-center caloppa-pad\">CalOPPA</div></div><div \nclass=\"col-2\"><div class=\"quick-links2 gen-text-center\">Our Contact Information<br></div></div></div><div \nstyle=\"clear:both;height:10px\"></div><div class=\"innerText\">\nThis privacy policy has been compiled to better serve those who are concerned with how their \'Personally Identifiable Information\' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.\n<br></div><span id=\"infoCo\"></span><br><div class=\"grayText\"><strong>\nWhat personal information do we collect from the people that visit our blog, website or app?</strong></div><br><div \nclass=\"innerText\">\nWhen ordering or registering on our site, as appropriate, you may be asked to enter your email address or other details to help you with your experience.\n</div><br><div class=\"grayText\"><strong>When do we collect information?</strong></div><br><div class=\"innerText\">\nWe collect information from you when you register on our site or enter information on our site.</div><br><span \nid=\"infoUs\"></span><br><div class=\"grayText\"><strong>How do we use your information? </strong></div><br><div \nclass=\"innerText\">\nWe may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:\n<br><br></div><div class=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.\n</div><div class=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n To improve our website in order to better serve you.</div><span id=\"infoPro\"></span><br><div class=\"grayText\"><strong>\nHow do we protect your information?</strong></div><br><div class=\"innerText\">\nOur website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.\n<br><br></div><div class=\"innerText\">We use regular Malware Scanning.<br><br></div><div class=\"innerText\">\nYour personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.\n</div><br><div class=\"innerText\">\nWe implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information.\n</div><br><div class=\"innerText\">\nAll transactions are processed through a gateway provider and are not stored or processed on our servers.</div><span \nid=\"coUs\"></span><br><div class=\"grayText\"><strong>Do we use \'cookies\'?</strong></div><br><div class=\"innerText\">\nYes. Cookies are small files that a site or its service provider transfers to your computer\'s hard drive through your Web browser (if you allow) that enables the site\'s or service provider\'s systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.\n</div><div class=\"innerText\"><br><strong>We use cookies to:</strong></div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong> Understand and save user\'s preferences for future visits.</div>\n<div class=\"innerText\"><br>\nYou can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser\'s Help Menu to learn the correct way to modify your cookies.\n<br></div><br><div class=\"innerText\">\nIf you turn cookies off, Some of the features that make your site experience more efficient may not function properly.It won\'t affect the user\'s experience that make your site experience more efficient and may not function properly.\n</div><br><span id=\"trDi\"></span><br><div class=\"grayText\"><strong>Third-party disclosure</strong></div><br><div \nclass=\"innerText\">\nWe do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.</div><span \nid=\"trLi\"></span><br><div class=\"grayText\"><strong>Third-party links</strong></div><br><div class=\"innerText\">\nOccasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.\n</div><span id=\"gooAd\"></span><br><div class=\"blueText\"><strong>Google</strong></div><br><div class=\"innerText\">\nGoogle\'s advertising requirements can be summed up by Google\'s Advertising Principles. They are put in place to provide a positive experience for users. https://support.google.com/adwordspolicy/answer/1316548?hl=en\n<br><br></div><div class=\"innerText\">We use Google AdSense Advertising on our website.</div><div class=\"innerText\"><br>\nGoogle, as a third-party vendor, uses cookies to serve ads on our site. Google\'s use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.\n<br></div><div class=\"innerText\"><br><strong>We have implemented the following:</strong></div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong> Remarketing with Google AdSense</div><br><div class=\"innerText\">\nWe, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.\n</div><div class=\"innerText\"><br><strong>Opting out:</strong><br>\nUsers can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.\n</div><span id=\"calOppa\"></span><br><div class=\"blueText\"><strong>California Online Privacy Protection Act</strong>\n</div><br><div class=\"innerText\">\nCalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law\'s reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies with whom it is being shared. - See more at: http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf\n<br></div><div class=\"innerText\"><br><strong>According to CalOPPA, we agree to the following:</strong><br></div><div \nclass=\"innerText\">Users can visit our site anonymously.</div><div class=\"innerText\">\nOnce this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website.\n<br></div><div class=\"innerText\">\nOur Privacy Policy link includes the word \'Privacy\' and can easily be found on the page specified above.</div><div \nclass=\"innerText\"><br>You will be notified of any Privacy Policy changes:</div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong> On our Privacy Policy Page<br></div><div class=\"innerText\">\nCan change your personal information:</div><div class=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;\n</strong> By logging in to your account</div><div class=\"innerText\"><br><strong>\nHow does our site handle Do Not Track signals?</strong><br></div><div class=\"innerText\">\nWe honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.\n</div><div class=\"innerText\"><br><strong>Does our site allow third-party behavioral tracking?</strong><br></div><div \nclass=\"innerText\">It\'s also important to note that we do not allow third-party behavioral tracking</div><span \nid=\"coppAct\"></span><br><div class=\"blueText\"><strong>COPPA (Children Online Privacy Protection Act)</strong></div><br>\n<div class=\"innerText\">\nWhen it comes to the collection of personal information from children under the age of 13 years old, the Children\'s Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States\' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children\'s privacy and safety online.\n<br><br></div><div class=\"innerText\">We do not specifically market to children under the age of 13 years old.</div><div\n class=\"innerText\">Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?</div>\n<span id=\"ftcFip\"></span><br><div class=\"blueText\"><strong>Fair Information Practices</strong></div><br><div \nclass=\"innerText\">\nThe Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information.\n<br><br></div><div class=\"innerText\"><strong>\nIn order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:\n</strong></div><div class=\"innerText\">We will notify you via email</div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong> Within 1 business day</div><div class=\"innerText\">\nWe will notify the users via in-site notification</div><div class=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>\n&bull;</strong> Within 1 business day</div><div class=\"innerText\"><br>\nWe also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.\n</div><span id=\"canSpam\"></span><br><div class=\"blueText\"><strong>CAN SPAM Act</strong></div><br><div \nclass=\"innerText\">\nThe CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.\n<br><br></div><div class=\"innerText\"><strong>We collect your email address in order to:</strong></div><div \nclass=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n Send information, respond to inquiries, and/or other requests or questions</div><div class=\"innerText\"><br><strong>\nTo be in accordance with CANSPAM, we agree to the following:</strong></div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong> Not use false or misleading subjects or email addresses.</div>\n<div class=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n Identify the message as an advertisement in some reasonable way.</div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n Include the physical address of our business or site headquarters.</div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n Monitor third-party email marketing services for compliance, if one is used.</div><div class=\"innerText\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong> Honor opt-out/unsubscribe requests quickly.</div><div \nclass=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n Allow users to unsubscribe by using the link at the bottom of each email.</div><div class=\"innerText\"><strong><br>\nIf at any time you would like to unsubscribe from receiving future emails, you can email us at</strong></div><div \nclass=\"innerText\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>&bull;</strong>\n Follow the instructions at the bottom of each email.</div>and we will promptly remove you from <strong>ALL</strong>\n correspondence.</div><br><span id=\"ourCon\"></span><br><div class=\"blueText\"><strong>Contacting Us</strong></div><br>\n<div class=\"innerText\">\nIf there are any questions regarding this privacy policy, you may contact us using the information below.<br><br></div>\n<div class=\"innerText\">cartraxx.com</div><div class=\"innerText\">1226 Greenway Dr</div>Allen, Texas 75013<div \nclass=\"innerText\">United States</div><div class=\"innerText\">tech-support@cartraxx.com</div><div class=\"innerText\"><br>\nLast Edited on 2017-10-07</div></div>");
$templateCache.put("app/main/settings/register/register.html","<div id=\"register\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/cartraxx/user.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex \nmd-truncate>Create Account</h2></div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div \nmd-theme=\"inputTheme\" class=\"position-absolute scroll-y full-width\"><div><div id=\"register-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><img \nclass=\"logo main-icon\" style=\"border-radius: 22px\" src=\"assets/images/cartraxx/car-white-square.png\"><md-button \nmd-ink-ripple ng-click=\"vm.signInWithGoogle($event)\" class=\"md-raised google\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"REGISTER.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><div class=\"login\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.settings_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div><div class=\"separator\"><span class=\"text\" translate=\"REGISTER.OR\">OR</span></div><div class=\"title\" \ntranslate=\"REGISTER.TITLE\">Create an account</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\"><input autocomplete=\"off\" name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" required><div\n ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input autocomplete=\"off\" type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\"><input\n autocomplete=\"off\" type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required \nng-minlength=\"vm.passwordLengthRequired\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div \nng-message=\"minlength\">Password must be {{vm.passwordLengthRequired}} or more characters</div><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input autocomplete=\"off\" type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" required \nng-pattern=\"vm.form.password\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"pattern\">Password Confirmation does not match</div><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \nng-click=\"vm.createUserWithEmailAndPassword(vm.form.email, vm.form.password, vm.form.username, $event)\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.settings_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div></div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp min-height-56\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" \nsrc=\"assets/images/art/bottlerocket_icon.jpeg\"><span class=\"logo-text\">BR Art</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent min-height-56\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" sidebarjs-toggle aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"toolbar-separator\"></div><md-icon md-svg-src=\"{{currentNavItem.svgIcon}}\" class=\"s24 ml-16\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{currentNavItem.title}}</h2><md-button \nng-if=\"saveSettings\" type=\"submit\" ng-click=\"saveSettings()\" class=\"md-icon-button\" aria-label=\"Save\"><md-icon \nmd-svg-icon=\"assets/images/cartraxx/save.svg\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar ng-if=\"firebaseUser\" \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\n{{firebaseUser.displayName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout($event)\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-red-A700-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/vehicle/details/bulletins/bulletins.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/sticky-note.svg\" class=\"s24 hero\" hero-id=\"bulletinsImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Recommended Features</h2></div></md-toolbar>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<md-icon md-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToItem(item)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.items track by item.id\"><div flex class=\"mr-16\"><div class=\"md-title truncate-2\">\n{{::item.bulletinNumber}}</div><div ng-if=\"item.componentDescription\" class=\"md-body line-height-14 truncate-2 mt-8\">\n{{vm.compDesc(item)}}</div></div><md-icon md-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" \nclass=\"s24\" aria-label=\"Cake\"></md-icon></div></div><div style=\"text-align: center\" layout=\"column\" \nlayout-align=\"center center\" class=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>\nNo Features Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/details/complaints/complaints.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/failed-chat.svg\" class=\"s24 hero\" hero-id=\"complaintsImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Complaints</h2></div></md-toolbar><md-toolbar\n style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.complaints.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToComplaintItem(item)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.complaints track by item.nhtsaIdNumber\"><div flex class=\"mr-16\"><div \nclass=\"md-subheader-black truncate-1\">{{item.dateOfIncident | date : \"MMMM dd, yyyy\"}}</div><div \nclass=\"md-subheader mt-8 truncate-3\">{{item.description}}</div></div><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.complaints.length === 0\"><div>No Complaints Found for Filter!\n</div></div></div>");
$templateCache.put("app/main/vehicle/details/crash/crash.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/dummy.svg\" class=\"s24 hero\" hero-id=\"crashImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Crash Tests</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.crashTests.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToComplaintItem(item)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.crashTests track by item.type\"><div flex class=\"mr-16\"><div class=\"md-title truncate-1\">\n{{item.display}}</div><div class=\"md-subheader mt-8 truncate-3\">{{item.ratings.length | number}} Ratings</div></div>\n<md-icon md-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon>\n</div></div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.crashTests.length === 0\"><div>No crashTests Found for Filter!\n</div></div></div>");
$templateCache.put("app/main/vehicle/details/investigations/investigations.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/microscope.svg\" class=\"s24 hero\" hero-id=\"investigationsImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Investigations</h2></div></md-toolbar>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<md-icon md-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.investigations.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat>\n<div layout=\"row\" touched-now ng-click=\"vm.goToComplaintItem(item)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.investigations track by item.nhtsaActionNumber\"><div flex class=\"mr-16\"><div \nclass=\"md-title truncate-1\">{{item.subject}}</div><div class=\"md-subheader mt-8 truncate-3\">{{item.summary}}</div>\n</div><md-icon md-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\">\n</md-icon></div></div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.investigations.length === 0\"><div>\nNo Investigations Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/details/man_comms/man_comms.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/comms.svg\" class=\"s24 hero\" hero-id=\"manCommsImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Communications</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.manComms.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToComplaintItem(item)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.manComms track by item.nhtsaIdNumber\"><div flex class=\"mr-16\"><div \nclass=\"md-subheader-black truncate-1\">{{item.communicationDate | date : \"MMMM dd, yyyy\"}}</div><div \nclass=\"md-subheader mt-8 truncate-3\">{{item.summary}}</div></div><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.manComms.length === 0\"><div>No Communications Found for Filter!\n</div></div></div>");
$templateCache.put("app/main/vehicle/details/options/options.html","<div id=\"options\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/cartraxx/bullet-list.svg\" class=\"s24 hero\" hero-id=\"optionsImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Options</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.options.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToOptions(option)\" class=\"border-bottom-grey p-16 md-white-bg\" \nng-repeat=\"option in vm.options track by option.category\"><div flex><div class=\"md-headline\">{{option.category}}</div>\n<div class=\"md-subheader\">{{option.options.length}} options</div></div><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.options.length === 0\"><div>No Specs Found for Filter!</div></div>\n</div>");
$templateCache.put("app/main/vehicle/details/rec_features/rec_features.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/like.svg\" class=\"s24 hero\" hero-id=\"recFeaturesImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Recommended Features</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToItem($index)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.items track by item.label\"><div flex class=\"mr-16\"><div class=\"md-title truncate-2\">\n{{::item.label}}</div><div class=\"md-subheader mt-8 truncate-3\">{{item.description}}</div></div><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>No Features Found for Filter!</div></div>\n</div>");
$templateCache.put("app/main/vehicle/details/safety_features/safety_features.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/seatbelt.svg\" class=\"s24 hero\" hero-id=\"safetyImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Safety Features</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToItem($index)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.items track by item.category\"><div flex class=\"mr-16\"><div class=\"md-title truncate-2\">\n{{::item.category}}</div><div class=\"md-subheader mt-8 truncate-3\">{{::item.notes}}</div></div><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>No Features Found for Filter!</div></div>\n</div>");
$templateCache.put("app/main/vehicle/details/specs/specs.html","<div id=\"specs\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/cartraxx/engine.svg\" class=\"s24 hero\" hero-id=\"specsImage\" aria-label=\"Cake\"></md-icon><h2 \nstyle=\"margin-left:16px\" flex md-truncate>Specs</h2></div></md-toolbar><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.specs.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nlayout=\"column\" class=\"border-bottom-grey p-16 {{spec.literalIndex % 2 == 0 ? \'md-white-bg\' : \'md-white-bg\'}}\" \nng-repeat=\"spec in vm.specs track by spec.index\"><div class=\"md-subheader-black md-truncate\">{{::spec.name}}</div><div \nclass=\"md-headline md-transparent-bg mt-8\" style=\"color : rgba(0,0,0,0.54)\"><div \nng-if=\"spec.name === \'Year\' || !isNumber(spec.item)\">{{::spec.item}}</div><div \nng-if=\"spec.name !== \'Year\' && isNumber(spec.item)\">{{::spec.item | number}}</div></div></div></div><div \nstyle=\"text-align: center\" layout=\"column\" layout-align=\"center center\" class=\"md-headline full-width-height p-32\" \nng-if=\"vm.specs.length === 0\"><div>No Specs Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/details/standard/standard.html","<div id=\"standard\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/cartraxx/details.svg\" class=\"s24 hero\" hero-id=\"standardImage\" aria-label=\"Cake\"></md-icon>\n<h2 style=\"margin-left:16px\" flex md-truncate>Details</h2></div></md-toolbar><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.standard.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToStandardItem(standard)\" \nclass=\"border-bottom-grey p-16 {{::standard.literalIndex % 2 == 0 ? \'md-white-bg\' : \'md-white-bg\'}}\" \nng-repeat=\"standard in vm.standard track by standard.index\"><div flex><div \nclass=\"md-title font-weight-500 md-truncate\">{{::standard.name}}</div><div class=\"md-subheader md-transparent-bg mt-8\">\n<div ng-if=\"standard.attributes.length > 0\">{{::standard.attributes.length | number}} items</div></div></div><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.standard.length === 0\"><div>No Details Found for Filter!</div>\n</div></div>");
$templateCache.put("app/main/vehicle/gas/input-gas/input-gas.html","<form name=\"vm.vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/gas-station_blue.svg\" class=\"s24 hero\" hero-id=\"gasImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Gas Input</h2><md-button type=\"submit\" \nng-click=\"vm.save()\" class=\"md-icon-button\" aria-label=\"Save\"><md-icon md-svg-icon=\"assets/images/cartraxx/save.svg\">\n</md-icon></md-button></div></md-toolbar><md-content class=\"position-relative\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width {{vm.calculatedMPG > 0 ? \'pb-64\' : \'\'}}\"><div class=\"position-relative\" \nlayout-align=\"start stretch\"><div class=\"border-bottom-grey p-16\"><div class=\"md-headline\">\n{{vs.getMakeModelYear(vm.vehicle)}}</div><div class=\"md-body-1 mt-24\" style=\"color: gray\">Refuel Date</div>\n<md-datepicker required name=\"date\" ng-model=\"fuel.date\"></md-datepicker><div ng-if=\"vm.vUpdates.date.$invalid\" \nng-messages=\"vm.vUpdates.date.$error\" class=\"animate-if-slide-40\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">Refuel Date is required</div><div \nng-message=\"maxdate\">Refuel Date cannot be in the future!</div></div></div><div layout=\"column\" \nclass=\"full-width md-title border-bottom-grey p-16\"><div class=\"md-headline mb-24\">Fuel Info</div><md-input-container \nclass=\"md-block mb-8\" flex><label>Gallon ($)</label><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_attach_money_black_24px.svg\"></md-icon><input autocomplete=\"off\" required \ntype=\"number\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" name=\"pricePerGallon\" ng-model=\"fuel.pricePerGallon\" \nplaceholder=\"2.49\" max=\"999.99\"><div ng-messages=\"vm.vUpdates.pricePerGallon.$error\" class=\"mb-16\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">Price per Gallon cannot be greater than $999.99</div><div \nng-message=\"required\" class=\"my-message\">Price per Gallon is required</div></div></md-input-container>\n<md-input-container class=\"md-block mb-8\" flex><label>Total Gallons</label><md-icon \nmd-svg-src=\"assets/images/cartraxx/water-can.svg\"></md-icon><input id=\"totalCost\" autocomplete=\"off\" required \ntype=\"number\" name=\"totalGallons\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" ng-model=\"fuel.totalGallons\" \nplaceholder=\"16.56\" max=\"999.999\"><div ng-messages=\"vm.vUpdates.totalGallons.$error\" class=\"mb-16\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">Total gallons cannot be more than 999 gallons</div><div \nng-message=\"required\" class=\"my-message\">Total gallons is required</div><div ng-message=\"ng-pattern\" \nclass=\"my-message\">Total gallons is incorrect</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Total ($)</label><md-icon md-svg-src=\"assets/images/cartraxx/equals.svg\"></md-icon><input \nautocomplete=\"off\" required type=\"number\" name=\"totalCost\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" \nng-model=\"fuel.totalCost\" placeholder=\"43.23\" max=\"99999\"><div ng-messages=\"vm.vUpdates.totalCost.$error\" \nclass=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">\nTotal cost cannot be more than $99,999</div><div ng-message=\"required\" class=\"my-message\">Total ($) is required</div>\n</div></md-input-container></div><div layout=\"column\" class=\"full-width border-bottom-grey p-16 pb-0\"><div \nclass=\"md-headline mb-24\">Odometer</div><md-input-container class=\"md-block mb-0 md-title\" flex-gt-sm><label>Odometer\n</label><md-icon md-svg-src=\"assets/images/cartraxx/odometer.svg\"></md-icon><input autocomplete=\"off\" required \ntype=\"number\" name=\"odometer\" ng-model=\"fuel.odometer\" placeholder=\"123,456\" max=\"9999999\"><div class=\"hint-input\" \nstyle=\"margin-left: 36px\" ng-if=\"vm.vUpdates.odometer.$valid && !(fuel.odometer === vm.getLastOdometer())\">\n{{vm.vehicle.odometer | number}} is the current odometer reading.</div><div \nng-if=\"fuel.odometer === vm.getLastOdometer() && vm.vUpdates.odometer.$valid\" style=\"margin-left: 36px\" \nclass=\"red-input\">Odometer cannot be the same</div><div ng-messages=\"vm.vUpdates.odometer.$error\" class=\"mb-16\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">Odometer cannot be more than 8 digits</div>\n<div ng-message=\"required\" class=\"my-message\">Odometer is required</div></div></md-input-container><div \nng-if=\"vm.vehicle.odometer !== fuel.odometer && vm.vUpdates.odometer.$valid\"><div \nng-if=\"fuel.odometer > 0 && fuel.odometer < vehicle.odometer\" class=\"animate-if-slide-40 pl-16\"><md-checkbox \nng-model=\"fuel.updateToThisOdometer\" class=\"mt-24\" aria-label=\"Checkbox 1\">\n{{fuel.odometer | number}} is current odometer reading?</md-checkbox></div><div \nng-if=\"fuel.odometer > vehicle.odometer\" class=\"animate-if-slide-40 pl-16 mt-24\">\n{{fuel.odometer | number}} will be the new odometer reading.</div></div><div class=\"ml-16 mr-16\" layout=\"column\"><div \nclass=\"md-title text-black mt-24 font-weight-400\">When did you last fill up?</div><md-radio-group \nclass=\"pl-24 mb-8 mt-8 pt-8 pb-8 border-top-bottom-grey\" name=\"previousgas\" required ng-model=\"selectedLastFillup\" \nng-change=\"vm.radioGroupChanged()\"><md-radio-button class=\"pt-8 pb-8 mt-0 mb-0\" ng-if=\"vm.lastFillup.odometer > 0\" \nvalue=\"LAST_FILLUP\"><div class=\"md-subheader\" ng-if=\"vm.lastFillup\"><div \nclass=\"md-body-1 {{selectedLastFillup === \'LAST_FILLUP\' ? \'is-selected\' : \'font-weight-300-grey\'}}\">Last Fillup</div>\n<div><b class=\"text-black\">Odometer : </b>{{vm.lastFillup.odometer | number}}</div><div><b class=\"text-black\">Date : \n</b>{{vm.lastFillup.date | date:\'longDate\'}}</div></div></md-radio-button><div layout=\"row\" class=\"pt-8\">\n<md-radio-button value=\"LAST_ODOMETER\"></md-radio-button><div layout=\"column\"><div \nclass=\"md-body-1 {{selectedLastFillup === \'LAST_ODOMETER\' ? \'is-selected\' : \'font-weight-300-grey\'}}\">Last Odometer\n</div><md-input-container md-no-float class=\"md-block mb-0 mt-0 no-errors-spacer-0 md-title\" flex-gt-sm><input \nautocomplete=\"off\" ng-required=\"selectedLastFillup === \'LAST_ODOMETER\'\" type=\"number\" name=\"lastOdometer\" \nplaceholder=\"123,233\" ng-model=\"vm.lastOdometer\" max=\"9999999\"><div \nng-if=\"vm.vUpdates.lastOdometer.$invalid && selectedLastFillup === \'LAST_ODOMETER\'\" \nng-messages=\"vm.vUpdates.lastOdometer.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" \nclass=\"my-message\">Odometer cannot be more than 8 digits</div><div ng-message=\"required\" class=\"my-message\">\nOdometer is required</div></div></md-input-container></div></div><md-radio-button class=\"pt-8 pb-8 mt-0 mb-0\" \nvalue=\"UNSURE\"><div class=\"md-body-1 {{selectedLastFillup === \'UNSURE\' ? \'is-selected\' : \'font-weight-300-grey\'}}\">\nUnsure</div></md-radio-button></md-radio-group><div \nng-if=\"(vm.vUpdates.previousgas.$touched || attemptedSave) && vm.vUpdates.previousgas.$invalid\" \nclass=\"md-subheader md-warn animate-if-slide-40\" role=\"alert\" multiple=\"multiple\">Previous Gas Fill Up is required\n</div></div></div><div layout=\"column\" class=\"full-width border-bottom-grey p-16\"><div class=\"md-headline mb-24\">\nDetails</div><div class=\"mt-16\"><md-input-container class=\"md-block md-title\"><label>Notes</label><textarea \nng-model=\"fuel.notes\" md-maxlength=\"300\" rows=\"3\" md-select-on-focus></textarea></md-input-container></div></div></div>\n</div><div class=\"height-64 full-width md-white-bg position-absolute md-subheader animate-if-transform\" \nstyle=\"bottom: 0px;  -webkit-box-shadow: 5px 5px 5px 5px rgba(100,100,100,.8);\n        box-shadow: 5px 5px 5px 5px rgba(100,100,100,.8); z-index: 10\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-display-1 font-weight-500 pulse animated\" \nstyle=\"color : #2196F3\">{{vm.calculatedMPG | number : 2}} <span class=\"md-headline font-color-grey\">&nbsp;mpg</span>\n</div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/gas/past/past-filter-dates.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"vm.vUpdates\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDate Range</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"pl-16 pr-8\"><div class=\"md-body-1 mt-24\" style=\"color: gray\">Start Date</div>\n<md-datepicker required name=\"dateAfter\" ng-model=\"vm.dateAfter\"></md-datepicker><div \nng-if=\"vm.vUpdates.dateAfter.$invalid\" ng-messages=\"vm.vUpdates.dateAfter.$error\" \nclass=\"animate-if-slide-40 pl-24 pr-24\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message error-message md-body-2\" style=\"color: red\">Start Date is required</div><div ng-message=\"maxdate\" \nclass=\"my-message error-message md-body-2\" style=\"color: red\">Start Date cannot be in the future!</div></div><div \nclass=\"md-body-1 mt-24\" style=\"color: gray\">End Date</div><md-datepicker required name=\"dateBefore\" \nng-model=\"vm.dateBefore\"></md-datepicker><div ng-if=\"vm.vUpdates.dateBefore.$invalid\" \nng-messages=\"vm.vUpdates.dateBefore.$error\" class=\"animate-if-slide-40 pl-24 pr-24\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">End Date is required</div><div\n ng-message=\"maxdate\" class=\"my-message error-message md-body-2\" style=\"color: red\">End Date cannot be in the future!\n</div><div ng-message=\"mindate\" class=\"my-message error-message md-body-2 full-width\" style=\"color: red\">\nEnd Date cannot be earlier than Start Date</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"ok()\">OK</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/vehicle/gas/past/past.html","<div id=\"vehicle-gas-view\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/pressure.svg\" class=\"s24 hero\" hero-id=\"pressureImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Past MPGs</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"><md-icon \ntouched-now ng-click=\"vm.filterDates()\" md-svg-src=\"assets/images/cartraxx/ic_date_range_black_24px.svg\" \nstyle=\"width : 24px; height : 24px\" class=\"s24\" aria-label=\"Cake\"></md-icon></div></md-toolbar><div \nng-if=\"vm.gasItems.length > 0\" id=\"scroll-vs-repeat\" class=\"md-white-bg scrollable\" vs-repeat><div \nng-repeat=\"gasItem in vm.gasItems track by gasItem.odometer\" class=\"repeated-item full-width border-bottom-grey\"><div \ntouched-now ng-click=\"vm.goToGasItem(gasItem.odometer)\" layout=\"row\" layout-align=\"center center\" \nclass=\"p-16 height-120 full-width\"><div class=\"full-width\" layout=\"column\" layout-align=\"center start\"><div \nng-if=\"gasItem.estimatedMPG > 0\" class=\"full-width height-40 md-white-bg position-relative\"><div layout=\"row\" \nclass=\"full-height-width position-absolute\"><div class=\"md-blue-200-bg full-height\" ng-style=\"vm.getWidthMPG(gasItem)\">\n</div><div class=\"height-40 width-40 arrow-left-blue\"></div></div><div layout=\"column\" class=\"full-height-width\" \nlayout-align=\"center center\"><div layout=\"row\" layout-align=\"center end\"><div class=\"md-headline z-index-0\">\n{{gasItem.estimatedMPG | number : 2}}</div><div class=\"md-subheader font-weight-400 mb-5 md-transparent-bg\">&nbsp;mpg\n</div></div></div></div><div layout=\"row\" layout-align=\"space-around center\" class=\"full-width mt-16\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-subheader font-weight-300\" style=\"font-size: 15px\">Odometer\n</div><div class=\"md-subheader-black mt-4\">{{gasItem.odometer | number}}</div></div><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"md-subheader font-weight-300\" style=\"font-size: 15px\">Date</div><div \nclass=\"md-subheader-black mt-4\">{{gasItem.date | date : \"MM\'/\'dd\'/\'yy \'at\' h:mma\"}}</div></div></div></div></div></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height md-white-bg p-32\" ng-if=\"vm.gasItems.length === 0\"><div>\nNo Past Fill-Ups Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/gas/view/gas-overview.html","<form name=\"vUpdates\" id=\"vehicle-gas-view\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/gasoline-station-green.svg\" class=\"s24 hero\" \nhero-id=\"gasOverviewImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Gas Overview</h2>\n</div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div ng-if=\"vm.vehicle.estimatedMPG.newMPG > 0\" layout=\"column\" \nclass=\"border-bottom-grey p-16\" layout-align=\"start center\"><div ng-if=\"vm.vehicle.estimatedMPG.newMPG\" \nclass=\"md-subheader font-weight-500 transparent\"><span class=\"md-display-2 transparent\">\n{{::vm.vehicle.estimatedMPG.newMPG | number : 2}}</span> &nbsp;mpg</div><div class=\"md-title\">Trending<span><md-icon \nmd-svg-src=\"{{::vm.estimatedImage}}\" class=\"s24 ml-4\"></md-icon></span></div><div layout=\"row\" class=\"mt-32 mb-16\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/co2_cloud.svg\" class=\"width-48 height-48 m-0\" \naria-label=\"Cake\"></md-icon><div class=\"md-title ml-8\">{{::vm.vehicle.estimatedMPG.newCOOperGallon | number : 2}}</div>\n<div class=\"md-subheader font-weight-400\">&nbsp;kg CO<span class=\"squared font-weight-400 mt-0\">2</span> per mile!\n</div></div></div><div layout=\"row\" touched-now ng-click=\"vm.pastFillUps()\" \nclass=\"md-headline position-relative border-bottom-grey p-16\"><md-icon class=\"s24 m-0 mr-16 center-vertical\" \nmd-svg-src=\"assets/images/cartraxx/pressure.svg\" class=\"hero\" hero-id=\"pressureImage\"></md-icon>View Past Fill-Ups\n</div><div class=\"border-bottom-grey p-16 full-width\"><div class=\"md-title\">What now?</div><div \nclass=\"md-subheader font-weight-400 mb-16\">Here\'s a few things to increase your MPG!</div><div touched-now \nlayout=\"row\" class=\"p-16\" layout-align=\"start center\" ng-repeat=\"item in ::vm.whatNowList track by $index\"><div \nstyle=\"color : white\" layout=\"column\" class=\"width-32 height-32 mr-16 md-title {{::vm.getClassCircle($index)}}\" \nlayout-align=\"center center\"><div>{{$index + 1}}</div></div><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"md-subheader-black transparent\">{{::item.title}}</div><div ng-if=\"item.description\" \nclass=\"md-subheader mt-8 transparent font-weight-300 truncate-2\">{{::item.description}}</div></div></div></div><div \nng-if=\"vm.vehicle.formattedJson[\'46\'] && vm.vehicle.formattedJson[\'47\']\" class=\"border-bottom-grey p-16 full-width\">\n<div class=\"md-title\">Manufacturer MPG rating</div><div class=\"md-headline mt-16\" layout=\"column\" \nlayout-align=\"center center\"><div><div>{{::vm.vehicle.formattedJson[\'46\'].item}}<span class=\"font-weight-300-grey\">\n&nbsp;city</span></div><div class=\"height-2 md-black-500-bg mt-8 mb-8\" style=\"width : calc(100% - 32px)\"></div><div>\n{{::vm.vehicle.formattedJson[\'47\'].item}}<span class=\"font-weight-300-grey\">&nbsp;highway</span></div></div></div>\n</div><div class=\"border-bottom-grey full-width\"><div class=\"md-title p-16\">Past Performance</div>\n<md-virtual-repeat-container id=\"virtual-container\" class=\"full-width height-180 mt-16 mb-16\" md-orient-horizontal><div\n id=\"virtual-container_{{item.odometer}}\" ng-click=\"vm.goToGasItem(item.odometer)\" \nmd-virtual-repeat=\"item in ::vm.gasItems\" class=\"repeated-item width-80 height-180\"><div class=\"full-height-width\" \ntouched-now layout=\"column\"><div class=\"height-120 md-blue-500-bg\" layout=\"row\"><div class=\"md-white-bg\" \nstyle=\"width : 40%\"></div><div class=\"md-white-bg\" style=\"width : 20%\" ng-style=\"vm.getHeightItem(item)\"></div><div \nclass=\"md-white-bg\" style=\"width : 40%\"></div></div><div class=\"height-50\" layout=\"column\" \nlayout-align=\"center center\"><div style=\"font-weight : 300\">{{item.estimatedMPG | number : 2}}</div><div \nstyle=\"color : grey\">mpg</div></div></div></div></md-virtual-repeat-container></div></div></md-content></form>");
$templateCache.put("app/main/vehicle/image/editor/image-editor.html","<form name=\"vUpdates\" id=\"vehicle-image\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-content \nclass=\"position-relative full-width md-black-500-bg\" flex=\"grow\" layout=\"column\" layout-align=\"center center\"><img-crop\n image=\"myImage\" result-image=\"myCroppedImage\" area-type=\"square\" class=\"full-width-height\"></img-crop><progress-view \nng-if=\"vm.loading\"></progress-view><md-icon md-svg-src=\"assets/images/cartraxx/ic_close_white_24px.svg\" \nclass=\"s24 position-absolute\" style=\"top: 16px; left : 16px\" ng-click=\"vm.goBack()\" aria-label=\"Cake\"></md-icon>\n</md-content></form>");
$templateCache.put("app/main/vehicle/maintenance/input-maintenance/input-maintenance.html","<form name=\"vUpdates\" id=\"vehicle-maintenance-input\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><img src=\"assets/images/cartraxx/car-repair_plus.png\" class=\"width-24 height-24 hero\" \nhero-id=\"maintenanceImage\" aria-label=\"Cake\"><h2 style=\"margin-left:16px\" flex md-truncate>Maintenance Input</h2>\n<md-button type=\"submit\" ng-click=\"vm.submit()\" class=\"md-icon-button\" aria-label=\"Save\"><md-icon \nmd-svg-icon=\"assets/images/cartraxx/save.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div class=\"position-relative border-bottom-grey p-16\" \nlayout-align=\"start stretch\"><div class=\"md-headline mt-16\"><md-autocomplete flex required \nmd-input-name=\"autocompleteField\" md-input-minlength=\"0\" md-input-maxlength=\"30\" md-no-cache=\"true\" \nmd-selected-item=\"m.actionItem\" md-search-text=\"maintenanceItemSearch\" \nmd-items=\"maintenanceItem in vm.querySearch(maintenanceItemSearch)\" \nmd-item-text=\"maintenanceItem.action + \' \' + maintenanceItem.item\" md-require-match \nmd-floating-label=\"Maintenance Item\" md-selected-item-change=\"vm.selectedItemChange(maintenanceItem)\">\n<md-item-template><span md-highlight-text=\"maintenanceItemSearch\">{{maintenanceItem.action}} {{maintenanceItem.item}}\n</span></md-item-template><div ng-messages=\"vUpdates.autocompleteField.$error\" \nng-if=\"vUpdates.autocompleteField.$touched\"><div ng-message=\"required\">You <b>must</b> have a Maintenance Item</div>\n<div ng-message=\"md-require-match\">Please select an existing Maintenance Item.</div><div ng-message=\"minlength\">\nYour entry is not long enough.</div><div ng-message=\"maxlength\">Your entry is too long.</div></div></md-autocomplete>\n</div><div ng-if=\"m.actionItem\" class=\"animate-if-slide-400\"><div class=\"md-body-1\" style=\"color: gray\">Completed Date\n</div><md-datepicker required name=\"date\" ng-model=\"m.dateCompleted\"></md-datepicker><div \nng-if=\"vUpdates.date.$invalid\" ng-messages=\"vUpdates.date.$error\" class=\"animate-if-slide-40\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">\nDate is required</div><div ng-message=\"maxdate\">Date cannot be in the future!</div></div><md-input-container \nclass=\"md-block md-title mb-0 mt-40\" flex-gt-sm><label>Odometer</label><input autocomplete=\"off\" required \ntype=\"number\" name=\"odometer\" ng-model=\"m.odometerAtCompletion\" placeholder=\"123,456\" max=\"9999999\"><div \nclass=\"hint-input\" ng-if=\"vUpdates.odometer.$valid\">{{vm.vehicle.odometer | number}} is the current odometer reading.\n</div><div ng-messages=\"vUpdates.odometer.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" \nclass=\"my-message\">Odometer cannot be more than 8 digits</div><div ng-message=\"required\" class=\"my-message\">\nOdometer is required</div></div></md-input-container><div \nng-if=\"vm.vehicle.odometer !== m.odometerAtCompletion && vUpdates.odometer.$valid\"><div \nng-if=\"m.odometerAtCompletion > 0 && m.odometerAtCompletion < vehicle.odometer\" class=\"animate-if position-absolute\">\n<md-checkbox ng-model=\"m.updateToThisOdometer\" aria-label=\"Checkbox 1\">\n{{m.odometerAtCompletion | number}} is current odometer reading?</md-checkbox></div><div \nng-if=\"m.odometerAtCompletion > vehicle.odometer\" class=\"animate-if position-absolute\">\n{{m.odometerAtCompletion | number}} will be the new odometer reading.</div></div><div class=\"mt-24\"><md-input-container\n class=\"md-block md-title\"><label>Notes</label><textarea ng-model=\"m.notes\" md-maxlength=\"300\" rows=\"3\" \nmd-select-on-focus></textarea></md-input-container></div></div></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/recalls/recall/recall.html","<div id=\"recall\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"{{::vs.getOpenRecallsImage(vm.recallItem)}}\" class=\"s24\" aria-label=\"Cake\"></md-icon><h2 \nstyle=\"margin-left:16px\" flex md-truncate>Recall {{::vm.recallItem.recallNumber}}</h2></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div class=\"border-bottom-grey p-16\"><div class=\"md-headline mt-16\">\n{{::vm.recallItem.subject}}</div><div layout=\"row\" class=\"mt-16\" layout-align=\"start start\"><md-icon \nmd-svg-src=\"{{::vm.getImage(vm.recallItem.isOpenRecall)}}\" class=\"width-16 height-16 m-0\" aria-label=\"Cake\"></md-icon>\n<div class=\"md-subheader-content ml-8 md-truncate\" style=\"font-weight: 600; text-align:center\" \nng-style=\"::vm.textColor(vm.recallItem.isOpenRecall)\">{{::vm.recallItem.recallStatus}}</div></div><div \nclass=\"md-body-1 mt-16\">{{::vm.recallItem.summary}}</div><div class=\"md-subheader-black mt-16\">\nIssued : {{::vm.recallItem.reportReceivedDate | date:\'longDate\'}}</div><div class=\"md-body-1 mt-16\">\n{{::vm.recallItem.consequence}}</div><div class=\"md-body-1 mt-16\">{{::vm.recallItem.correctiveAction}}</div><div \nclass=\"md-subheader-black mt-16\">NHTSA Recall : {{::vm.recallItem.nhtsaCampaignNumber}}</div><div \nclass=\"md-subheader-black mt-8\">Manufacturer Recall : {{::vm.recallItem.mfrCampaignNumber}}</div></div><div \nng-if=\"vm.recallItem.associatedProducts.length < 0\" class=\"border-bottom-grey p-16\"><div class=\"md-headline\">\nAffected Vehicles</div><div class=\"md-subheader-black mt-32\">\nNumber of Vehicles : {{::vm.recallItem.potentialNumberOfUnitsAffected | number}}</div><div class=\"mt-32\"><md-card \nclass=\"mt-8 ml-16 p-16\" ng-repeat=\"product in ::vm.recallItem.associatedProducts track by $index\"><div \nclass=\"md-body-1\">{{::product.productMake}} {{::product.productModel}} {{::product.productYear}}</div><div \nclass=\"md-body-1 mt-4\">{{::product.productionDates}}</div></md-card></div></div><div \nng-if=\"vm.recallItem.associatedDocuments.length < 0\" class=\"border-bottom-grey p-16\"><div class=\"md-headline\">\nAssociated Documents</div><div class=\"md-subheader-black mt-32\">\nNumber of Associated Documents : {{::vm.recallItem.associatedDocuments.length | number}}</div><div class=\"mt-32\">\n<md-card class=\"mt-8 ml-16 p-16\" ng-repeat=\"doc in ::vm.recallItem.associatedDocuments track by $index\"><div \nclass=\"md-body-1\">{{::doc.summary}}</div><div class=\"md-subheader\">{{::(doc.fileSize / 1000) | number}} KB</div>\n</md-card></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/vehicle/maintenance/item/item.html","<div id=\"recall\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><h2 flex \nmd-truncate>{{::vm.mi.action}} {{::vm.mi.item}}</h2><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin \nmd-svg-icon=\"assets/images/cartraxx/ic_more_vert_black_24px.svg\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.inputMaintenance()\"><md-icon md-svg-icon=\"assets/images/cartraxx/plus.svg\" \nmd-menu-align-target></md-icon>Add Repair</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item>\n<md-button ng-click=\"vm.inputMaintenance()\"><md-icon md-svg-icon=\"assets/images/cartraxx/edit.svg\" \nmd-menu-align-target></md-icon>Edit Labor Rate ($)</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div class=\"border-bottom-grey p-16\"><div class=\"md-headline mt-4\">\n{{::vm.mi.action}} {{::vm.mi.item}}</div><div \nng-if=\"vm.mi.laborUnits > 0 && vm.mi.partUnits > 0 && vm.mi.partCostPerUnit\"><div flex \nclass=\"centered md-display-1 text-center text-bold mt-16\">\n${{::vm.getCost(-1) | number : 0}} - ${{::vm.getCost(1) | number : 0}}</div><div \nclass=\"height-20 mt-24 position-relative\" flex><div ng-if=\"vm.animate\" \nclass=\"md-red-200-bg position-absolute full-width-height animate-slide-right\"></div><div ng-if=\"vm.animate\" \nng-style=\"{{vm.getWidth()}}\" class=\"md-blue-200-bg position-absolute full-height animate-slide-right\"></div><div \nstyle=\"left: -16px\" class=\"full-height width-16 position-absolute md-white-bg\"></div></div><div layout=\"row\" \nclass=\"mt-8\" layout-align=\"center center\"><div class=\"mr-8 md-blue-200-bg\" style=\"height: 10px\" flex=\"10\"></div><div \nclass=\"\">Labor :&nbsp;</div><div class=\"text-bold\">\n${{::vm.getLabor(-1) | number : 0}} - ${{::vm.getLabor(1) | number : 0}}</div><div class=\"mr-8 ml-16 md-red-200-bg\" \nstyle=\"height: 10px\" flex=\"10\"></div><div class=\"\">Parts :&nbsp;</div><div class=\"text-bold\">\n${{::vm.mi.partUnits * vm.mi.partCostPerUnit | number:0}}</div></div></div><div class=\"mt-24\"><div class=\"md-headline\" \nng-if=\"vm.mi.nextDueOdomoter\" ng-style=\"vm.textColor(vm.mi)\">{{::vm.dueMileage(vm.mi)}}</div><div class=\"md-headline\" \nng-if=\"vm.mi.nextDueDate\" ng-style=\"vm.textColor(vm.mi)\">{{::vm.dueInTime(vm.mi)}}</div><md-progress-linear \nmd-theme=\"{{::vm.mi.duePercentage > 1 ? \'orangeTheme\' : \'greenTheme\'}}\" class=\"md-green-bg mt-8\" md-mode=\"determinate\" \nvalue=\"{{::vm.mi.duePercentage * 100}}\"></md-progress-linear></div><div class=\"md-body-1 mt-32\">\n{{::vm.mi.itemDescription}}</div><div ng-if=\"vm.mi.note1\" class=\"md-body-1 mt-16\"><span \nstyle=\"font-weight : 600; color : black\">Note* :</span> {{::vm.mi.note1}}</div><div class=\"mt-16\" \nstyle=\"margin-left: -8px\"><md-button ng-click=\"vm.inputMaintenance()\" class=\"md-raised md-primary\"><div layout=\"row\">\n<div>Add Repair</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/cartraxx/ic_add_circle_outline_white_24px.svg\"></md-icon></div></md-button></div><div \nclass=\"md-headline\" ng-if=\"vm.hasCompletedMaintenance()\"><div class=\"border-bottom-grey pt-16 pb-16\">Past Repairs</div>\n<div class=\"border-bottom-grey p-16\" ng-repeat=\"(key, item) in vm.mi.completedMaintenance\"><div layout=\"row\"><div \nclass=\"md-subheader\">Date :&nbsp;</div><div class=\"md-subheader-black\">{{::item.dateCompleted | date:\'mediumDate\' }}\n</div></div><div class=\"mt-8\" layout=\"row\"><div class=\"md-subheader\">Odometer :&nbsp;</div><div \nclass=\"md-subheader-black\">{{::item.odometerAtCompletion | number }}</div></div></div></div><div \nng-if=\"vm.mi.intervalMileage || vm.mi.intervalMonth\" class=\"md-body-1 mt-32\" style=\"font-weight : 600; color : black\">\n{{::vm.mi.action}} every...</div><div ng-if=\"vm.mi.intervalMileage\" class=\"md-body-1 ml-16\">\n{{::vm.mi.intervalMileage | number}} Miles</div><div ng-if=\"vm.mi.intervalMonth\" class=\"md-body-1 ml-16\">\n{{::vm.mi.intervalMonth | number}} Months</div><div \nng-if=\"vm.mi.laborUnits || vm.mi.partUnits || vm.mi.partCostPerUnit\" class=\"mt-32\"><div ng-if=\"vm.mi.laborUnits\" \nclass=\"md-subheader-black mt-8\">Estimated Hours : {{::vm.mi.laborUnits}}</div><div ng-if=\"vm.mi.partUnits\" \nclass=\"md-subheader-black mt-8\">Parts Count Needed : {{::vm.mi.partUnits}}</div><div ng-if=\"vm.mi.partCostPerUnit\" \nclass=\"md-subheader-black mt-8\">Cost Per Part : {{::vm.mi.partCostPerUnit | currency}}</div></div></div></div>\n<progress-view ng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/settings/generic/generic-toolbar/generic-toolbar.html","<md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-svg-icon=\"assets/images/cartraxx/ic_more_vert_black_24px.svg\"></md-icon></md-button>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/vehicle/details/bulletins/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/sticky-note.svg\" class=\"s24 hero\" \nhero-id=\"bulletinsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{::vm.item.bulletinNumber}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nlayout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"md-title\">\n{{::vm.item.bulletinDate | date : \'MMM dd, yyyy\'}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8\">{{::vm.item.summaryText}}</div><div \nng-if=\"vm.item.bulletinNumber\" class=\"mt-24\"><div class=\"md-title\">Bulletin Number</div><div \nclass=\"md-subheader ml-16 mt-8\">{{::vm.item.bulletinNumber}}</div></div><div ng-if=\"vm.item.nhtsaItemNumber\" \nclass=\"mt-24\"><div class=\"md-title\">NHTSA Number</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.item.nhtsaItemNumber}}</div></div></div><div class=\"md-headline border-bottom-grey md-grey-100-bg p-8\">\nComponents</div><div layout=\"column\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in ::vm.compDescriptions track by $index\"><div class=\"md-subheader-black\">{{::item}}</div></div></div>\n</div>");
$templateCache.put("app/main/vehicle/details/complaints/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/failed-chat.svg\" class=\"s24 hero\" \nhero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\nComplaint - {{vm.complaintItem.nhtsaIdNumber}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height md-white-bg scrollable\"><div class=\"border-bottom-grey p-16 pb-24\"><div class=\"md-title\">\nNHTSA ID : {{vm.complaintItem.nhtsaIdNumber}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.complaintItem.description}}</div><div \nclass=\"mt-32\"><div class=\"md-title\">Date Filed</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.complaintItem.dateFiled | date : \"MMMM dd, yyyy \'at\' h:mma\"}}</div></div><div class=\"mt-32\"><div \nclass=\"md-title\">Date of Incident</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.complaintItem.dateOfIncident | date : \"MMMM dd, yyyy \'at\' h:mma\"}}</div></div><div class=\"mt-32\"><div \nclass=\"md-title\">Consumer Location</div><div class=\"md-subheader ml-16 mt-8\">{{::vm.complaintItem.consumerLocation}}\n</div></div></div><div ng-if=\"vm.complaintItem.components.length > 0\" class=\"border-bottom-grey p-16 pb-24\"><div \nclass=\"md-title\">Components</div><div class=\"mt-8 ml-16 md-subheader\" \nng-repeat=\"comp in vm.complaintItem.components track by comp.id\">{{comp.description}}</div></div><div \nclass=\"border-bottom-grey p-16 pl-32 pb-24\"><div class=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">\n{{vm.complaintItem.crash ? \'YES\' : \'NO\'}} <span class=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Crash\n</span></div><div class=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">\n{{vm.complaintItem.fire ? \'YES\' : \'NO\'}} <span class=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Fire</span>\n</div><div class=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">{{vm.complaintItem.numberOfDeaths | number}} \n<span class=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Deaths</span></div><div \nclass=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">{{vm.complaintItem.numberOfInjuries | number}} <span \nclass=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Injuries</span></div></div></div><div \nstyle=\"text-align: center\" layout=\"column\" layout-align=\"center center\" class=\"md-headline full-width-height p-32\" \nng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/details/crash/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/dummy.svg\" class=\"s24 hero\" hero-id=\"crashImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{vm.crashRating.display}}</h2></div>\n</md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height md-white-bg scrollable\"><div layout=\"row\" \nclass=\"border-bottom-grey md-white-bg p-16\" ng-repeat=\"item in ::vm.crashRating.ratings track by item.position\"><div \nflex class=\"mr-16\"><div class=\"md-title truncate-1\">{{item.display}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{item.notes}}</div><div layout=\"row\"><div \nclass=\"mr-8\" ng-repeat=\"star in ::vm.ratingArray(item) track by $index\"><md-icon ng-if=\"star\" \nmd-svg-src=\"assets/images/cartraxx/star.svg\" class=\"s24 hero\" hero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon>\n<md-icon ng-if=\"!star\" md-svg-src=\"assets/images/cartraxx/star_outline.svg\" class=\"s24 hero\" hero-id=\"complaintsImage\" \naria-label=\"Cake\"></md-icon></div></div><div class=\"md-subheader mt-8\">{{item.rating}} / 5 Rating</div><div \nng-if=\"item.possibility || item.tip || item.safetyConcerns\" class=\"mt-24\"><div ng-if=\" item.possibility \" \nclass=\"md-subheader-black font-weight-300 mt-16\"><b>Possibility :</b> {{::(item.possibility * 100) | number : 2}}%\n</div><div ng-if=\"item.tip \" class=\"md-subheader-black font-weight-300 mt-16\"><b>Tip :</b> {{::item.tip}}</div><div \nng-if=\"item.safetyConcerns \" class=\"md-subheader-black font-weight-300 line-height-20 mt-8\" style=\"color : red\">\n{{item.safetyConcerns}}</div></div></div></div></div><div style=\"text-align: center\" layout=\"column \" \nlayout-align=\"center center \" class=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length===0 \"><div>\nNo Specs Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/details/investigations/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/microscope.svg\" class=\"s24 hero\" \nhero-id=\"investigationsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{vm.investigationsItem.subject}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height md-white-bg scrollable\"><div layout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div \nclass=\"md-headline\">NHTSA ID - <span class=\"font-weight-400\">{{vm.investigationsItem.nhtsaActionNumber}}</span></div>\n<div class=\"md-title mt-24\">{{vm.investigationsItem.subject}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{vm.investigationsItem.summary}}</div></div><div \nlayout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"\"><div class=\"md-title\">Date Opened</div><div \nclass=\"md-subheader ml-16 mt-8\">{{::vm.investigationsItem.dateOpened | date : \"MMMM dd, yyyy\"}}</div></div><div \nclass=\"mt-32\"><div class=\"md-title\">Date Closed</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.investigationsItem.dateClosed | date : \"MMMM dd, yyyy\"}}</div></div></div><div \nng-if=\"vm.investigationsItem.recalls\"><div layout=\"row\" touched-now ng-click=\"vm.goToRecall(item)\" \nclass=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.investigationsItem.recalls track by item.nhtsaCampaignNumber\"><div flex class=\"mr-16\"><div \nclass=\"md-title truncate-1\">Recall - {{item.nhtsaCampaignNumber}}</div><div class=\"md-subheader mt-8 truncate-3\">\n{{item.subject}}</div></div><md-icon md-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" \naria-label=\"Cake\"></md-icon></div></div></div><div style=\"text-align: center\" layout=\"column \" \nlayout-align=\"center center \" class=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length===0 \"><div>\nNo Specs Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/details/man_comms/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/comms.svg\" class=\"s24 hero\" hero-id=\"manCommsImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\nCommunication - {{vm.commItem.manufacturerCommunicationNumber}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\"><div class=\"border-bottom-grey p-16 md-white-bg pb-24\"><div class=\"md-title\">\nCommunication ID : {{vm.commItem.manufacturerCommunicationNumber}}</div><div class=\"md-title mt-8\">\nNHTSA ID : {{vm.commItem.nhtsaIdNumber}}</div><div ng-if=\"vm.commItem.subject\" \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.commItem.subject}}</div><div \nng-if=\"vm.commItem.summary\" class=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.commItem.summary}}\n</div><div class=\"mt-32\"><div class=\"md-title\">Date Communicated</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.commItem.communicationDate | date : \"MMMM dd, yyyy\"}}</div></div></div><div \nng-if=\"vm.commItem.components.length > 0\" class=\"border-bottom-grey md-white-bg p-16 pb-24\"><div class=\"md-title\">\nComponents</div><div class=\"mt-8 ml-16 md-subheader\" ng-repeat=\"comp in vm.commItem.components track by comp.id\">\n{{comp.description}}</div></div></div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div>\n</div></div>");
$templateCache.put("app/main/vehicle/details/options/items/items.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back>\n<md-icon md-svg-src=\"assets/images/cartraxx/bullet-list.svg\" class=\"s24 hero\" hero-id=\"optionsImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{vm.option.category}}</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.optionItems.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nlayout=\"row\" touched-now ng-click=\"vm.goToOptionItem(item)\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.optionItems track by item.id\"><div flex class=\"mr-16\"><div class=\"md-subheader-black truncate-2\">\n{{item.name}}</div><div class=\"md-subheader mt-8 truncate-3\">{{item.description}}</div><div \nng-if=\"item.price.baseMSRP > 0\" class=\"md-headline mt-8\" style=\"color : blue\">${{item.price.baseMSRP | number}}</div>\n</div><md-icon md-svg-src=\"assets/images/cartraxx/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\">\n</md-icon></div></div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div>\n</div></div>");
$templateCache.put("app/main/vehicle/details/rec_features/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/like.svg\" class=\"s24 hero\" hero-id=\"recFeaturesImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{::vm.item.label}}</h2></div></md-toolbar>\n<div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div layout=\"column\" \nclass=\"border-bottom-grey md-white-bg p-16\"><div class=\"md-title\">{{::vm.item.label}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{::vm.item.description}}</div></div></div></div>");
$templateCache.put("app/main/vehicle/details/safety_features/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/seatbelt.svg\" class=\"s24 hero\" hero-id=\"safetyImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{::vm.item.category}}</h2></div>\n</md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div layout=\"column\" \nclass=\"border-bottom-grey md-white-bg p-16\"><div class=\"md-title\">{{::vm.item.category}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{::vm.item.notes}}</div></div><div \nclass=\"md-headline border-bottom-grey md-grey-100-bg p-8\">Features</div><div layout=\"column\" \nclass=\"border-bottom-grey md-white-bg p-16\" ng-repeat=\"item in vm.item.features track by item.label\"><div \nclass=\"md-title\">{{::item.label}}</div><div ng-if=\"item.notes\" \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8\">{{::item.notes}}</div><div ng-if=\"item.value\" \nclass=\"md-subheader line-height-20 mt-8\">{{::item.value}}</div></div></div></div>");
$templateCache.put("app/main/vehicle/details/standard/standard-item/standard-item.html","<div id=\"standard\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/cartraxx/details.svg\" class=\"s24 hero\" hero-id=\"standardImage\" aria-label=\"Cake\"></md-icon>\n<h2 style=\"margin-left:16px\" flex md-truncate>{{::vm.standard.name}}</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/cartraxx/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.attributes.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"column\" class=\"border-bottom-grey p-16 {{::standard.literalIndex % 2 == 0 ? \'md-white-bg\' : \'md-white-bg\'}}\" \nng-repeat=\"standard in vm.attributes track by standard.index\"><div class=\"md-title font-weight-500 md-truncate\">\n{{::standard.name}}</div><div class=\"md-subheader md-transparent-bg mt-8\"><div>{{::standard.value}}</div></div></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.attributes.length === 0\"><div>No Details Found for Filter!</div>\n</div></div>");
$templateCache.put("app/main/vehicle/gas/past/item/past-item.html","<form name=\"vUpdates\" id=\"vehicle-gas-view\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><go-back>\n</go-back><md-icon md-svg-src=\"assets/images/cartraxx/speedometer.svg\" class=\"s24 hero\" hero-id=\"speedomoterImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>MPG at <span \nstyle=\"color : #000000; font-weight : 300\">{{vm.gasItem.odometer | number}}</span>&nbsp;miles</h2></div></md-toolbar>\n<md-content class=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div ng-if=\"vm.gasItem.estimatedMPG > 0\" layout=\"column\" \nclass=\"border-bottom-grey p-16\" layout-align=\"start center\"><div ng-if=\"vm.vehicle.estimatedMPG.newMPG\" \nclass=\"md-subheader font-weight-500 transparent\"><span class=\"md-display-2 transparent\">\n{{::vm.gasItem.estimatedMPG | number : 2}}</span> &nbsp;mpg</div><div layout=\"row\" class=\"mt-24 mb-16\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/cartraxx/co2_cloud.svg\" class=\"width-48 height-48 m-0\" \naria-label=\"Cake\"></md-icon><div class=\"md-title ml-8\">\n{{::(vm.mEstimatedCOOperGallon / vm.gasItem.estimatedMPG) | number : 2}}</div><div \nclass=\"md-subheader font-weight-400 mt-8\">&nbsp;kg per mile!</div></div></div><div class=\"border-bottom-grey p-16\"><div\n class=\"md-headline mb-24\">Gas</div><div class=\"md-subheader\">Price per gallon</div><div \nclass=\"md-headline font-weight-300 ml-8 mt-4\">{{::vm.gasItem.pricePerGallon | currency}}</div><div \nclass=\"md-subheader mt-16\">Total gallons</div><div class=\"md-headline font-weight-300 ml-8 mt-4\">\n{{::vm.gasItem.totalGallons | number : 2}}</div><div class=\"md-subheader mt-16\">Total cost</div><div \nclass=\"md-headline font-weight-300 ml-8 mt-4\">{{::vm.gasItem.totalCost | currency}}</div></div><div \nclass=\"border-bottom-grey p-16\"><div class=\"md-headline mb-24\">Details</div><div class=\"md-subheader\">\nOdometer at reading</div><div class=\"md-headline font-weight-300 ml-8 mt-4\">{{::vm.gasItem.odometer | number : 0}}\n</div><div class=\"md-subheader mt-16\">Date recorded</div><div class=\"md-headline font-weight-300 ml-8 mt-4\">\n{{::vm.gasItem.date | date : \"MMMM dd, yyyy \'at\' h:mma\"}}</div></div></div></md-content></form>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/vehicle/details/options/items/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/cartraxx/bullet-list.svg\" class=\"s24 hero\" \nhero-id=\"optionsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{vm.optionItem.name}}\n</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height md-white-bg scrollable p-16\"><div \nclass=\"md-title\">{{vm.optionItem.name}}</div><div class=\"md-subheader-black font-weight-300 line-height-20 mt-24\">\n{{vm.optionItem.description}}</div><div class=\"mt-32\" ng-if=\"vm.optionItem.manufactureOptionCode\"><div \nclass=\"md-subheader-black\">Manufacture Option Code</div><div class=\"md-subheader ml-16 mt-8\">\n{{vm.optionItem.manufactureOptionCode}}</div></div><div class=\"mt-32\" ng-if=\"vm.optionItem.price.baseMSRP > 0\"><div \nclass=\"md-subheader-black\">Item MSRP</div><div class=\"md-headline mt-4\" style=\"color : blue\">\n${{vm.optionItem.price.baseMSRP | number}}</div></div><div class=\"mt-32\" ng-if=\"vm.optionItem.price.baseInvoice > 0\">\n<div class=\"md-subheader-black\">Item Invoice</div><div class=\"md-headline mt-4\" style=\"color : blue\">\n${{vm.optionItem.price.baseInvoice | number}}</div></div></div><div style=\"text-align: center\" layout=\"column\" \nlayout-align=\"center center\" class=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length === 0\"><div>\nNo Specs Found for Filter!</div></div></div>");}]);